import { IGroupedOption } from "./LookupWithGroupsData";

interface IMedication {
  medicationName?: string;
  numberTaken?: string;
  frequency?: string;
  dosageKnown?: string;
  dosage?: string;
  dosageUnit?: string;
  forConditionType?: string;
  startDate?: string;
  stillTakeMedication?: string;
  endDate?: string;
}

export type { IMedication };

const allMedications = [
  {
    value: "102319",
    label: "(2-benzhydryloxyethyl)diethyl-methylammonium iodide",
  },
  { value: "102320", label: "2-(4-chlorphenoxy)-ethanol" },
  { value: "102321", label: "4-dimethylaminophenol" },
  { value: "102322", label: "5FU" },
  { value: "102323", label: "aaa" },
  { value: "100004", label: "AAA Spray" },
  { value: "198", label: "Abacavir" },
  { value: "102324", label: "abarelix" },
  { value: "102325", label: "Abasaglar" },
  { value: "100005", label: "Abatacept" },
  { value: "100006", label: "Abciximab" },
  { value: "100007", label: "Abelcet" },
  { value: "102326", label: "abelset" },
  { value: "102327", label: "abemaciclib" },
  { value: "102328", label: "abetimus" },
  { value: "100008", label: "Abilify" },
  { value: "199", label: "Abiraterone" },
  { value: "102329", label: "ablecet" },
  { value: "100009", label: "Abraxane" },
  { value: "102330", label: "Abrocitinib" },
  { value: "102331", label: "absorbable gelatin sponge" },
  { value: "100010", label: "Abstral" },
  { value: "102332", label: "acadesine" },
  { value: "102333", label: "acalabrutinib" },
  { value: "200", label: "Acamprosate" },
  { value: "201", label: "Acarbose" },
  { value: "100011", label: "Accolate" },
  { value: "202", label: "Accupril" },
  { value: "100012", label: "Accupro" },
  { value: "100013", label: "Accuretic" },
  { value: "100014", label: "ACE inhibitor - Other" },
  { value: "102334", label: "acea" },
  { value: "100015", label: "Acea Gel" },
  { value: "203", label: "Acebutolol" },
  { value: "102335", label: "acebutolol and thiazides" },
  {
    value: "102336",
    label: "Acebutolol with hydrochlorothiazide 200mg/12.5mg",
  },
  { value: "102337", label: "aceclidine" },
  { value: "102338", label: "aceclidine, combinations" },
  { value: "100016", label: "Aceclofenac" },
  { value: "102339", label: "acefylline piperazine" },
  { value: "204", label: "Acemetacin" },
  { value: "205", label: "Acenocoumarol" },
  { value: "102340", label: "Acepril" },
  { value: "102341", label: "acepromazine" },
  { value: "102342", label: "acetarsol" },
  { value: "100017", label: "Acetazolamide" },
  { value: "102343", label: "acetic" },
  { value: "100018", label: "Acetic acid" },
  { value: "102344", label: "acetohexamide" },
  { value: "102345", label: "acetohydroxamic acid" },
  { value: "102346", label: "acetophenazine" },
  { value: "102347", label: "acetoxolone" },
  { value: "102348", label: "acetrizoic acid" },
  { value: "102349", label: "acetylcarnitine" },
  { value: "100019", label: "Acetylcholine" },
  { value: "206", label: "Acetylcysteine" },
  { value: "102350", label: "acetyldigitoxin" },
  { value: "102351", label: "acetyldigoxin" },
  { value: "102352", label: "acetyldigoxin, combinations" },
  { value: "102353", label: "acetyldihydrocodeine" },
  { value: "102354", label: "acetylglycinamide chloral hydrate" },
  { value: "102355", label: "acetylleucine" },
  { value: "102356", label: "acetylsalicylic" },
  { value: "100020", label: "Acetylsalicylic Acid" },
  { value: "102357", label: "acetylsalicylic acid and corticosteroids" },
  {
    value: "102358",
    label: "acetylsalicylic acid, combinations excl. psycholeptics",
  },
  {
    value: "102359",
    label: "acetylsalicylic acid, combinations with psycholeptics",
  },
  { value: "102360", label: "Acezide" },
  { value: "207", label: "Acfol" },
  { value: "208", label: "Aciclovir" },
  { value: "102361", label: "aciclovir, combinations" },
  { value: "100021", label: "Acidex" },
  { value: "209", label: "Acipimox" },
  { value: "210", label: "Acitretin" },
  { value: "102362", label: "aclarubicin" },
  { value: "211", label: "Aclasta" },
  { value: "102363", label: "Aclidinium" },
  { value: "102364", label: "aclidinium bromide" },
  { value: "100022", label: "Acnecide" },
  { value: "100023", label: "Acnisal" },
  { value: "212", label: "Acomplia" },
  { value: "213", label: "Acovil" },
  { value: "102365", label: "acriflavinium chloride" },
  { value: "102366", label: "acrivastine" },
  { value: "214", label: "Actavis" },
  { value: "100024", label: "Actilyse" },
  { value: "102367", label: "actilyse cathflo" },
  { value: "102368", label: "actinomycin" },
  { value: "100025", label: "Actinomycin D" },
  { value: "100026", label: "Actiq" },
  { value: "100027", label: "Activated" },
  { value: "100028", label: "Active II Endocrine" },
  { value: "215", label: "Actonel" },
  { value: "100029", label: "Actonel Combi" },
  { value: "100030", label: "Actonel Once a Week" },
  { value: "216", label: "Actos" },
  { value: "217", label: "Actrapid" },
  { value: "100031", label: "Acular" },
  { value: "102369", label: "acumor" },
  { value: "102370", label: "acumor xl" },
  { value: "100032", label: "Acupan" },
  { value: "102371", label: "Adakveo" },
  { value: "218", label: "Adalat" },
  { value: "100033", label: "Adalat Capsules" },
  { value: "100034", label: "Adalat LA" },
  { value: "102372", label: "Adalat Retard" },
  { value: "219", label: "Adalimumab" },
  { value: "100035", label: "Adapalene" },
  { value: "102373", label: "adapalene, combinations" },
  { value: "100036", label: "Adartrel" },
  { value: "100037", label: "Adcal" },
  { value: "220", label: "Adcal D3" },
  { value: "102374", label: "Adcetris" },
  { value: "102375", label: "Adcira" },
  { value: "221", label: "Adcirca" },
  { value: "100038", label: "Adcortyl" },
  { value: "100039", label: "Adefovir" },
  { value: "102376", label: "adefovir dipivoxil" },
  { value: "102377", label: "ademetionine" },
  { value: "100040", label: "Adenocor" },
  { value: "222", label: "Adenosine" },
  { value: "100041", label: "Adenuric" },
  { value: "102378", label: "adinazolam" },
  { value: "223", label: "Adipine" },
  { value: "102379", label: "Adipine MR" },
  { value: "100042", label: "Adipine XL" },
  { value: "102380", label: "adipiodone" },
  { value: "224", label: "Adiro" },
  { value: "225", label: "Adizem" },
  { value: "100044", label: "Adizem-SR" },
  { value: "100045", label: "Adizem-XL" },
  { value: "102381", label: "Adlyxin" },
  { value: "102382", label: "Adoport" },
  { value: "102383", label: "adrafinil" },
  { value: "100046", label: "Adrenaline" },
  { value: "102384", label: "adrenalone" },
  { value: "102385", label: "Adtralza" },
  { value: "102386", label: "Aducanumab" },
  { value: "102387", label: "Advagraf" },
  { value: "100047", label: "Advagraf Prolonged Release" },
  { value: "100048", label: "Advate" },
  { value: "226", label: "Advicor" },
  { value: "227", label: "Aerosonit" },
  { value: "102388", label: "afatinib" },
  { value: "102389", label: "afelimomab" },
  { value: "228", label: "Afinitor" },
  { value: "102390", label: "aflibercept" },
  { value: "102391", label: "agalsidase alfa" },
  { value: "102392", label: "agalsidase beta" },
  { value: "100049", label: "Aggrastat" },
  { value: "102393", label: "Aglomelatine" },
  { value: "100050", label: "Agomelatine" },
  { value: "102394", label: "Aimovig" },
  { value: "229", label: "Airomir" },
  { value: "102395", label: "Airsalb" },
  { value: "102396", label: "ajmaline" },
  { value: "102397", label: "Ajovy" },
  { value: "100051", label: "Aknemin" },
  { value: "102398", label: "aknemycin" },
  { value: "100052", label: "Aknemycin Plus" },
  { value: "102399", label: "alanyl glutamine" },
  { value: "102400", label: "alaproclate" },
  { value: "230", label: "Alateris" },
  { value: "102401", label: "albendazole" },
  { value: "102402", label: "albiglutide" },
  { value: "102403", label: "albinterferon alfa-2b" },
  { value: "102404", label: "albumin" },
  { value: "102405", label: "albumin tannate" },
  { value: "102406", label: "albumin tannate, combinations" },
  { value: "102407", label: "Albuterol" },
  { value: "102408", label: "alclofenac" },
  { value: "100053", label: "Alclometasone" },
  { value: "102409", label: "alcuronium" },
  { value: "231", label: "Aldactazine" },
  { value: "102410", label: "aldactide" },
  { value: "100054", label: "Aldactide 50" },
  { value: "232", label: "Aldactone" },
  { value: "233", label: "Aldara" },
  { value: "234", label: "Aldesleukin" },
  { value: "102411", label: "aldesulfone sodium" },
  { value: "100055", label: "Aldomet" },
  { value: "102412", label: "aldosterone" },
  { value: "102413", label: "Alecensa" },
  { value: "102414", label: "alectinib" },
  { value: "102415", label: "alefacept" },
  { value: "235", label: "Alemtuzumab" },
  { value: "236", label: "Alendronate" },
  { value: "102416", label: "alendronic" },
  { value: "237", label: "Alendronic acid" },
  { value: "102417", label: "alfa1 antitrypsin" },
  { value: "238", label: "Alfacalcidol" },
  { value: "102418", label: "alfaxalone" },
  { value: "100056", label: "Alfentanil" },
  { value: "239", label: "Alfuzosin" },
  { value: "102419", label: "algeldrate" },
  { value: "100057", label: "Algesal" },
  { value: "240", label: "Alginates" },
  { value: "102420", label: "alginic" },
  { value: "100058", label: "Alginic Acid" },
  { value: "102421", label: "Alginic acid preparations" },
  {
    value: "102422",
    label: "Alginic acid preparations (All standard preparations)",
  },
  { value: "102423", label: "Alginic acid preparations (Gaviscon Advance)" },
  { value: "102424", label: "alglucerase" },
  { value: "102425", label: "alglucosidase alfa" },
  { value: "241", label: "Alimemazine" },
  { value: "100059", label: "Alimta" },
  { value: "102426", label: "alipogene tiparvovec" },
  { value: "102427", label: "alirocumab" },
  { value: "242", label: "Aliskiren" },
  { value: "100060", label: "Alitretinoin" },
  { value: "102428", label: "alizapride" },
  { value: "102429", label: "Alka selzer" },
  { value: "102430", label: "alkapamid" },
  { value: "102431", label: "alkapamid xl" },
  { value: "243", label: "Alkeran" },
  { value: "100062", label: "Allegron" },
  { value: "102432", label: "allobarbital" },
  { value: "244", label: "Allopurinol" },
  { value: "102433", label: "allopurinol, combinations" },
  { value: "102434", label: "allylestrenol" },
  { value: "102435", label: "almagate" },
  { value: "102436", label: "almasilate" },
  { value: "102437", label: "Almatol" },
  { value: "245", label: "Almax" },
  { value: "102438", label: "alminoprofen" },
  { value: "102439", label: "almitrine" },
  { value: "100063", label: "Almogran" },
  { value: "100064", label: "Almotriptan" },
  { value: "100065", label: "Alogliptin" },
  { value: "102440", label: "aloglutamol" },
  { value: "100066", label: "Alomide" },
  { value: "102441", label: "alosetron" },
  { value: "100067", label: "Aloxi" },
  { value: "102442", label: "aloxiprin" },
  { value: "102443", label: "Alpelisib" },
  { value: "100068", label: "Alpha blocker - Other" },
  { value: "100069", label: "Alphaderm" },
  { value: "100070", label: "Alphagan" },
  { value: "100071", label: "Alphosyl" },
  { value: "100072", label: "Alphosyl HC" },
  { value: "246", label: "Alprazolam" },
  { value: "102444", label: "alprenolol" },
  { value: "247", label: "Alprostadil" },
  { value: "102445", label: "Alredase" },
  { value: "102446", label: "alsactide" },
  { value: "102447", label: "altacite" },
  { value: "100073", label: "Altacite Plus" },
  { value: "100074", label: "Altargo" },
  { value: "248", label: "Alteis" },
  { value: "100075", label: "Alteplase" },
  { value: "102448", label: "althea root" },
  { value: "102449", label: "altizide and potassium-sparing agents" },
  { value: "102450", label: "altretamine" },
  { value: "249", label: "Alu-Cap" },
  { value: "102451", label: "alum" },
  { value: "102452", label: "aluminium" },
  { value: "100076", label: "Aluminium Acetate" },
  { value: "102453", label: "aluminium acetoacetate" },
  { value: "102454", label: "aluminium acetotartrate" },
  { value: "102455", label: "aluminium chloride" },
  { value: "100077", label: "Aluminium chloride hexahydrate" },
  { value: "102456", label: "aluminium chlorohydrate" },
  { value: "102457", label: "aluminium clofibrate" },
  { value: "100078", label: "Aluminium Dihydroxyallantoinate" },
  { value: "102458", label: "aluminium glycinate" },
  { value: "250", label: "Aluminium Hydroxide" },
  { value: "100079", label: "Aluminium Hydroxide Gel" },
  { value: "102459", label: "Aluminium Hydroxide Mixture" },
  { value: "102460", label: "aluminium nicotinate" },
  { value: "100080", label: "Aluminium oxide" },
  { value: "102461", label: "aluminium phosphate" },
  { value: "102462", label: "aluminium preparations" },
  { value: "102463", label: "Alunbrig" },
  { value: "251", label: "Alupent" },
  { value: "100081", label: "Alvedon" },
  { value: "102464", label: "Alventa" },
  { value: "102465", label: "Alventa XL" },
  { value: "252", label: "Alverine" },
  { value: "100082", label: "Alverine citrate" },
  { value: "102466", label: "alverine, combinations" },
  { value: "253", label: "Alvesco" },
  { value: "102467", label: "alvimopan" },
  { value: "102468", label: "alzain" },
  { value: "254", label: "Amantadine" },
  { value: "100083", label: "Amantadine hydrochloride" },
  { value: "102469", label: "Amantidine" },
  { value: "255", label: "Amaryl" },
  { value: "102470", label: "ambazone" },
  { value: "102471", label: "ambenonium" },
  { value: "100084", label: "Ambirix" },
  { value: "100085", label: "Ambisome" },
  { value: "102472", label: "ambisone" },
  { value: "256", label: "Ambrisentan" },
  { value: "102473", label: "ambroxol" },
  { value: "102474", label: "ambutonium and psycholeptics" },
  { value: "102475", label: "amcinonide" },
  { value: "257", label: "Amdip" },
  { value: "100086", label: "Ametop" },
  { value: "102476", label: "amezinium metilsulfate" },
  { value: "102477", label: "amfepramone" },
  { value: "102478", label: "amfetamine" },
  { value: "102479", label: "Amgevita" },
  { value: "258", label: "Amias" },
  { value: "100087", label: "Amidox" },
  { value: "102480", label: "amielle" },
  { value: "100088", label: "Amielle Comfort" },
  { value: "100089", label: "Amifampridine" },
  { value: "102481", label: "amifostine" },
  { value: "100090", label: "Amikacin" },
  { value: "100091", label: "Amikin" },
  { value: "102482", label: "Amilamont" },
  { value: "259", label: "Amiloride" },
  { value: "102483", label: "Amiloride HCI" },
  { value: "102484", label: "Amiloride HCI/Bumetanide" },
  { value: "102485", label: "Amiloride HCI/Cyclopenth 2.5/250" },
  { value: "102486", label: "amineptine" },
  { value: "102487", label: "Amino acids" },
  { value: "102488", label: "amino(diphenylhydantoin) valeric acid" },
  { value: "102489", label: "aminoacridine" },
  { value: "102490", label: "aminobenzoic" },
  { value: "100092", label: "Aminobenzoic acid" },
  { value: "102491", label: "aminobutyric acid" },
  { value: "102492", label: "aminocaproic acid" },
  { value: "102493", label: "aminoglutethimide" },
  { value: "102494", label: "aminohippuric acid" },
  { value: "102495", label: "aminolevulinic acid" },
  { value: "102496", label: "aminomethylbenzoic acid" },
  { value: "102497", label: "aminophenazone" },
  {
    value: "102498",
    label: "aminophenazone, combinations excl. psycholeptics",
  },
  { value: "102499", label: "aminophenazone, combinations with psycholeptics" },
  { value: "260", label: "Aminophylline" },
  { value: "102500", label: "aminophylline and adrenergics" },
  { value: "102501", label: "aminophylline, combinations" },
  { value: "102502", label: "aminosalicylic acid" },
  { value: "261", label: "Amiodarone" },
  { value: "102503", label: "Amiodarone HCI" },
  { value: "262", label: "Amisulpride" },
  { value: "263", label: "Amitriptyline" },
  { value: "102504", label: "Amitriptyline & perphenazine 10mg/2mg" },
  { value: "102505", label: "Amitriptyline & perphenazine 25mg/2mg" },
  { value: "102506", label: "amitriptyline and psycholeptics" },
  { value: "102507", label: "amlexanox" },
  { value: "264", label: "Amlobesilat-Sandoz" },
  { value: "265", label: "Amlodipine" },
  { value: "102508", label: "amlodipine valsartan" },
  { value: "266", label: "Amlor" },
  { value: "267", label: "Amlostin" },
  { value: "268", label: "Amlovasc" },
  { value: "100095", label: "Ammonaps" },
  { value: "102509", label: "ammonium chloride" },
  { value: "100096", label: "Amobarbital" },
  { value: "102510", label: "amodiaquine" },
  { value: "269", label: "Amorolfine" },
  { value: "102511", label: "amoxapine" },
  { value: "270", label: "Amoxetine" },
  { value: "271", label: "Amoxicillin" },
  { value: "100097", label: "Amoxil" },
  { value: "100098", label: "Amphocil" },
  { value: "102512", label: "Amphoteracin" },
  { value: "272", label: "Amphotericin" },
  { value: "102513", label: "amphotericin B" },
  { value: "100099", label: "Ampicillin" },
  { value: "102514", label: "ampicillin, combinations" },
  { value: "102515", label: "amprenavir" },
  { value: "102516", label: "amrinone" },
  { value: "102517", label: "amrubicin" },
  { value: "100100", label: "Amsacrine" },
  { value: "100101", label: "Amsidine" },
  { value: "100102", label: "Amyben" },
  { value: "102518", label: "amyl nitrite" },
  { value: "100103", label: "Anabact" },
  { value: "100104", label: "Anacal" },
  { value: "102519", label: "Anacetrapib" },
  { value: "102520", label: "Anadin" },
  { value: "273", label: "Anafranil" },
  { value: "102521", label: "anafranil sr" },
  { value: "274", label: "Anagrelide" },
  { value: "100105", label: "Anakinra" },
  { value: "100106", label: "Anapen" },
  { value: "102522", label: "Anastrazole" },
  { value: "275", label: "Anastrozole" },
  { value: "102523", label: "ancestim" },
  { value: "100107", label: "Ancotil" },
  { value: "102524", label: "ancrod" },
  { value: "100108", label: "Androcur" },
  { value: "100109", label: "Andropatch" },
  { value: "102525", label: "androstanolone" },
  { value: "102526", label: "anecortave" },
  { value: "100110", label: "Anectine" },
  { value: "102527", label: "anethole trithione" },
  { value: "100111", label: "Anexate" },
  { value: "100112", label: "Angeliq" },
  { value: "276", label: "Angettes" },
  { value: "100113", label: "Angettes 75" },
  { value: "102528", label: "Angilol" },
  { value: "102529", label: "angiotensin" },
  { value: "100114", label: "Angiotensin II Receptor Blocker - Other" },
  { value: "102530", label: "angiotensinamide" },
  { value: "100115", label: "Angiox" },
  { value: "100116", label: "Angitak" },
  { value: "102531", label: "Angitil" },
  { value: "277", label: "Angitil SR" },
  { value: "278", label: "Angitil XL" },
  { value: "102532", label: "anhydrol" },
  { value: "100117", label: "Anhydrol Forte" },
  { value: "100118", label: "Anidulafungin" },
  { value: "102533", label: "anileridine" },
  { value: "102534", label: "animals" },
  { value: "102535", label: "aniracetam" },
  { value: "102536", label: "anistreplase" },
  { value: "102537", label: "Anopyrin" },
  { value: "102538", label: "anoro" },
  { value: "102539", label: "Anoro Ellipta" },
  { value: "100119", label: "Anquil" },
  { value: "100120", label: "Antabuse" },
  { value: "100121", label: "Antazoline" },
  { value: "100122", label: "Antepsin" },
  { value: "279", label: "Anthenol" },
  { value: "102540", label: "anthrax antigen" },
  { value: "102541", label: "anti-arrhythmic" },
  { value: "100123", label: "Anti-arrhythmic - Other" },
  { value: "102542", label: "antibiotics in combination with other drugs" },
  { value: "102543", label: "anti-d" },
  { value: "102544", label: "anti-D (rh) immunoglobulin" },
  { value: "100124", label: "Anti-D immunoglobulin" },
  { value: "102545", label: "anti-hypertensive" },
  { value: "100125", label: "Anti-hypertensive - Other" },
  { value: "102546", label: "antiinfectives, combinations" },
  { value: "102547", label: "Antilymphocyte Immunoglobulin" },
  { value: "102548", label: "antilymphocyte immunoglobulin (horse)" },
  { value: "102549", label: "antimony pentasulfide" },
  { value: "102550", label: "antiplatelet" },
  { value: "100127", label: "Antiplatelet - Other" },
  { value: "102551", label: "antithrombin" },
  { value: "100128", label: "Antithrombin alfa" },
  { value: "102552", label: "antithrombin III" },
  { value: "102553", label: "anti-thymocyte" },
  { value: "102554", label: "Antithymocyte Immunoglobulin" },
  { value: "100126", label: "Anti-thymocyte immunoglobulin" },
  { value: "102555", label: "antithymocyte immunoglobulin (rabbit)" },
  { value: "102556", label: "Antixarin" },
  { value: "102557", label: "anugesic" },
  { value: "100129", label: "Anugesic-HC" },
  { value: "100130", label: "Anusol" },
  { value: "100131", label: "Anusol HC" },
  { value: "280", label: "Anxicalm" },
  { value: "281", label: "Apagrel" },
  { value: "102558", label: "apalutamide" },
  { value: "282", label: "Apidra" },
  { value: "102559", label: "apixaban" },
  { value: "283", label: "Apocard" },
  { value: "100132", label: "APO-go" },
  { value: "284", label: "Apomorphine" },
  { value: "102560", label: "Apomorphine Hydrochloride" },
  { value: "100133", label: "Apraclonidine" },
  { value: "102561", label: "apremilast" },
  { value: "100134", label: "Aprepitant" },
  { value: "100135", label: "Apresoline" },
  { value: "102562", label: "aprindine" },
  { value: "100136", label: "Aprinox" },
  { value: "102563", label: "aprobarbital" },
  { value: "102564", label: "apronal" },
  { value: "102565", label: "aprotinin" },
  { value: "285", label: "Aprovel" },
  { value: "100137", label: "Aptivus" },
  { value: "100138", label: "Aqsia" },
  { value: "100139", label: "Aquadrate" },
  { value: "102566", label: "aquagel" },
  { value: "100140", label: "Aquagel Genito-urinary System" },
  { value: "102567", label: "aqueous" },
  { value: "100141", label: "Aqueous Cream" },
  { value: "100142", label: "Aqueous cream Skin" },
  { value: "102568", label: "arachis" },
  { value: "100143", label: "Arachis Oil" },
  { value: "286", label: "Aranesp" },
  { value: "287", label: "Arava" },
  { value: "100144", label: "ARB - Other" },
  { value: "102569", label: "arbekacin" },
  { value: "102570", label: "arbutamine" },
  { value: "288", label: "Arcoxia" },
  { value: "100145", label: "Aredia" },
  { value: "102571", label: "argatroban" },
  { value: "102572", label: "arginine glutamate" },
  { value: "102573", label: "arginine hydrochloride" },
  { value: "100146", label: "Argipressin" },
  { value: "289", label: "Aricept" },
  { value: "290", label: "Arimidex" },
  { value: "291", label: "Aripaprazole" },
  { value: "100147", label: "Aripiprazole" },
  { value: "100148", label: "Arixtra" },
  { value: "102574", label: "arjun" },
  { value: "100149", label: "Arjun Ear Drops" },
  { value: "100150", label: "Arlevert" },
  { value: "292", label: "Aromasin" },
  { value: "102575", label: "aromatase" },
  { value: "293", label: "Aromatase inhibitors" },
  { value: "100151", label: "Arpicolin" },
  { value: "102576", label: "arsenic" },
  { value: "102577", label: "arsenic trioxide" },
  { value: "102578", label: "arsthinol" },
  { value: "102579", label: "ART" },
  { value: "100153", label: "Artelac" },
  { value: "100154", label: "Artemether" },
  { value: "102580", label: "artemisinin" },
  { value: "102581", label: "artemotil" },
  { value: "102582", label: "artenimol" },
  { value: "102583", label: "artenimol and piperaquine" },
  { value: "102584", label: "artesunate" },
  { value: "294", label: "Arthrotec" },
  { value: "100155", label: "Arthrotec 50" },
  { value: "102585", label: "articaine" },
  { value: "102586", label: "articaine, combinations" },
  { value: "100156", label: "Artificial saliva" },
  {
    value: "102587",
    label: "artificial tears and other indifferent preparations",
  },
  { value: "295", label: "Arythmol" },
  { value: "100157", label: "Arzerra" },
  { value: "102588", label: "Arzip" },
  { value: "100158", label: "AS Saliva Orthana" },
  { value: "102589", label: "Asa" },
  { value: "296", label: "Asacol" },
  { value: "100159", label: "Asacol MR" },
  { value: "297", label: "Asasantin" },
  { value: "100160", label: "Asasantin Retard" },
  { value: "102590", label: "ascensia" },
  { value: "298", label: "Ascensia Microfil" },
  { value: "102591", label: "Asciminib" },
  { value: "102592", label: "ascorbic acid" },
  { value: "102593", label: "ascorbic acid (vit C)" },
  { value: "102594", label: "asenapine" },
  { value: "100161", label: "Aserbine" },
  { value: "299", label: "Asilone" },
  { value: "100162", label: "Asilone Suspension" },
  { value: "102595", label: "Asmabec" },
  { value: "100163", label: "Asmabec Clickhaler" },
  { value: "102596", label: "Asmanex" },
  { value: "100164", label: "Asmanex Twisthaler" },
  { value: "102597", label: "Asmasal" },
  { value: "100165", label: "Asmasal Clickhaler" },
  { value: "102598", label: "asparaginase" },
  { value: "300", label: "Aspegic" },
  { value: "301", label: "Aspirin" },
  { value: "102599", label: "aspro" },
  { value: "302", label: "Aspro Clear" },
  { value: "102600", label: "astemizole" },
  { value: "102601", label: "asunaprevir" },
  { value: "303", label: "Atacand" },
  { value: "304", label: "Atarax" },
  { value: "100166", label: "Atazanavir" },
  { value: "305", label: "Atenolol" },
  { value: "102602", label: "atezolizumab" },
  { value: "102603", label: "atimos" },
  { value: "100167", label: "Atimos Modulite" },
  { value: "100168", label: "Ativan" },
  { value: "306", label: "Atomoxetine" },
  { value: "100169", label: "Atopiclair" },
  { value: "307", label: "Atoris" },
  { value: "308", label: "Atorvastatin" },
  { value: "100170", label: "Atosiban" },
  { value: "100171", label: "Atovaquone" },
  { value: "100172", label: "Atracurium" },
  { value: "100173", label: "Atriance" },
  { value: "309", label: "Atripla" },
  { value: "310", label: "Atropine" },
  { value: "102604", label: "atropine and psycholeptics" },
  { value: "102605", label: "Atropine Sulphate" },
  { value: "311", label: "Atrovent" },
  { value: "100174", label: "ATryn" },
  { value: "102606", label: "attapulgite" },
  { value: "102607", label: "attapulgite, combinations" },
  { value: "102608", label: "Aubagio" },
  { value: "312", label: "Augmentin" },
  { value: "102609", label: "auranofin" },
  { value: "100175", label: "Aureocort" },
  { value: "102610", label: "aurothioglucose" },
  { value: "102611", label: "aurotioprol" },
  { value: "100176", label: "Automatic ICD" },
  { value: "102612", label: "Avacopan" },
  { value: "102613", label: "Avalglucosidase alfa" },
  { value: "313", label: "Avalide" },
  { value: "100177", label: "Avamys" },
  { value: "314", label: "Avandamet" },
  { value: "315", label: "Avandia" },
  { value: "316", label: "Avapro" },
  { value: "317", label: "Avastin" },
  { value: "102614", label: "avatrombopag" },
  { value: "100178", label: "Avaxim" },
  { value: "100179", label: "Aveeno" },
  { value: "100180", label: "Avelox" },
  { value: "102615", label: "avelumab" },
  { value: "100181", label: "Avloclor" },
  { value: "100182", label: "Avoca" },
  { value: "102616", label: "avocado and soyabean oil, unsaponifiables" },
  { value: "318", label: "Avodart" },
  { value: "100183", label: "Avomine" },
  { value: "319", label: "Avonex" },
  { value: "320", label: "Axagon" },
  { value: "102617", label: "axalid" },
  { value: "102618", label: "axicabtagene ciloleucel" },
  { value: "100184", label: "Axid" },
  { value: "102619", label: "axitinib" },
  { value: "100185", label: "Axorid" },
  { value: "100186", label: "Axsain" },
  { value: "321", label: "Azacitidine" },
  { value: "100187", label: "Azactam" },
  { value: "102620", label: "Azadatine" },
  { value: "102621", label: "Azamune" },
  { value: "102622", label: "azanidazole" },
  { value: "102623", label: "azapetine" },
  { value: "102624", label: "azapropazone" },
  { value: "100188", label: "Azarga" },
  { value: "102625", label: "azatadine" },
  { value: "322", label: "Azathioprine" },
  { value: "102626", label: "azelaic" },
  { value: "100189", label: "Azelaic acid" },
  { value: "100190", label: "Azelastine" },
  { value: "323", label: "Azelastine Hydrochloride" },
  { value: "102627", label: "azidamfenicol" },
  { value: "102628", label: "azidocillin" },
  { value: "102629", label: "Azidothymidine" },
  { value: "324", label: "Azilect" },
  { value: "102630", label: "Azilsartan" },
  { value: "102631", label: "azilsartan medoxomil" },
  { value: "325", label: "Azithromycin" },
  { value: "102632", label: "azlocillin" },
  { value: "102633", label: "azocan" },
  { value: "326", label: "Azopt" },
  { value: "102634", label: "Azor" },
  { value: "102635", label: "azothioprine" },
  { value: "102636", label: "AZT" },
  { value: "100191", label: "Aztreonam" },
  { value: "102637", label: "B12 medication (generic)" },
  { value: "102638", label: "bacampicillin" },
  { value: "100192", label: "Bacitracin" },
  { value: "327", label: "Baclofen" },
  { value: "100193", label: "Bactroban" },
  { value: "100194", label: "Bactroban Nasal" },
  { value: "100195", label: "Balance Activ RX" },
  { value: "100196", label: "Balmosa" },
  { value: "328", label: "Balneum" },
  { value: "329", label: "Balsalazide" },
  { value: "100197", label: "Bambec" },
  { value: "100198", label: "Bambuterol" },
  { value: "102639", label: "bamethan" },
  { value: "102640", label: "bamifylline" },
  { value: "102641", label: "bamipine" },
  { value: "100199", label: "Baraclude" },
  { value: "100200", label: "Baratol" },
  { value: "102642", label: "barbexaclone" },
  { value: "102643", label: "barbital" },
  { value: "102644", label: "Barbiturates in combination with other drugs" },
  { value: "102645", label: "baricitinib" },
  { value: "102646", label: "barium sulfate with suspending agents" },
  { value: "102647", label: "barium sulfate without suspending agents" },
  { value: "100201", label: "Barkat" },
  { value: "330", label: "Barnidipine" },
  { value: "100202", label: "Basiliximab" },
  { value: "102648", label: "batroxobin" },
  { value: "102649", label: "Bavencio" },
  { value: "100203", label: "Baxan" },
  { value: "102650", label: "bazedoxifene" },
  { value: "102651", label: "BCG vaccine" },
  { value: "100204", label: "Becaplermin" },
  { value: "102652", label: "beclamide" },
  { value: "331", label: "Beclazone" },
  { value: "332", label: "Becloforte" },
  { value: "333", label: "Beclometasone" },
  { value: "102653", label: "beclometasone and antibiotics" },
  { value: "102654", label: "Beclomethasone" },
  { value: "102655", label: "Beclomethasone & salbutamol 100mcg/200mcg" },
  { value: "102656", label: "Beclomethasone & salbutamol 200mcg/400mcg" },
  { value: "102657", label: "Beclomethasone & salbutamol 50mcg/100mcg" },
  { value: "102658", label: "Beclomethasone CFC-free (QVAR)" },
  { value: "334", label: "Beclotaide" },
  { value: "335", label: "Becodisks" },
  { value: "336", label: "Beconase" },
  { value: "337", label: "Becotide" },
  { value: "100205", label: "Bedol" },
  { value: "102659", label: "Bedranol" },
  { value: "102660", label: "Bedranol SR" },
  { value: "102661", label: "Beechams" },
  { value: "102662", label: "befunolol" },
  { value: "102663", label: "belatacept" },
  { value: "102664", label: "belimumab" },
  { value: "102665", label: "belladonna total alkaloids" },
  { value: "102666", label: "belladonna total alkaloids and psycholeptics" },
  { value: "102667", label: "belvo" },
  { value: "102668", label: "bemegride" },
  { value: "100206", label: "Bemiparin" },
  { value: "102669", label: "Bempedoic Acid" },
  { value: "338", label: "Benazepril" },
  { value: "102670", label: "benazepril and diuretics" },
  { value: "102671", label: "bencyclane" },
  { value: "102672", label: "bendamustine" },
  { value: "102673", label: "bendazac" },
  { value: "102674", label: "Bendrofluazide" },
  { value: "339", label: "Bendroflumethiazide" },
  { value: "100207", label: "Benefix" },
  { value: "102675", label: "Benepali" },
  { value: "102676", label: "benfluorex" },
  { value: "102677", label: "benfotiamine" },
  { value: "102678", label: "benidipine" },
  { value: "102679", label: "Benlysta" },
  { value: "102680", label: "benorilate" },
  { value: "102681", label: "Benorylate" },
  { value: "102682", label: "benoxaprofen" },
  { value: "100208", label: "Benperidol" },
  { value: "102683", label: "benproperine" },
  { value: "102684", label: "benralizumab" },
  { value: "100209", label: "Benserazide" },
  { value: "102685", label: "bentiromide" },
  { value: "102686", label: "benzalkonium" },
  { value: "100210", label: "Benzalkonium chloride" },
  { value: "102687", label: "benzathine benzylpenicillin" },
  { value: "102688", label: "benzathine phenoxymethylpenicillin" },
  { value: "100211", label: "Benzatropine" },
  { value: "102689", label: "benzbromarone" },
  { value: "102690", label: "benzethonium" },
  { value: "102691", label: "benzethonium chloride" },
  { value: "102692", label: "benzethonium chloride, combinations" },
  { value: "340", label: "Benzhexol" },
  { value: "102693", label: "Benzhexol (Trihexyphenidyl)" },
  { value: "102694", label: "benzilone" },
  { value: "102695", label: "benziodarone" },
  { value: "102696", label: "benziodarone, combinations" },
  { value: "102697", label: "benznidazole" },
  { value: "100212", label: "Benzocaine" },
  { value: "102698", label: "benzoctamine" },
  { value: "102699", label: "benzododecinium" },
  { value: "102700", label: "Benzofluazide" },
  { value: "102701", label: "benzoic" },
  { value: "100213", label: "Benzoic Acid" },
  { value: "100214", label: "Benzoin" },
  { value: "102702", label: "benzonatate" },
  { value: "102703", label: "benzoxonium chloride" },
  { value: "102704", label: "benzoyl" },
  { value: "341", label: "Benzoyl Peroxide" },
  { value: "102705", label: "benzoyl peroxide, combinations" },
  { value: "100215", label: "Benzthiazide" },
  { value: "102706", label: "Benztropine" },
  { value: "342", label: "Benzydamine" },
  { value: "102707", label: "benzyl" },
  { value: "100216", label: "Benzyl Benzoate" },
  { value: "102708", label: "benzylpenicillin" },
  { value: "102709", label: "Benzylpenicillin (GP single injection)" },
  { value: "100217", label: "Benzylpenicillin sodium" },
  { value: "102710", label: "benzylthiouracil" },
  { value: "102711", label: "Beovu" },
  { value: "102712", label: "bephenium" },
  { value: "102713", label: "bepridil" },
  { value: "100218", label: "Beractant" },
  { value: "102714", label: "beraprost" },
  { value: "102715", label: "bergapten" },
  { value: "100219", label: "Berinert" },
  { value: "102716", label: "beriplex" },
  { value: "100220", label: "Beriplex P/N" },
  { value: "102717", label: "Berotralstat" },
  { value: "102718", label: "besavar" },
  { value: "343", label: "Besavar XL" },
  { value: "102719", label: "besifloxacin" },
  { value: "344", label: "Besitran" },
  { value: "102720", label: "Besponsa" },
  { value: "102721", label: "Beta Prograne" },
  { value: "100221", label: "Beta-adalat" },
  { value: "102722", label: "beta-blocker" },
  { value: "100222", label: "Beta-blocker - Other" },
  { value: "100223", label: "Betacap" },
  { value: "345", label: "Beta-Cardone" },
  { value: "102723", label: "betacarotene" },
  { value: "102724", label: "betadine" },
  { value: "100224", label: "Betadine Ointment" },
  { value: "100225", label: "Betadine Spray" },
  { value: "346", label: "Betaferon" },
  { value: "100226", label: "Betagan" },
  { value: "347", label: "Betahistine" },
  { value: "102725", label: "betaine" },
  { value: "100227", label: "Betaine anhydrous" },
  { value: "102726", label: "betaine hydrochloride" },
  { value: "348", label: "Betaloc" },
  { value: "100228", label: "Betaloc - SA" },
  { value: "100229", label: "Betaloc I.V. Injection" },
  { value: "349", label: "Betamethasone" },
  { value: "102727", label: "betamethasone and antibiotics" },
  { value: "102728", label: "betamethasone and antiinfectives" },
  { value: "102729", label: "betamethasone and antiseptics" },
  { value: "102730", label: "betamethasone and mydriatics" },
  { value: "102731", label: "betanidine" },
  { value: "350", label: "Beta-Prograne" },
  { value: "100230", label: "Betaxolol" },
  { value: "102732", label: "betaxolol, combinations" },
  { value: "102733", label: "betazole" },
  { value: "100231", label: "Betesil" },
  { value: "100232", label: "Bethanechol" },
  { value: "100233", label: "Betim" },
  { value: "102734", label: "Betmiga" },
  { value: "100234", label: "Betnelan" },
  { value: "351", label: "Betnesol" },
  { value: "100235", label: "Betnesol Tablets" },
  { value: "352", label: "Betnovate" },
  { value: "100236", label: "Betnovate RD" },
  { value: "100237", label: "Betnovate-C" },
  { value: "353", label: "Betoptic" },
  { value: "102735", label: "betrixaban" },
  { value: "100238", label: "Bettamousse" },
  { value: "354", label: "Bevacizumab" },
  { value: "102736", label: "bevantolol" },
  { value: "102737", label: "bevonium" },
  { value: "102738", label: "bevonium and analgesics" },
  { value: "102739", label: "bevonium and psycholeptics" },
  { value: "100239", label: "Bexarotene" },
  { value: "355", label: "Bezafibrate" },
  { value: "100240", label: "Bezalip" },
  { value: "100241", label: "Bezalip Mono" },
  { value: "356", label: "Bezalip-Mono" },
  { value: "102740", label: "bezitramide" },
  { value: "100242", label: "Bi-Aglut" },
  { value: "100243", label: "Bi-Alimenta" },
  { value: "102741", label: "biapenem" },
  { value: "102742", label: "bibenzonium bromide" },
  { value: "102743", label: "bibrocathol" },
  { value: "357", label: "Bicalutamide" },
  { value: "102744", label: "Bi-Carzem" },
  { value: "102745", label: "bietaserpine" },
  { value: "102746", label: "bietaserpine and diuretics" },
  { value: "102747", label: "bietaserpine, combinations" },
  { value: "102748", label: "bifemelane" },
  { value: "102749", label: "bifonazole" },
  { value: "102750", label: "bifonazole, combinations" },
  { value: "102751", label: "bilastine" },
  { value: "102752", label: "Bilocor" },
  { value: "358", label: "Bimatoprost" },
  { value: "102753", label: "bimekizumab" },
  { value: "102754", label: "Bimzelx" },
  { value: "102755", label: "binimetinib" },
  { value: "100244", label: "Binocrit" },
  { value: "102756", label: "bioallethrin" },
  { value: "102757", label: "bioallethrin, combinations" },
  { value: "100245", label: "Biorphen" },
  { value: "102758", label: "biotene" },
  { value: "100246", label: "Biotene Oralbalance" },
  { value: "102759", label: "biotin" },
  { value: "100247", label: "BioXtra" },
  { value: "102760", label: "biperiden" },
  { value: "102761", label: "biphasic" },
  { value: "100248", label: "Biphasic Insulin Aspart" },
  { value: "100249", label: "Biphasic Insulin Lispro" },
  { value: "100250", label: "Biphasic Isophane Insulin" },
  { value: "102762", label: "biphenylol" },
  { value: "359", label: "Biphosphonates" },
  { value: "360", label: "Bipreterax" },
  { value: "361", label: "Bisacodyl" },
  { value: "102763", label: "bisacodyl, combinations" },
  { value: "102764", label: "bismuth" },
  { value: "100251", label: "Bismuth Oxide" },
  { value: "102765", label: "bismuth preparations, combinations" },
  { value: "102766", label: "bismuth subcitrate" },
  { value: "100252", label: "Bismuth Subgallate" },
  { value: "102767", label: "bismuth subnitrate" },
  { value: "362", label: "Bisoprolol" },
  { value: "102768", label: "Bisoprolol with hydrochlorothiazide 10mg/6.25mg" },
  { value: "102769", label: "bisoxatin" },
  { value: "102770", label: "bithionol" },
  { value: "102771", label: "bitolterol" },
  { value: "100253", label: "Bivalirudin" },
  { value: "102772", label: "bleo-kyowa" },
  { value: "363", label: "Bleomycin" },
  { value: "102773", label: "blinatumomab" },
  { value: "102774", label: "Blincyto" },
  { value: "102775", label: "Blonanserin" },
  { value: "102776", label: "blood plasma" },
  { value: "100254", label: "Blood pressure treatment - Other" },
  { value: "102777", label: "boceprevir" },
  { value: "102778", label: "bolamyn" },
  { value: "364", label: "Bolamyn SR" },
  { value: "365", label: "Bondronat" },
  { value: "366", label: "Bonefos" },
  { value: "102779", label: "Bonilux" },
  { value: "102780", label: "Bonilux XL" },
  { value: "100255", label: "Bonjela" },
  { value: "367", label: "Bonviva" },
  { value: "102781", label: "bopindolol" },
  { value: "102782", label: "bopindolol and other diuretics" },
  { value: "102783", label: "boric acid" },
  { value: "102784", label: "bornaprine" },
  { value: "368", label: "Bortezomib" },
  { value: "369", label: "Bosentan" },
  { value: "102785", label: "Bosulif" },
  { value: "102786", label: "bosutinib" },
  { value: "100256", label: "Botox" },
  { value: "102787", label: "botulinum" },
  { value: "102788", label: "botulinum antitoxin" },
  { value: "370", label: "Botulinum toxin" },
  { value: "100257", label: "BP treatment - Other" },
  { value: "100258", label: "Bradosol" },
  { value: "102789", label: "Braftovi" },
  { value: "102790", label: "Braltus" },
  { value: "100259", label: "Bramitob" },
  { value: "100260", label: "Brasivol" },
  { value: "371", label: "Brazepam" },
  { value: "102791", label: "brentuximab" },
  { value: "102792", label: "brentuximab vedotin" },
  { value: "102793", label: "bretylium tosilate" },
  { value: "100261", label: "Brevibloc" },
  { value: "100262", label: "Brevoxyl" },
  { value: "100263", label: "Brexidol" },
  { value: "102794", label: "briakinumab" },
  { value: "372", label: "Bricanyl" },
  { value: "100264", label: "Bricanyl Turbohaler" },
  { value: "100265", label: "Bridion" },
  { value: "102795", label: "brigatinib" },
  { value: "102796", label: "Brilique" },
  { value: "100266", label: "Brimonidine" },
  { value: "102797", label: "brinase" },
  { value: "102798", label: "Brintellix" },
  { value: "373", label: "Brinzolamide" },
  { value: "100267", label: "BritLofex" },
  { value: "102799", label: "brivaracetam" },
  { value: "102800", label: "briviact" },
  { value: "102801", label: "brivudine" },
  { value: "100268", label: "Brochlor" },
  { value: "102802", label: "brodalumab" },
  { value: "102803", label: "brodimoprim" },
  { value: "100269", label: "Broflex" },
  { value: "100270", label: "Brolene" },
  { value: "102804", label: "brolucizumab" },
  { value: "374", label: "Bromazepam" },
  { value: "102805", label: "bromazine" },
  { value: "375", label: "Bromelain" },
  { value: "102806", label: "bromelains" },
  { value: "102807", label: "bromfenac" },
  { value: "102808", label: "bromhexine" },
  { value: "102809", label: "bromides" },
  { value: "102810", label: "bromisoval" },
  { value: "102811", label: "bromochlorosalicylanilide" },
  { value: "376", label: "Bromocriptine" },
  { value: "102812", label: "bromopride" },
  { value: "102813", label: "bromperidol" },
  { value: "102814", label: "brompheniramine" },
  { value: "102815", label: "brompheniramine, combinations" },
  { value: "102816", label: "bronchitol" },
  { value: "102817", label: "brotizolam" },
  { value: "102818", label: "broxyquinoline" },
  { value: "102819", label: "brucella antigen" },
  { value: "102820", label: "brufen" },
  { value: "377", label: "Brufen Retard" },
  { value: "102821", label: "Brukinsa" },
  { value: "378", label: "Buccastem" },
  { value: "102822", label: "Buccolam" },
  { value: "102823", label: "bucetin" },
  { value: "102824", label: "bucetin, combinations excl. psycholeptics" },
  { value: "102825", label: "bucetin, combinations with psycholeptics" },
  { value: "102826", label: "bucillamine" },
  { value: "102827", label: "bucladesine" },
  { value: "100271", label: "Buclizine" },
  { value: "102828", label: "buclizine, combinations" },
  { value: "102829", label: "budelin" },
  { value: "100272", label: "Budelin Novolizer" },
  { value: "100273", label: "Budenofalk" },
  { value: "379", label: "Budesonide" },
  { value: "102830", label: "Budesonide & Formoterol 100/6mcg, 200/6mcg" },
  { value: "102831", label: "budipine" },
  { value: "102832", label: "bufexamac" },
  { value: "102833", label: "buflomedil" },
  { value: "102834", label: "buformin" },
  { value: "102835", label: "bufylline" },
  { value: "102836", label: "bumadizone" },
  { value: "380", label: "Bumetanide" },
  { value: "102852", label: "bumetanide and potassium-sparing agents" },
  { value: "102837", label: "bunaftine" },
  { value: "102838", label: "buphenine" },
  { value: "100274", label: "Bupivacaine" },
  { value: "102839", label: "bupivacaine, combinations" },
  { value: "102840", label: "bupranolol" },
  { value: "381", label: "Buprenorphine" },
  { value: "102841", label: "Buprenorphine transdermal patch" },
  { value: "102842", label: "buprenorphine, combinations" },
  { value: "382", label: "Bupropion" },
  { value: "383", label: "Burinex" },
  { value: "384", label: "Burinex A" },
  { value: "385", label: "Burinex K" },
  { value: "386", label: "Buscopan" },
  { value: "100275", label: "Buserelin" },
  { value: "100276", label: "Busilvex" },
  { value: "387", label: "Buspar" },
  { value: "388", label: "Buspirone" },
  { value: "100277", label: "Busulfan" },
  { value: "102843", label: "Busulphan" },
  { value: "102844", label: "butalamine" },
  { value: "389", label: "Butamide" },
  { value: "102845", label: "butamirate" },
  { value: "102846", label: "butanilicaine" },
  { value: "102847", label: "butaperazine" },
  { value: "102848", label: "butenafine" },
  { value: "102849", label: "butizide and potassium-sparing agents" },
  { value: "100278", label: "Butobarbital" },
  { value: "102850", label: "butoconazole" },
  { value: "102851", label: "butorphanol" },
  { value: "390", label: "BuTrans" },
  { value: "102853", label: "butriptyline" },
  { value: "102854", label: "butylscopolamine" },
  { value: "102855", label: "butylscopolamine and analgesics" },
  { value: "102856", label: "Bydureon" },
  { value: "391", label: "Byetta" },
  { value: "102857", label: "c1-esterase" },
  { value: "100279", label: "C1-esterase inhibitor" },
  { value: "102858", label: "c1-inhibitor" },
  { value: "100280", label: "Cabaser" },
  { value: "102859", label: "cabazitaxel" },
  { value: "392", label: "Cabergoline" },
  { value: "102860", label: "Cablivi" },
  { value: "102861", label: "Cabometyx" },
  { value: "102862", label: "Cabotegravir" },
  { value: "102863", label: "cabozantinib" },
  { value: "393", label: "Cabren" },
  { value: "394", label: "Cacit" },
  { value: "102864", label: "Cacit D3" },
  { value: "100281", label: "Cacit Tablets" },
  { value: "102865", label: "cade" },
  { value: "100282", label: "Cade Oil" },
  { value: "102866", label: "cadexomer iodine" },
  { value: "100283", label: "Cadicor" },
  { value: "102867", label: "cadmium compounds" },
  { value: "102868", label: "cadralazine" },
  { value: "395", label: "Caduet" },
  { value: "100284", label: "Caelyx" },
  { value: "102869", label: "cafedrine" },
  { value: "100285", label: "Cafergot" },
  { value: "100286", label: "Caffeine" },
  { value: "102870", label: "caffeine and sodium benzoate" },
  { value: "102871", label: "caffeine citrate" },
  { value: "100287", label: "Calamine" },
  { value: "100288", label: "Calceos" },
  { value: "102872", label: "Calchan" },
  { value: "100289", label: "Calchan MR" },
  { value: "102873", label: "Calcicard" },
  { value: "100290", label: "Calcicard CR" },
  { value: "396", label: "Calcichew" },
  { value: "102874", label: "calcifediol" },
  { value: "100291", label: "Calcijex" },
  { value: "397", label: "Calcipotriol" },
  { value: "102875", label: "calcipotriol, combinations" },
  { value: "398", label: "Calcitonin" },
  { value: "102876", label: "calcitonin (human synthetic)" },
  { value: "102877", label: "calcitonin (pork natural)" },
  { value: "102878", label: "calcitonin (salmon synthetic)" },
  { value: "399", label: "Calcitriol" },
  { value: "100292", label: "Calcium" },
  { value: "102879", label: "calcium (different salts in combination)" },
  { value: "100293", label: "Calcium acetate" },
  { value: "102880", label: "calcium acetate anhydrous" },
  { value: "102881", label: "calcium alginate" },
  { value: "102882", label: "calcium aminosalicylate" },
  { value: "102883", label: "calcium carbimide" },
  { value: "100295", label: "Calcium carbonate" },
  { value: "100296", label: "Calcium channel blocker - Other" },
  { value: "102884", label: "calcium chloride" },
  { value: "102885", label: "calcium citrate lysine complex" },
  { value: "102886", label: "Calcium compounds" },
  { value: "102887", label: "calcium dobesilate" },
  { value: "102888", label: "calcium dobesilate, combinations" },
  { value: "102889", label: "calcium folinate" },
  { value: "102890", label: "calcium glubionate" },
  { value: "102891", label: "calcium glucoheptonate" },
  { value: "100297", label: "Calcium gluconate" },
  { value: "102892", label: "calcium glycerylphosphate" },
  { value: "102893", label: "calcium hexamine thiocyanate" },
  { value: "102894", label: "calcium iopodate" },
  { value: "100298", label: "Calcium lactate" },
  { value: "102895", label: "calcium lactate gluconate" },
  { value: "102896", label: "calcium laevulate" },
  { value: "100299", label: "Calcium levofolinate" },
  { value: "102897", label: "calcium pangamate" },
  { value: "102898", label: "calcium pantothenate" },
  { value: "100300", label: "Calcium Phosphate" },
  { value: "100301", label: "Calcium Resonium" },
  { value: "102899", label: "calcium silicate" },
  { value: "100302", label: "Calcium-Sandoz" },
  { value: "100303", label: "Calcort" },
  { value: "102900", label: "calfovit" },
  { value: "100304", label: "Calfovit D3" },
  { value: "100305", label: "Calgel" },
  { value: "100306", label: "Calmurid" },
  { value: "100307", label: "Calmurid HC" },
  { value: "100308", label: "Calogen" },
  { value: "100309", label: "Caloreen" },
  { value: "102901", label: "calpol" },
  { value: "100310", label: "Calpol Paediatric" },
  { value: "102902", label: "Calquence" },
  { value: "100311", label: "Calshake" },
  { value: "400", label: "Calsynar" },
  { value: "100312", label: "CAM" },
  { value: "102903", label: "camazepam" },
  { value: "100313", label: "Camcolit" },
  { value: "102904", label: "camostat" },
  { value: "401", label: "Campath" },
  { value: "100314", label: "Camphor" },
  { value: "102905", label: "camphora" },
  { value: "102906", label: "campral" },
  { value: "100315", label: "Campral EC" },
  { value: "100316", label: "Campto" },
  { value: "102907", label: "camylofin" },
  { value: "102908", label: "camylofin and analgesics" },
  { value: "100317", label: "Canagliflozin" },
  { value: "102909", label: "canakinumab" },
  { value: "100318", label: "Cancidas" },
  { value: "402", label: "Candazole" },
  { value: "102910", label: "candersartan" },
  { value: "102911", label: "candersartan cilexetil" },
  { value: "100319", label: "Candesartan" },
  { value: "102912", label: "candesartan and diuretics" },
  { value: "403", label: "Candesartan Ciletexil" },
  { value: "100320", label: "Candesartan Cilexetil" },
  { value: "102913", label: "candesrsartan" },
  { value: "102914", label: "candesrsartan ciletexil" },
  { value: "102915", label: "candicidin" },
  { value: "102916", label: "canestan" },
  { value: "102917", label: "canesten" },
  { value: "100321", label: "Canesten Cream" },
  { value: "100322", label: "Canesten Pessary" },
  { value: "100323", label: "Canesten Solution" },
  { value: "100324", label: "Canesten-HC" },
  { value: "100325", label: "Cannabidiol" },
  { value: "102918", label: "cannabinoids" },
  { value: "102919", label: "Cannabis extract" },
  { value: "102920", label: "canrenone" },
  { value: "100326", label: "Canusal" },
  { value: "100327", label: "Capasal" },
  { value: "100328", label: "Capastat" },
  { value: "404", label: "Capecitabine" },
  { value: "102921", label: "Capexion" },
  { value: "100329", label: "Caphosol" },
  { value: "102922", label: "Capimune" },
  { value: "102923", label: "caplacizumab" },
  { value: "405", label: "Capoten" },
  { value: "406", label: "Capozide" },
  { value: "102924", label: "Caprelsa" },
  { value: "100330", label: "Capreomycin" },
  { value: "100331", label: "Caprilon" },
  { value: "100332", label: "Caprin" },
  { value: "407", label: "Capsaicin" },
  { value: "102925", label: "capsicum" },
  { value: "100333", label: "Capsicum Oleoresin" },
  { value: "102926", label: "Capsorin" },
  { value: "102927", label: "captodiame" },
  { value: "408", label: "Captopril" },
  { value: "102928", label: "captopril and diuretics" },
  {
    value: "102929",
    label:
      "Captopril with hydrochlorothiazide 12.5mg/25mg & 25mg/50mg (Co-zidocapt)",
  },
  { value: "409", label: "Carace" },
  { value: "100334", label: "Carace 10 Plus" },
  { value: "102930", label: "carace 20 plus" },
  { value: "100335", label: "Carace Plus" },
  { value: "100336", label: "Caralpha" },
  { value: "102931", label: "Caramet" },
  { value: "102932", label: "carbachol" },
  { value: "102933", label: "Carbagen" },
  { value: "102934", label: "Carbagen SR" },
  { value: "100337", label: "Carbaglu" },
  { value: "410", label: "Carbamazepine" },
  { value: "102935", label: "carbamide" },
  { value: "102936", label: "carbamide, combinations" },
  { value: "102937", label: "carbasalate calcium" },
  {
    value: "102938",
    label: "carbasalate calcium combinations excl. psycholeptics",
  },
  { value: "102939", label: "carbazochrome" },
  { value: "102940", label: "carbenicillin" },
  { value: "102941", label: "carbenoxolone" },
  { value: "102942", label: "carbenoxolone, combinations excl. psycholeptics" },
  { value: "102943", label: "carbenoxolone, combinations with psycholeptics" },
  { value: "100338", label: "Carbetocin" },
  { value: "411", label: "Carbidopa" },
  { value: "412", label: "Carbimazole" },
  { value: "102944", label: "carbinoxamine" },
  { value: "413", label: "Carbocisteine" },
  { value: "102945", label: "carbocromen" },
  { value: "100339", label: "Carbo-Dome" },
  { value: "102946", label: "carbohydrates" },
  { value: "414", label: "Carbomer" },
  { value: "102947", label: "carbon dioxide" },
  { value: "102948", label: "carbon dioxide producing drugs" },
  { value: "415", label: "Carboplatin" },
  { value: "100340", label: "Carboprost" },
  { value: "102949", label: "carboquone" },
  { value: "102950", label: "carbromal" },
  { value: "102951", label: "carbutamide" },
  { value: "102952", label: "carbuterol" },
  { value: "416", label: "Cardene" },
  { value: "100341", label: "Cardene SR" },
  { value: "417", label: "Cardensiel" },
  { value: "418", label: "Cardicor" },
  { value: "102953", label: "Cardide" },
  { value: "102954", label: "cardide sr" },
  { value: "102955", label: "cardioplegia solutions" },
  { value: "419", label: "Cardioplen" },
  { value: "100342", label: "Cardioplen XL" },
  { value: "100343", label: "Cardioxane" },
  { value: "420", label: "Cardipril" },
  { value: "421", label: "Cardoxin" },
  { value: "102956", label: "cardozin" },
  { value: "422", label: "Cardozin XL" },
  { value: "423", label: "Cardura" },
  { value: "100344", label: "Cardura XL" },
  { value: "424", label: "Carduran" },
  { value: "425", label: "Cardyl" },
  { value: "100345", label: "Care Olive Oil Ear Drops" },
  { value: "100346", label: "Care Virasoothe" },
  { value: "102957", label: "carfecillin" },
  { value: "102958", label: "carfilzomib" },
  { value: "102959", label: "carglumic" },
  { value: "100347", label: "Carglumic acid" },
  { value: "102960", label: "carindacillin" },
  { value: "102961", label: "carisbamate" },
  { value: "102962", label: "carisoprodol" },
  { value: "102963", label: "carisoprodol, combinations excl. psycholeptics" },
  { value: "102964", label: "carisoprodol, combinations with psycholeptics" },
  { value: "426", label: "Carloc" },
  { value: "102965", label: "carmellose" },
  { value: "100348", label: "Carmellose sodium" },
  { value: "102966", label: "carmofur" },
  { value: "102967", label: "carmustine" },
  { value: "102968", label: "caroverine" },
  { value: "427", label: "Carteolol" },
  { value: "102969", label: "carteolol, combinations" },
  { value: "428", label: "Carvedilol" },
  { value: "102970", label: "cascara" },
  { value: "102971", label: "cascara, combinations" },
  { value: "429", label: "Casodex" },
  { value: "102972", label: "casopitant" },
  { value: "100349", label: "Caspofungin" },
  { value: "102973", label: "castor" },
  { value: "100350", label: "Castor Oil" },
  { value: "100351", label: "Catacrom" },
  { value: "430", label: "Catapres" },
  { value: "102974", label: "cathine" },
  { value: "102975", label: "cation exchange resins" },
  { value: "102976", label: "catumaxomab" },
  { value: "102977", label: "caverject" },
  { value: "100352", label: "Caverject Dual Chamber" },
  { value: "100353", label: "Cayston" },
  { value: "102978", label: "ceanel" },
  { value: "100354", label: "Ceanel Conc." },
  { value: "102979", label: "cedocard" },
  { value: "100355", label: "Cedocard retard" },
  { value: "102980", label: "cefacetrile" },
  { value: "100356", label: "Cefaclor" },
  { value: "431", label: "Cefadroxil" },
  { value: "432", label: "Cefalexin" },
  { value: "102981", label: "cefaloridine" },
  { value: "102982", label: "cefalotin" },
  { value: "102983", label: "cefamandole" },
  { value: "102984", label: "cefapirin" },
  { value: "102985", label: "cefatrizine" },
  { value: "102986", label: "cefazedone" },
  { value: "102987", label: "cefazolin" },
  { value: "102988", label: "cefcapene" },
  { value: "102989", label: "cefdinir" },
  { value: "102990", label: "cefditoren" },
  { value: "102991", label: "cefepime" },
  { value: "102992", label: "cefetamet" },
  { value: "100357", label: "Cefixime" },
  { value: "102993", label: "cefmenoxime" },
  { value: "102994", label: "cefmetazole" },
  { value: "102995", label: "cefodizime" },
  { value: "102996", label: "cefonicid" },
  { value: "102997", label: "cefoperazone" },
  { value: "102998", label: "cefoperazone, combinations" },
  { value: "102999", label: "ceforanide" },
  { value: "100358", label: "Cefotaxime" },
  { value: "103000", label: "cefotetan" },
  { value: "103001", label: "cefotiam" },
  { value: "103002", label: "cefoxitin" },
  { value: "103003", label: "cefozopran" },
  { value: "103004", label: "cefpiramide" },
  { value: "103005", label: "cefpirome" },
  { value: "100359", label: "Cefpodoxime" },
  { value: "103006", label: "cefprozil" },
  { value: "433", label: "Cefradine" },
  { value: "103007", label: "cefroxadine" },
  { value: "103008", label: "cefsulodin" },
  { value: "103009", label: "ceftaroline fosamil" },
  { value: "100360", label: "Ceftazidime" },
  { value: "103010", label: "ceftezole" },
  { value: "103011", label: "ceftibuten" },
  { value: "103012", label: "ceftizoxime" },
  { value: "103013", label: "ceftobiprole medocaril" },
  { value: "100361", label: "Ceftriaxone" },
  { value: "103014", label: "ceftriaxone, combinations" },
  { value: "100362", label: "Cefuroxime" },
  {
    value: "103015",
    label: "cefuroxime, combinations with other antibacterials",
  },
  { value: "100363", label: "Celance" },
  { value: "434", label: "Celebrex" },
  { value: "435", label: "Celecoxib" },
  { value: "436", label: "Celectol" },
  { value: "100364", label: "Celevac" },
  { value: "437", label: "Celiprolol" },
  { value: "438", label: "Cellcept" },
  { value: "100365", label: "Celluvisc" },
  { value: "100366", label: "Celsentri" },
  { value: "100367", label: "Celvapan" },
  { value: "103016", label: "cemiplimab" },
  { value: "103017", label: "Cenobamate" },
  { value: "103018", label: "centyl" },
  { value: "439", label: "Centyl K" },
  { value: "103019", label: "cephalexin" },
  { value: "100368", label: "Ceplene" },
  { value: "100369", label: "Ceporex" },
  { value: "100370", label: "Ceprotin" },
  { value: "103020", label: "cepton" },
  { value: "100371", label: "Cepton Medicated Skin Wash" },
  { value: "103021", label: "ceratonia" },
  { value: "103022", label: "ceritinib" },
  { value: "103023", label: "cerium oxalate" },
  { value: "103024", label: "cerivastatin" },
  { value: "440", label: "Certican" },
  { value: "103025", label: "certolizumab" },
  { value: "441", label: "Certolizumab pegol" },
  { value: "103026", label: "Certoparin sodium" },
  { value: "103027", label: "ceruletide" },
  { value: "100372", label: "Cerumol" },
  { value: "100373", label: "Cervarix" },
  { value: "103028", label: "cetalkonium" },
  { value: "100374", label: "Cetalkonium Chloride" },
  { value: "100375", label: "Cetavlex" },
  { value: "103029", label: "cetiedil" },
  { value: "442", label: "Cetirizine" },
  { value: "100376", label: "Cetraben" },
  { value: "100377", label: "Cetrimide" },
  { value: "103030", label: "cetrimonium" },
  { value: "100378", label: "Cetrorelix" },
  { value: "100379", label: "Cetrotide" },
  { value: "103031", label: "cetuximab" },
  { value: "103032", label: "cetylpyridinium" },
  { value: "100380", label: "Cetylpyridinium Chloride" },
  { value: "103033", label: "cevimeline" },
  { value: "443", label: "Champix" },
  { value: "100381", label: "Charcoal" },
  { value: "100382", label: "Charcodote" },
  { value: "444", label: "Chemydur" },
  { value: "103034", label: "chemydur 60x" },
  { value: "100383", label: "Chemydur 60XL" },
  { value: "103035", label: "chenodeoxycholic acid" },
  { value: "103036", label: "chiniofon" },
  { value: "103037", label: "Chlomethiazole" },
  { value: "103038", label: "Chloractil" },
  { value: "103039", label: "chloral" },
  { value: "103040", label: "Chloral betaine" },
  { value: "100384", label: "Chloral hydrate" },
  { value: "103041", label: "chloralodol" },
  { value: "445", label: "Chlorambucil" },
  { value: "446", label: "Chloramphenicol" },
  { value: "100385", label: "Chloraprep" },
  { value: "103042", label: "chlorbenzoxamine" },
  { value: "103043", label: "chlorcyclizine" },
  { value: "447", label: "Chlordiazepoxide" },
  { value: "448", label: "Chlorhexidine" },
  { value: "100386", label: "Chlorhexidine gluconate" },
  { value: "103044", label: "chlorhexidine, combinations" },
  { value: "449", label: "Chloripramine" },
  { value: "103045", label: "chlormadinone" },
  { value: "103046", label: "Chlormethiazole" },
  { value: "103047", label: "Chlormethiazole base (capsules)" },
  { value: "103048", label: "Chlormethiazole edisylate (syrup)" },
  { value: "103049", label: "chlormethine" },
  { value: "103050", label: "chlormezanone" },
  { value: "103051", label: "chlormezanone, combinations excl. psycholeptics" },
  { value: "103052", label: "chlormezanone, combinations with psycholeptics" },
  { value: "103053", label: "chlormidazole" },
  { value: "100387", label: "Chlorobutanol" },
  { value: "103054", label: "chlorobutanol, combinations" },
  { value: "103055", label: "chloroform" },
  { value: "100388", label: "Chloromycetin" },
  { value: "103056", label: "chloroprednisone and antiinfectives" },
  { value: "103057", label: "chloroprocaine" },
  { value: "103058", label: "chloropyramine" },
  { value: "103059", label: "chloropyramine, combinations" },
  { value: "450", label: "Chloroquine" },
  { value: "103060", label: "chlorothiazide" },
  { value: "103061", label: "chlorothiazide, combinations" },
  { value: "103062", label: "chlorotrianisene" },
  { value: "100389", label: "Chloroxylenol" },
  { value: "451", label: "Chlorphenamine" },
  { value: "103063", label: "chlorphenamine, combinations" },
  { value: "103064", label: "chlorphenesin" },
  { value: "103065", label: "Chlorpheniramine" },
  { value: "103066", label: "chlorphenoxamine" },
  { value: "103067", label: "chlorphenoxamine, combinations" },
  { value: "103068", label: "chlorproethazine" },
  { value: "452", label: "Chlorpromazine" },
  { value: "103069", label: "Chlorpromazine HCI" },
  { value: "103070", label: "Chlorpromazine Hydrochloride" },
  { value: "100390", label: "Chlorpropamide" },
  { value: "103071", label: "chlorprothixene" },
  { value: "103072", label: "chlorquinaldol" },
  { value: "453", label: "Chlortalidone" },
  { value: "103073", label: "chlortalidone and potassium-sparing agents" },
  { value: "103074", label: "chlortetracycline" },
  { value: "103075", label: "Chlorthalidone" },
  { value: "103076", label: "chlorzoxazone" },
  { value: "103077", label: "chlorzoxazone, combinations excl. psycholeptics" },
  { value: "103078", label: "chlorzoxazone, combinations with psycholeptics" },
  {
    value: "103079",
    label:
      "cholera, combinations with typhoid vaccine, inactivated, whole cell",
  },
  { value: "103080", label: "cholera, inactivated, whole cell" },
  { value: "103081", label: "cholera, live attenuated" },
  { value: "454", label: "Cholestagel" },
  { value: "103082", label: "cholesterol" },
  { value: "100391", label: "Cholesterol treatment - Other" },
  { value: "455", label: "Cholestin" },
  { value: "103083", label: "Cholestyramine" },
  { value: "103084", label: "Cholib" },
  { value: "103085", label: "cholic acid" },
  { value: "103086", label: "choline" },
  { value: "103087", label: "choline alfoscerate" },
  { value: "103088", label: "choline fenofibrate" },
  { value: "100392", label: "Choline Salicylate" },
  { value: "103089", label: "choline theophyllinate" },
  { value: "103090", label: "choline theophyllinate and adrenergics" },
  { value: "103091", label: "cholinesterase" },
  { value: "103092", label: "chondrocytes, autologous" },
  { value: "103093", label: "chondroitin sulfate" },
  { value: "103094", label: "chondroitin sulfate-iron complex" },
  { value: "100393", label: "Choragon" },
  { value: "103095", label: "choriogonadotropin" },
  { value: "100394", label: "Choriogonadotropin alfa" },
  { value: "103096", label: "chorionic" },
  { value: "100395", label: "Chorionic gonadotrophin" },
  { value: "103097", label: "chromium (51Cr) chromate labelled cells" },
  { value: "103098", label: "chromium (51Cr) edetate" },
  { value: "103099", label: "chymopapain" },
  { value: "103100", label: "chymotrypsin" },
  { value: "456", label: "Cialis" },
  { value: "103101", label: "cibenzoline" },
  { value: "103102", label: "Cibinqo" },
  { value: "103103", label: "Cibral" },
  { value: "103104", label: "cibral xl" },
  { value: "457", label: "Ciclesonide" },
  { value: "103105", label: "cicletanine" },
  { value: "103106", label: "ciclobendazole" },
  { value: "458", label: "Ciclofalina" },
  { value: "103107", label: "ciclonicate" },
  { value: "103108", label: "ciclonium and analgesics" },
  { value: "103109", label: "ciclopirox" },
  { value: "459", label: "Ciclosporin" },
  { value: "460", label: "Cidine" },
  { value: "100396", label: "Cidofovir" },
  { value: "103110", label: "cidomycin" },
  { value: "100397", label: "Cidomycin Paediatric" },
  { value: "103111", label: "cilansetron" },
  { value: "100398", label: "Cilastatin" },
  { value: "461", label: "Cilazapril" },
  { value: "103112", label: "cilazapril and diuretics" },
  { value: "462", label: "Cilift" },
  { value: "103113", label: "cilnidipine" },
  { value: "463", label: "Cilostazol" },
  { value: "100399", label: "Ciloxan" },
  { value: "464", label: "Cimetidine" },
  { value: "103114", label: "cimetidine, combinations" },
  { value: "103115", label: "cimetropium bromide" },
  { value: "465", label: "Cimzia" },
  { value: "100400", label: "Cinacalcet" },
  { value: "466", label: "Cinchocaine" },
  { value: "103116", label: "cinchophen" },
  { value: "103117", label: "cinepazet" },
  { value: "103118", label: "cinepazide" },
  { value: "467", label: "Cinitapride" },
  { value: "103119", label: "cinnamic" },
  { value: "100401", label: "Cinnamic Acid" },
  { value: "468", label: "Cinnarizine" },
  { value: "103120", label: "cinnarizine, combinations" },
  { value: "103121", label: "cinolazepam" },
  { value: "103122", label: "cinoxacin" },
  { value: "103123", label: "Cinqaero" },
  { value: "103124", label: "cinryze" },
  { value: "469", label: "Cipralex" },
  { value: "100402", label: "Cipramil" },
  { value: "470", label: "Ciprofibrate" },
  { value: "471", label: "Ciprofloxacin" },
  { value: "472", label: "Ciproxin" },
  { value: "100403", label: "Circadin" },
  { value: "103125", label: "cisapride" },
  { value: "100404", label: "Cisatracurium" },
  { value: "473", label: "Cisplatin" },
  { value: "474", label: "Citalopram" },
  { value: "103126", label: "Citalopram Hydrobromide" },
  { value: "100405", label: "Citanest" },
  { value: "103127", label: "citicoline" },
  { value: "103128", label: "citiolone" },
  { value: "100406", label: "Citramag" },
  { value: "103129", label: "citric" },
  { value: "100407", label: "Citric Acid" },
  { value: "100408", label: "Cladribine" },
  { value: "100409", label: "Clairette" },
  { value: "100410", label: "Clarelux" },
  { value: "475", label: "Clarithromycin" },
  { value: "103130", label: "clavulanic" },
  { value: "100411", label: "Clavulanic Acid" },
  { value: "103131", label: "clebopride" },
  { value: "103132", label: "clefamide" },
  { value: "100412", label: "Clemastine" },
  { value: "103133", label: "clemastine, combinations" },
  { value: "103134", label: "clenbuterol" },
  { value: "103135", label: "clenil" },
  { value: "476", label: "Clenil Modulite" },
  { value: "477", label: "Cleocin" },
  { value: "103136", label: "clevidipine" },
  { value: "103137", label: "clevudine" },
  { value: "478", label: "Clexane" },
  { value: "103138", label: "clidinium and psycholeptics" },
  { value: "100413", label: "Climagest" },
  { value: "100414", label: "Climanor" },
  { value: "479", label: "Climaval" },
  { value: "480", label: "Climesse" },
  { value: "481", label: "Clindamycin" },
  { value: "103139", label: "clindamycin, combinations" },
  { value: "100415", label: "Clinitas" },
  { value: "100416", label: "Clinorette" },
  { value: "482", label: "Clioquinol" },
  { value: "103140", label: "clioquinol, combinations" },
  { value: "100417", label: "Clipper" },
  { value: "103141", label: "Clivarin" },
  { value: "483", label: "Clobazam" },
  { value: "103142", label: "clobenzorex" },
  { value: "484", label: "Clobetasol" },
  { value: "103143", label: "clobetasol and antibiotics" },
  { value: "100418", label: "Clobetasol Propionate" },
  { value: "485", label: "Clobetasone" },
  { value: "103144", label: "clobetasone and antiinfectives" },
  { value: "100419", label: "Clobetasone butyrate" },
  { value: "103145", label: "clobutinol" },
  { value: "103146", label: "clocortolone" },
  { value: "103147", label: "clodantoin" },
  { value: "486", label: "Clodronate" },
  { value: "103148", label: "clodronic acid" },
  { value: "100420", label: "Clofarabine" },
  { value: "103149", label: "clofazimine" },
  { value: "103150", label: "clofedanol" },
  { value: "103151", label: "clofenamide" },
  { value: "103152", label: "clofenotane" },
  { value: "103153", label: "clofenotane, combinations" },
  { value: "103154", label: "clofezone" },
  { value: "103155", label: "clofibrate" },
  { value: "103156", label: "clofibride" },
  { value: "103157", label: "clofoctol" },
  { value: "100421", label: "Clomethiazole" },
  { value: "103158", label: "clomethiazole, combinations" },
  { value: "103159", label: "clometocillin" },
  { value: "100422", label: "Clomid" },
  { value: "100423", label: "Clomifene" },
  { value: "487", label: "Clomipramine" },
  { value: "103160", label: "Clomipramine Hydrochloride" },
  { value: "103161", label: "clomocycline" },
  { value: "488", label: "Clonazepam" },
  { value: "489", label: "Clonidine" },
  { value: "103162", label: "clonidine and diuretics" },
  {
    value: "103163",
    label: "clonidine and diuretics, combinations with other drugs",
  },
  { value: "100424", label: "Clonidine hydrochloride" },
  { value: "100425", label: "Clopamide" },
  { value: "103164", label: "clopenthixol" },
  { value: "103165", label: "cloperastine" },
  { value: "490", label: "Clopidogrel" },
  { value: "100426", label: "Clopixol" },
  { value: "103166", label: "Clopixol acuphase" },
  { value: "103167", label: "cloprednol" },
  { value: "103168", label: "cloral" },
  { value: "491", label: "Cloral Betaine" },
  { value: "103169", label: "cloranolol" },
  { value: "103170", label: "clorexolone" },
  { value: "103171", label: "clorexolone, comb. with psycholeptics" },
  { value: "103172", label: "cloricromen" },
  { value: "103173", label: "cloridarol" },
  { value: "103174", label: "clorindione" },
  { value: "103175", label: "clotam" },
  { value: "100427", label: "Clotam Rapid" },
  { value: "103176", label: "clotiapine" },
  { value: "103177", label: "clotiazepam" },
  { value: "492", label: "Clotrimazole" },
  { value: "103178", label: "cloxacillin" },
  { value: "103179", label: "cloxazolam" },
  { value: "493", label: "Clozapine" },
  { value: "103180", label: "Clozaril" },
  { value: "103181", label: "coaguchek" },
  { value: "100434", label: "CoaguChek PT" },
  { value: "103182", label: "coaguchek xs pt" },
  { value: "103183", label: "coagulation factor IX" },
  {
    value: "103184",
    label: "coagulation factor IX, II, VII and X in combination",
  },
  { value: "103185", label: "coagulation factor VII" },
  { value: "103186", label: "coagulation factor VIII" },
  { value: "103187", label: "coagulation factor XIII" },
  { value: "100435", label: "Coal tar" },
  { value: "494", label: "Co-amilofruse" },
  { value: "103188", label: "Co-Amilofruse 2.5/20" },
  { value: "495", label: "Co-amilozide" },
  { value: "103189", label: "Co-Amilozide 2.5/25" },
  { value: "496", label: "Co-Amoxiclav" },
  { value: "103190", label: "Co-amoxiclav 375mg" },
  { value: "103191", label: "Co-amoxiclav 625mg" },
  { value: "497", label: "CoAprovel" },
  { value: "103192", label: "Cobalin-H" },
  { value: "103193", label: "cobalt (57Co) cyanocobalamine" },
  { value: "103194", label: "cobalt (58Co) cyanocobalamine" },
  { value: "103195", label: "cobamamide" },
  { value: "498", label: "Co-beneldopa" },
  { value: "103196", label: "Co-beneldopa 12.5mg/50mg" },
  { value: "103197", label: "Co-beneldopa 25mg/100mg" },
  { value: "103198", label: "Co-beneldopa 50mg/200mg" },
  { value: "103199", label: "Co-beneldopa MR 25mg/100mg" },
  { value: "100428", label: "Co-Betaloc" },
  { value: "103200", label: "cobicistat" },
  { value: "103201", label: "cocaine" },
  { value: "499", label: "Co-careldopa" },
  { value: "103202", label: "Co-careldopa 10mg/100mg" },
  { value: "103203", label: "Co-careldopa 12.5mg/50mg" },
  { value: "103204", label: "Co-careldopa 25mg/100mg" },
  { value: "103205", label: "Co-careldopa 25mg/250mg" },
  { value: "103206", label: "Co-careldopa MR 25mg/100mg" },
  { value: "103207", label: "Co-careldopa MR 50mg/200mg" },
  { value: "500", label: "Co-Codamol" },
  { value: "103208", label: "Co-codamol 60mg/1000mg" },
  { value: "103209", label: "Co-codamol 8mg/500mg & 30mg/500mg" },
  { value: "100429", label: "Co-Codaprin" },
  { value: "103210", label: "Co-codaprin 8mg/400mg" },
  { value: "100436", label: "Cocois" },
  { value: "100437", label: "Cod Liver Oil" },
  { value: "501", label: "Co-danthramer" },
  { value: "103211", label: "Co-danthramer 25/200" },
  { value: "103212", label: "Co-danthramer 25/200/5ml liquid" },
  { value: "103213", label: "Co-danthramer 37.5/500" },
  { value: "103214", label: "Co-danthramer 75mg/1000mg/5ml Liquid" },
  { value: "502", label: "Co-danthrusate" },
  { value: "103215", label: "Co-danthrusate 50mg/60mg" },
  { value: "103216", label: "Co-danthrusate 50mg/60mg liquid" },
  { value: "503", label: "Codeine" },
  { value: "100438", label: "Codeine Phosphate" },
  { value: "103217", label: "codeine, combinations excl. psycholeptics" },
  { value: "103218", label: "codeine, combinations with psycholeptics" },
  { value: "504", label: "Codeisan" },
  { value: "505", label: "Co-diovan" },
  { value: "506", label: "Codipar" },
  { value: "103219", label: "Codis" },
  { value: "507", label: "Co-dydramol" },
  { value: "103220", label: "Co-dydramol 10mg/500mg" },
  { value: "103221", label: "Co-dydramol 20mg/500mg (Remedeine)" },
  { value: "103222", label: "Co-dydramol 30mg/500mg (Remedeine Forte)" },
  { value: "100430", label: "Co-Fluampicil" },
  { value: "100431", label: "Co-flumactone" },
  { value: "103223", label: "Co-Flumactone 25/25" },
  { value: "508", label: "Colazide" },
  { value: "509", label: "Colchicine" },
  { value: "510", label: "Colecalciferol" },
  { value: "511", label: "Colesevelam" },
  { value: "512", label: "Colestid" },
  { value: "513", label: "Colestipol" },
  { value: "514", label: "Colestyramine" },
  { value: "103224", label: "colextran" },
  { value: "103225", label: "colfosceril palmitate" },
  { value: "100439", label: "Colifoam" },
  { value: "103226", label: "colistimethate" },
  { value: "100440", label: "Colistimethate sodium" },
  { value: "515", label: "Colistin" },
  { value: "100441", label: "Collagen" },
  { value: "103227", label: "collagen, combinations" },
  { value: "103228", label: "collagenase" },
  { value: "103229", label: "collagenase clostridium histolyticum" },
  { value: "103230", label: "collagenase, combinations" },
  { value: "516", label: "Colofac" },
  { value: "100442", label: "Colofac MR" },
  { value: "517", label: "Colomycin" },
  { value: "518", label: "Colpermin" },
  { value: "519", label: "Co-magaldrox" },
  {
    value: "103231",
    label:
      "comb. of rauwolfia alkaloids and diuretics incl. other combinations",
  },
  { value: "100443", label: "Combigan" },
  { value: "103232", label: "combinations" },
  { value: "103233", label: "combinations of barbiturates" },
  { value: "103234", label: "combinations of corticosteroids" },
  { value: "103235", label: "combinations of different antibiotics" },
  { value: "103236", label: "combinations of electrolytes" },
  { value: "103237", label: "combinations of imidazole derivatives" },
  { value: "103238", label: "combinations of levothyroxine and liothyronine" },
  { value: "103239", label: "combinations of penicillins" },
  { value: "103240", label: "combinations of rauwolfia alkaloids" },
  {
    value: "103241",
    label: "combinations of rauwolfia alkoloids, combinations",
  },
  { value: "103242", label: "combinations of sulfonamides" },
  { value: "103243", label: "combinations of tetracyclines" },
  { value: "103244", label: "combinations of xanthines" },
  { value: "520", label: "Combivent" },
  { value: "100444", label: "Combivent UDV" },
  { value: "521", label: "Combivir" },
  { value: "100445", label: "Combodart" },
  { value: "103245", label: "Cometriq" },
  { value: "522", label: "Competact" },
  { value: "103246", label: "compound" },
  { value: "100446", label: "Compound macrogol oral powder" },
  { value: "523", label: "Comtess" },
  { value: "103247", label: "concerta" },
  { value: "100447", label: "Concerta XL" },
  { value: "103248", label: "Concor" },
  { value: "100448", label: "Condyline" },
  { value: "103249", label: "conestat" },
  { value: "103250", label: "conestat alfa" },
  { value: "103251", label: "confidence" },
  { value: "100449", label: "Confidence Rings" },
  { value: "524", label: "Congescor" },
  { value: "103252", label: "conivaptan" },
  { value: "103253", label: "conjugated estrogens" },
  { value: "100450", label: "Conotrane" },
  { value: "103254", label: "Constella" },
  { value: "103255", label: "contact laxatives in combination" },
  {
    value: "103256",
    label: "contact laxatives in combination with belladonna alkaloids",
  },
  { value: "103257", label: "ContiFlo" },
  { value: "100451", label: "Contiflo XL" },
  { value: "100452", label: "Contigen" },
  { value: "100453", label: "Convulex" },
  { value: "525", label: "Copaxone" },
  { value: "100454", label: "Copegus" },
  { value: "526", label: "Co-phenotrope" },
  { value: "103258", label: "copper oleinate" },
  { value: "103259", label: "copper sulfate" },
  { value: "103260", label: "copper usnate" },
  { value: "100432", label: "Co-Prenozide" },
  { value: "527", label: "Co-proxamol" },
  { value: "103261", label: "Co-proxamol Suspension" },
  { value: "528", label: "Coracten" },
  { value: "100455", label: "Coracten SR" },
  { value: "100456", label: "Coracten XL" },
  { value: "103262", label: "cordarone" },
  { value: "529", label: "Cordarone X" },
  { value: "103263", label: "Cordilox" },
  { value: "530", label: "Coreg" },
  { value: "531", label: "Corgard" },
  { value: "103264", label: "corifollitropin" },
  { value: "100457", label: "Corifollitropin alfa" },
  { value: "100458", label: "Corlan" },
  { value: "103265", label: "corodil" },
  { value: "532", label: "Corodil Comp" },
  { value: "100459", label: "Coro-Nitro" },
  { value: "100460", label: "Coro-Nitro Pump Spray" },
  { value: "533", label: "Coropres" },
  { value: "100461", label: "Corsodyl" },
  { value: "103266", label: "corticorelin" },
  { value: "103267", label: "corticotropin" },
  { value: "100462", label: "Cortisone" },
  { value: "103268", label: "cortivazol" },
  { value: "103269", label: "Cosentyx" },
  { value: "534", label: "Co-simalcite" },
  { value: "103270", label: "cosmegen" },
  { value: "100463", label: "Cosmegen Lyovac" },
  { value: "100464", label: "CosmoFer" },
  { value: "100465", label: "Cosopt" },
  { value: "535", label: "Cotareg" },
  { value: "536", label: "Co-tenidone" },
  { value: "537", label: "Co-triamterzide" },
  { value: "103271", label: "Co-Triamterzide 50/25" },
  { value: "538", label: "Co-trimoxazole" },
  { value: "103272", label: "Co-trimoxazole 480mg" },
  { value: "103273", label: "Co-trimoxazole 960mg" },
  { value: "103274", label: "cough suppressants and expectorants" },
  { value: "103275", label: "cough suppressants and mucolytics" },
  { value: "539", label: "Coumadin" },
  { value: "100466", label: "Covermark" },
  { value: "540", label: "Coversyl" },
  { value: "100467", label: "Coversyl Arginine" },
  { value: "100468", label: "Coversyl Arginine Plus" },
  { value: "100469", label: "Coversyl Plus" },
  { value: "541", label: "Cozaar" },
  { value: "542", label: "Cozaar-Comp" },
  { value: "100470", label: "Cozaar-Comp 50/12.5" },
  { value: "100433", label: "Co-Zidocapt" },
  { value: "103276", label: "crataegus glycosides" },
  { value: "103277", label: "creatinolfosfate" },
  { value: "543", label: "Creon" },
  { value: "100471", label: "Creon 10000" },
  { value: "103278", label: "creosote" },
  { value: "544", label: "Crestor" },
  { value: "103279", label: "crilanomer" },
  { value: "100472", label: "Crinone" },
  { value: "100473", label: "Crixivan" },
  { value: "103280", label: "crizanlizumab" },
  { value: "103281", label: "crizotinib" },
  { value: "103282", label: "crocin" },
  { value: "103283", label: "cromoglicic acid" },
  { value: "103284", label: "cromoglicic acid, combinations" },
  { value: "103285", label: "crospovidone" },
  { value: "100474", label: "Crotamiton" },
  { value: "100475", label: "Cryogesic" },
  { value: "100476", label: "Crystacide" },
  { value: "100477", label: "Crystapen" },
  { value: "545", label: "CTD" },
  { value: "100478", label: "Cubicin" },
  { value: "100479", label: "Cuplex" },
  { value: "100480", label: "Curatoderm" },
  { value: "100481", label: "Curosurf" },
  { value: "100482", label: "Cutivate" },
  { value: "100483", label: "CX Powder" },
  { value: "103286", label: "cyamemazine" },
  { value: "546", label: "Cyanocobalamin" },
  { value: "103287", label: "cyanocobalamin tannin complex" },
  { value: "103288", label: "cyanocobalamin, combinations" },
  { value: "103289", label: "cyclandelate" },
  { value: "100484", label: "Cyclimorph" },
  { value: "547", label: "Cyclizine" },
  { value: "103290", label: "cyclizine, combinations" },
  { value: "103291", label: "cyclobarbital" },
  { value: "103292", label: "cyclobenzaprine" },
  { value: "103293", label: "cyclobutyrol" },
  { value: "103294", label: "cyclofenil" },
  { value: "100486", label: "Cyclogest" },
  { value: "103295", label: "cycloguanil embonate" },
  { value: "103296", label: "cyclopentamine" },
  { value: "548", label: "Cyclopenthiazide" },
  { value: "103297", label: "cyclopenthiazide and potassium-sparing agents" },
  { value: "100487", label: "Cyclopentolate" },
  { value: "549", label: "Cyclophosphamide" },
  { value: "103298", label: "cyclo-progynova" },
  { value: "100485", label: "Cyclo-Progynova 2mg" },
  { value: "103299", label: "cycloserine" },
  { value: "550", label: "Cyclosporin" },
  { value: "103300", label: "Cyclosporine" },
  { value: "103301", label: "cyclothiazide" },
  { value: "103302", label: "cyfluthrin" },
  { value: "103303", label: "cyklokapron" },
  { value: "100488", label: "Cyklokapron Injection" },
  { value: "100489", label: "Cyklokapron Tablets" },
  { value: "103304", label: "cymarin" },
  { value: "551", label: "Cymbalta" },
  { value: "100490", label: "Cymevene" },
  { value: "103305", label: "cypermethrin" },
  { value: "100491", label: "Cyproheptadine" },
  { value: "100492", label: "Cyprostat" },
  { value: "100493", label: "Cyproterone" },
  { value: "552", label: "Cyproterone Acetate" },
  { value: "100494", label: "Cystadane" },
  { value: "100495", label: "Cystagon" },
  { value: "103306", label: "cystine" },
  { value: "100496", label: "Cystine AA Supplement" },
  { value: "100497", label: "Cystrin" },
  { value: "103307", label: "Cytacon" },
  { value: "103308", label: "Cytamen" },
  { value: "100498", label: "Cytarabine" },
  { value: "103309", label: "cytomegalovirus immunoglobulin" },
  { value: "100499", label: "Cytotec" },
  { value: "100501", label: "Dabigatran" },
  { value: "100502", label: "Dabigatran etexilate" },
  { value: "103310", label: "dabrafenib" },
  { value: "553", label: "Dacadis" },
  { value: "103311", label: "Dacadis MR" },
  { value: "554", label: "Dacarbazine" },
  { value: "103312", label: "daclatasvir" },
  { value: "103313", label: "daclizumab" },
  { value: "103314", label: "dacogen" },
  { value: "103315", label: "dacomitinib" },
  { value: "555", label: "Dacortin" },
  { value: "103316", label: "dactinomycin" },
  { value: "556", label: "Dafiro" },
  { value: "103317", label: "Daklinza" },
  { value: "557", label: "Daktacort" },
  { value: "100503", label: "Daktarin" },
  { value: "100504", label: "Daktarin Oral Gel" },
  { value: "103318", label: "dalacin" },
  { value: "100505", label: "Dalacin C" },
  { value: "100506", label: "Dalacin Cream" },
  { value: "100507", label: "Dalacin T" },
  { value: "103319", label: "dalbavancin" },
  { value: "558", label: "Dalteparin" },
  { value: "100508", label: "Dalteparin Sodium" },
  { value: "103320", label: "danaparoid" },
  { value: "100509", label: "Danaparoid sodium" },
  { value: "559", label: "Danazol" },
  { value: "100510", label: "Danol" },
  { value: "100511", label: "Dantrium" },
  { value: "103321", label: "dantrium sodium" },
  { value: "560", label: "Dantrolene" },
  { value: "100512", label: "Dantrolene sodium" },
  { value: "100513", label: "Dantron" },
  { value: "103322", label: "dantron, combinations" },
  { value: "103323", label: "dantron, incl. combinations" },
  { value: "561", label: "Daonil" },
  { value: "100514", label: "Dapagliflozin" },
  { value: "103324", label: "dapiprazole" },
  { value: "103325", label: "dapoxetine" },
  { value: "562", label: "Dapsone" },
  { value: "100515", label: "Daptomycin" },
  { value: "100516", label: "Daraprim" },
  { value: "103326", label: "daratumumab" },
  { value: "103327", label: "darbepoetin" },
  { value: "563", label: "Darbepoetin Alfa" },
  { value: "100517", label: "Darifenacin" },
  { value: "103328", label: "darolutamide" },
  { value: "100518", label: "Darunavir" },
  { value: "103329", label: "Darzalex" },
  { value: "103330", label: "dasabuvir" },
  { value: "564", label: "Dasatinib" },
  { value: "100519", label: "Daunorubicin" },
  { value: "100520", label: "Daunoxome" },
  { value: "103331", label: "Daxas" },
  { value: "100521", label: "DDAVP" },
  { value: "100522", label: "DDAVP Nasal Solution" },
  { value: "103332", label: "deanol" },
  { value: "103333", label: "debrisoquine" },
  { value: "100524", label: "Deca-Durabolin" },
  { value: "103334", label: "decamethrin" },
  { value: "103335", label: "Decapeptyl" },
  { value: "100525", label: "Decapeptyl SR" },
  { value: "103336", label: "decitabine" },
  { value: "103337", label: "decubal" },
  { value: "100526", label: "Decubal Clinic" },
  { value: "103338", label: "defanac" },
  { value: "100527", label: "Defanac SR" },
  { value: "100528", label: "Deferasirox" },
  { value: "100529", label: "Deferiprone" },
  { value: "103339", label: "deferoxamine" },
  { value: "103340", label: "defibrillator" },
  { value: "100530", label: "Defibrillator - Implanted" },
  { value: "103341", label: "defibrotide" },
  { value: "103342", label: "defitelio" },
  { value: "565", label: "Deflazacort" },
  { value: "103343", label: "deflazocort" },
  { value: "100531", label: "Degarelix" },
  { value: "103344", label: "Degludec" },
  { value: "103345", label: "delapril" },
  { value: "103346", label: "delapril and diuretics" },
  { value: "103347", label: "delavirdine" },
  { value: "103348", label: "delph" },
  { value: "100532", label: "Delph SPF30" },
  { value: "100533", label: "Deltacortril" },
  { value: "566", label: "Deltacortril Enteric" },
  { value: "100534", label: "Deltastab" },
  { value: "103349", label: "demecarium" },
  { value: "100535", label: "Demeclocycline" },
  { value: "103350", label: "demecolcine" },
  { value: "103351", label: "demegestone" },
  { value: "567", label: "Demerol" },
  { value: "103352", label: "demoxytocin" },
  { value: "103353", label: "denileukin diftitox" },
  { value: "100523", label: "De-Noltab" },
  { value: "100536", label: "Denosumab" },
  { value: "100537", label: "Denzapine" },
  { value: "568", label: "Depakote" },
  { value: "569", label: "Depamine" },
  { value: "103354", label: "Depefex" },
  { value: "103355", label: "Depefex XL" },
  { value: "570", label: "Depixol" },
  { value: "100539", label: "DepoCyte" },
  { value: "100538", label: "Depo-Medrone" },
  { value: "100540", label: "Deponit" },
  { value: "103356", label: "deptropine" },
  { value: "103357", label: "dequalinium" },
  { value: "100541", label: "Dequaspray" },
  { value: "100542", label: "Dermacolor" },
  { value: "100543", label: "Dermalo" },
  { value: "100544", label: "Dermamist" },
  { value: "103358", label: "dermatan sulfate" },
  { value: "103359", label: "dermatonics" },
  { value: "100545", label: "Dermatonics Heel Balm" },
  { value: "103360", label: "dermax" },
  { value: "100546", label: "Dermax Therapeutic Shampoo" },
  { value: "100547", label: "Dermol" },
  { value: "100548", label: "Dermovate" },
  { value: "100549", label: "Dermovate-NN" },
  { value: "103361", label: "desaspidin" },
  { value: "103362", label: "Descovy" },
  { value: "100550", label: "Deseril" },
  { value: "103363", label: "deserpidine" },
  { value: "103364", label: "deserpidine and diuretics" },
  { value: "100551", label: "Desferal" },
  { value: "100552", label: "Desferrioxamine" },
  { value: "103365", label: "desflurane" },
  { value: "103366", label: "desipramine" },
  { value: "103367", label: "desirudin" },
  { value: "103368", label: "Desitrend" },
  { value: "103369", label: "deslanoside" },
  { value: "571", label: "Desloratadine" },
  { value: "103370", label: "Desloratidine" },
  { value: "100553", label: "DesmoMelt" },
  { value: "572", label: "Desmopressin" },
  { value: "573", label: "Desmospray" },
  { value: "100554", label: "Desmotabs" },
  { value: "103371", label: "desogestrel" },
  { value: "103372", label: "desonide" },
  { value: "103373", label: "desonide and antiseptics" },
  { value: "103374", label: "desoximetasone" },
  { value: "103375", label: "desoxycortone" },
  { value: "103376", label: "desoxyribonuclease" },
  { value: "100555", label: "Destolit" },
  { value: "103377", label: "desvenlafaxine" },
  { value: "574", label: "Detemir" },
  { value: "575", label: "Detensiel" },
  { value: "103378", label: "detrol" },
  { value: "576", label: "Detrol LA" },
  { value: "577", label: "Detrunorm" },
  { value: "578", label: "Detrusitol" },
  { value: "579", label: "Dexamethasone" },
  { value: "103379", label: "dexamethasone and antibiotics" },
  { value: "103380", label: "dexamethasone and antiinfectives" },
  { value: "103381", label: "dexamethasone, combinations" },
  { value: "580", label: "Dexamfetamine" },
  { value: "103382", label: "dexbrompheniramine" },
  { value: "103383", label: "dexbrompheniramine, combinations" },
  { value: "103384", label: "dexchlorpheniramine" },
  { value: "103385", label: "dexchlorpheniramine, combinations" },
  { value: "100556", label: "Dexedrine" },
  { value: "100557", label: "Dexeryl" },
  { value: "103386", label: "dexetimide" },
  { value: "103387", label: "dexfenfluramine" },
  { value: "100558", label: "Dexibuprofen" },
  { value: "100559", label: "Deximune" },
  { value: "100560", label: "Dexketoprofen" },
  { value: "103388", label: "dexlansoprazole" },
  { value: "103389", label: "dexmedetomidine" },
  { value: "103390", label: "dexmethylphenidate" },
  { value: "103391", label: "dexpanthenol" },
  { value: "103392", label: "dexrabeprazole" },
  { value: "100561", label: "Dexrazoxane" },
  { value: "100562", label: "Dexsol" },
  { value: "100563", label: "Dextran" },
  { value: "103393", label: "dextranomer" },
  { value: "100564", label: "Dextrogel" },
  { value: "103394", label: "dextromethorphan" },
  { value: "103395", label: "dextromoramide" },
  { value: "103396", label: "dextropropoxyphene" },
  { value: "103397", label: "dextropropoxyphene, comb. excl. psycholeptics" },
  { value: "103398", label: "dextropropoxyphene, comb. with psycholeptics" },
  { value: "100565", label: "Dextrose" },
  { value: "103399", label: "dextrothyroxine" },
  { value: "103400", label: "dezocine" },
  { value: "100566", label: "DF 118 Forte" },
  { value: "100500", label: "D-GAM" },
  { value: "103401", label: "dhc" },
  { value: "100567", label: "DHC Continus" },
  { value: "103402", label: "diabact" },
  { value: "100568", label: "diabact UBT" },
  { value: "100569", label: "Diabetes mellitus - Other Tablet" },
  { value: "581", label: "Diabex" },
  { value: "103403", label: "diacerein" },
  { value: "103404", label: "diacomit" },
  { value: "100570", label: "Diafalk" },
  { value: "582", label: "Diaformin" },
  { value: "583", label: "Diafusor" },
  { value: "103405", label: "Diagemet" },
  { value: "100571", label: "Dialamine" },
  { value: "103406", label: "Dialar" },
  { value: "584", label: "Dialyvit" },
  { value: "585", label: "Diamicron" },
  { value: "100572", label: "Diamicron MR" },
  { value: "100573", label: "Diamorphine" },
  { value: "100574", label: "Diamox" },
  { value: "586", label: "Dianben" },
  { value: "100575", label: "Dianette" },
  { value: "103407", label: "diastase" },
  { value: "103408", label: "diatrizoic acid" },
  { value: "587", label: "Diavan" },
  { value: "100576", label: "Diazemuls" },
  { value: "588", label: "Diazepam" },
  { value: "100577", label: "Diazepam Rectubes" },
  { value: "100578", label: "Diazoxide" },
  { value: "103409", label: "dibekacin" },
  { value: "100579", label: "Dibenyline" },
  { value: "103410", label: "dibenzepin" },
  { value: "103411", label: "dibotermin alfa" },
  { value: "103412", label: "dibromotyrosine" },
  { value: "103413", label: "dibrompropamidine" },
  { value: "103414", label: "dibunate" },
  { value: "103415", label: "dibutylphthalate" },
  { value: "103416", label: "dibutylsuccinate" },
  { value: "103417", label: "dichloralphenazone" },
  { value: "103418", label: "dichlorobenzyl alcohol" },
  { value: "103419", label: "dichlorophen" },
  { value: "589", label: "Dichlotride" },
  { value: "590", label: "Diclofenac" },
  { value: "103420", label: "diclofenac and antiinfectives" },
  { value: "103421", label: "Diclofenac sodium" },
  { value: "103422", label: "Diclofenac sodium & misoprostol 50mg/200mcg" },
  { value: "103423", label: "Diclofenac sodium & misoprostol 75mg/200mcg" },
  { value: "103424", label: "diclofenac, combinations" },
  { value: "103425", label: "diclofenamide" },
  { value: "591", label: "Dicloflex" },
  { value: "103426", label: "diclomax" },
  { value: "592", label: "Diclomax Retard" },
  { value: "103427", label: "dicloxacillin" },
  { value: "100580", label: "Diconal" },
  { value: "103428", label: "dicoumarol" },
  { value: "103429", label: "Dicyclomine" },
  { value: "103430", label: "Dicyclomine compound prep. (Kolanticon Gel)" },
  { value: "593", label: "Dicycloverine" },
  { value: "100581", label: "Dicynene" },
  { value: "100582", label: "Didanosine" },
  { value: "103431", label: "didecyldimethylammonium chloride" },
  { value: "594", label: "Didronel" },
  { value: "100583", label: "Didronel PMO" },
  { value: "103432", label: "dienestrol" },
  { value: "100584", label: "Dietary Specials" },
  { value: "103433", label: "diethyl ether" },
  { value: "103434", label: "diethylamine" },
  { value: "595", label: "Diethylamine Salicylate" },
  { value: "103435", label: "diethylcarbamazine" },
  { value: "596", label: "Diethylstilbestrol" },
  { value: "103436", label: "diethyltoluamide" },
  { value: "103437", label: "difemerine" },
  { value: "103438", label: "difenoxin" },
  { value: "103439", label: "difenpiramide" },
  { value: "103440", label: "difetarsone" },
  { value: "100585", label: "Differin" },
  { value: "100586", label: "Difflam" },
  { value: "100587", label: "Difflam Oral Rinse" },
  { value: "103441", label: "diflorasone" },
  { value: "597", label: "Diflucan" },
  { value: "103442", label: "diflucortolone" },
  { value: "103443", label: "diflucortolone and antiseptics" },
  { value: "100588", label: "Diflucortolone valerate" },
  { value: "103444", label: "diflunisal" },
  { value: "103445", label: "difluprednate" },
  { value: "100589", label: "Digibind" },
  { value: "103446", label: "digitalis antitoxin" },
  { value: "103447", label: "digitalis leaves" },
  { value: "598", label: "Digitoxin" },
  { value: "599", label: "Digoxin" },
  { value: "100590", label: "Digoxin antibody" },
  { value: "103448", label: "dihexyverine" },
  { value: "103449", label: "dihydralazine" },
  { value: "103450", label: "dihydralazine and diuretics" },
  {
    value: "103451",
    label: "dihydralazine and diuretics, combinations with other drugs",
  },
  { value: "600", label: "Dihydrocodeine" },
  { value: "103452", label: "dihydrocodeine, combinations" },
  { value: "103453", label: "dihydroemetine" },
  { value: "103454", label: "dihydroergocristine" },
  { value: "103455", label: "dihydroergocristine, combinations" },
  { value: "103456", label: "dihydroergocryptine mesylate" },
  { value: "103457", label: "dihydroergotamine" },
  { value: "103458", label: "dihydroergotamine, combinations" },
  { value: "103459", label: "dihydrostreptomycin" },
  { value: "103460", label: "dihydrotachysterol" },
  { value: "103461", label: "dihydroxialumini sodium carbonate" },
  { value: "103462", label: "diiodohydroxypropane" },
  { value: "103463", label: "diiodohydroxyquinoline" },
  { value: "103464", label: "diiodotyrosine" },
  { value: "103465", label: "diisopromine" },
  { value: "103466", label: "dilantin" },
  { value: "103467", label: "dilazep" },
  { value: "103468", label: "Dilcardia" },
  { value: "103469", label: "Dilcardia SR" },
  { value: "103470", label: "diloxanide" },
  { value: "601", label: "Diltiazem" },
  { value: "602", label: "Dilzem" },
  { value: "100591", label: "Dilzem SR" },
  { value: "100592", label: "Dilzem XL" },
  { value: "103471", label: "dimazole" },
  { value: "103472", label: "dimefline" },
  { value: "103473", label: "dimemorfan" },
  { value: "103474", label: "Dimenhydrate" },
  { value: "100593", label: "Dimenhydrinate" },
  { value: "103475", label: "dimercaprol" },
  { value: "103476", label: "dimetacrine" },
  { value: "103477", label: "dimethoxanate" },
  { value: "103478", label: "dimethyl fumarate" },
  { value: "100594", label: "Dimethyl Sulfoxide" },
  { value: "103479", label: "dimethylaminopropionylphenothiazine" },
  { value: "103480", label: "dimethylcarbate" },
  { value: "103481", label: "dimethylphthalate" },
  { value: "103482", label: "dimethyltubocurarine" },
  { value: "100595", label: "Dimeticone" },
  { value: "103483", label: "dimetindene" },
  { value: "103484", label: "dimetofrine" },
  { value: "103485", label: "dimetotiazine" },
  { value: "103486", label: "dinoprost" },
  { value: "100596", label: "Dinoprostone" },
  { value: "100597", label: "Dioctyl" },
  { value: "100598", label: "Dioderm" },
  { value: "103487", label: "diodone" },
  { value: "100599", label: "Dioralyte" },
  { value: "103488", label: "diosmectite" },
  { value: "103489", label: "diosmin" },
  { value: "103490", label: "diosmin, combinations" },
  { value: "603", label: "Diovan" },
  { value: "100600", label: "Dipentum" },
  { value: "103491", label: "diphemanil" },
  { value: "103492", label: "diphemanil and psycholeptics" },
  { value: "103493", label: "diphenadione" },
  { value: "604", label: "Diphenhydramine" },
  { value: "103494", label: "diphenhydramine methylbromide" },
  { value: "103495", label: "diphenhydramine, combinations" },
  { value: "103496", label: "diphenoxylate" },
  { value: "103497", label: "diphenylpyraline" },
  { value: "103498", label: "diphenylpyraline, combinations" },
  { value: "103499", label: "diphtheria" },
  { value: "103500", label: "diphtheria antitoxin" },
  { value: "103501", label: "diphtheria immunoglobulin" },
  { value: "100601", label: "Diphtheria Toxoid" },
  {
    value: "103502",
    label: "diphtheria-Hemophilus influenzae B-pertussis-poliomyelitis-tetanus",
  },
  {
    value: "103503",
    label:
      "diphtheria-Hemophilus influenzae B-pertussis-poliomyelitis-tetanus-hepatitis B",
  },
  {
    value: "103504",
    label: "diphtheria-Hemophilus influenzae B-pertussis-tetanus-hepatitis B",
  },
  {
    value: "103505",
    label:
      "diphtheria-hemophilus influenzae B-pertussis-tetanus-hepatitis B-meningococcus A + C",
  },
  { value: "103506", label: "diphtheria-hepatitis B-pertussis-tetanus" },
  { value: "103507", label: "diphtheria-hepatitis B-tetanus" },
  { value: "103508", label: "diphtheria-pertussis-poliomyelitis-tetanus" },
  {
    value: "103509",
    label: "diphtheria-pertussis-poliomyelitis-tetanus-hepatitis B",
  },
  { value: "103510", label: "diphtheria-poliomyelitis-tetanus" },
  { value: "103511", label: "diphtheria-rubella-tetanus" },
  { value: "100602", label: "Dipipanone" },
  { value: "103512", label: "Dipipanone & cyclizine 10mg/30mg" },
  { value: "103513", label: "dipiperonylaminoethanol, combinations" },
  { value: "103514", label: "dipivefrine" },
  { value: "100603", label: "Diprivan" },
  { value: "100604", label: "Diprobase" },
  { value: "100605", label: "Diprobath" },
  { value: "103515", label: "diprophylline" },
  { value: "103516", label: "diprophylline and adrenergics" },
  { value: "103517", label: "diprophylline, combinations" },
  { value: "605", label: "Diprosalic" },
  { value: "100606", label: "Diprosone" },
  { value: "606", label: "Dipyridamole" },
  { value: "103518", label: "Dipyridamole and aspirin MR 200mg/25mg" },
  { value: "103519", label: "Dipyridamole MR" },
  { value: "103520", label: "dipyrocetyl" },
  { value: "103521", label: "dipyrocetyl and corticosteroids" },
  { value: "103522", label: "dipyrocetyl, combinations excl. psycholeptics" },
  { value: "103523", label: "dipyrocetyl, combinations with psycholeptics" },
  { value: "103524", label: "dirithromycin" },
  { value: "103525", label: "Diroximel fumarate" },
  { value: "100607", label: "Disipal" },
  { value: "100608", label: "Disodium Edetate" },
  { value: "103526", label: "Disodium Etidronate" },
  { value: "607", label: "Disopyramide" },
  { value: "103527", label: "Dispirin" },
  { value: "103528", label: "distaclor" },
  { value: "100609", label: "Distaclor MR" },
  { value: "100610", label: "Distamine" },
  { value: "100611", label: "Distigmine" },
  { value: "100612", label: "Disulfiram" },
  { value: "103529", label: "disulfiram, combinations" },
  { value: "103530", label: "ditazole" },
  { value: "100613", label: "Dithranol" },
  { value: "103531", label: "dithranol, combinations" },
  { value: "100614", label: "Dithrocream" },
  { value: "100615", label: "Ditropan" },
  { value: "103532", label: "diumide-k" },
  { value: "100616", label: "Diumide-K Continus" },
  { value: "103533", label: "diuresal" },
  { value: "103534", label: "diuretic" },
  { value: "100617", label: "Diuretic - Other" },
  { value: "608", label: "Diurexan" },
  { value: "103535", label: "dixanthogen" },
  { value: "609", label: "Dixarit" },
  { value: "103536", label: "dixyrazine" },
  { value: "103537", label: "dobutamine" },
  { value: "610", label: "Docetaxel" },
  { value: "100618", label: "DocOmega" },
  { value: "103538", label: "docosahexaenoic" },
  { value: "611", label: "Docosahexaenoic acid" },
  { value: "103539", label: "docosanol" },
  { value: "612", label: "Docusate" },
  { value: "100619", label: "Docusate Sodium" },
  { value: "103540", label: "Docusate sodium (includingcombinations)" },
  { value: "103541", label: "docusate sodium, incl. combinations" },
  { value: "100620", label: "Docusol" },
  { value: "103542", label: "dodeclonium bromide, combinations" },
  { value: "103543", label: "dofetilide" },
  { value: "103544", label: "dolasetron" },
  { value: "100621", label: "Dolenio" },
  { value: "100622", label: "Dolmatil" },
  { value: "103545", label: "Dolobid" },
  { value: "613", label: "Dolodol" },
  { value: "103546", label: "dolutegravir" },
  { value: "103547", label: "domiodol" },
  { value: "103548", label: "domiphen" },
  { value: "614", label: "Domperidone" },
  { value: "615", label: "Donepezil" },
  { value: "100623", label: "Dopacard" },
  { value: "616", label: "Dopamine" },
  { value: "100624", label: "Dopexamine" },
  { value: "100625", label: "Dopram" },
  { value: "103549", label: "Doptelet" },
  { value: "617", label: "Doralese" },
  { value: "100626", label: "Doribax" },
  { value: "100627", label: "Doripenem" },
  { value: "103550", label: "Dorisin XL" },
  { value: "103551", label: "dormonoct" },
  { value: "103552", label: "dornase" },
  { value: "100628", label: "Dornase alfa" },
  { value: "103553", label: "dornase alfa (desoxyribonuclease)" },
  { value: "618", label: "Dorzolamide" },
  { value: "103554", label: "Dostarlimab" },
  { value: "619", label: "Dostinex" },
  { value: "620", label: "Dosulepin" },
  { value: "103555", label: "Dosulepin Hydrochloride" },
  { value: "621", label: "Dothiepin" },
  { value: "103556", label: "Dothiepin (Dosulepin)" },
  { value: "103557", label: "Dothiepin Hydrochloride" },
  { value: "100629", label: "Doublebase" },
  { value: "100630", label: "Dovobet" },
  { value: "100631", label: "Dovonex" },
  { value: "103558", label: "doxacurium chloride" },
  { value: "622", label: "Doxadura" },
  { value: "103559", label: "doxadura xl" },
  { value: "100632", label: "Doxapram" },
  { value: "100633", label: "Doxazisin" },
  { value: "623", label: "Doxazosin" },
  { value: "103560", label: "Doxazosin Mesyl" },
  { value: "103561", label: "doxefazepam" },
  { value: "624", label: "Doxepin" },
  { value: "103562", label: "doxercalciferol" },
  { value: "625", label: "Doxium" },
  { value: "103563", label: "doxofylline" },
  { value: "626", label: "Doxorubicin" },
  { value: "100634", label: "Doxorubin" },
  { value: "627", label: "Doxycycline" },
  { value: "103564", label: "doxylamine" },
  { value: "628", label: "Doxzogen" },
  { value: "100635", label: "Dozic" },
  { value: "100636", label: "Drapolene" },
  { value: "100637", label: "Driclor" },
  { value: "103565", label: "dronabinol" },
  { value: "629", label: "Dronedarone" },
  { value: "103566", label: "droperidol" },
  { value: "103567", label: "dropropizine" },
  { value: "100638", label: "Drospirenone" },
  { value: "103568", label: "drotaverine" },
  { value: "103569", label: "drotrecogin" },
  { value: "100639", label: "Drotrecogin alfa" },
  { value: "103570", label: "drotrecogin alfa (activated)" },
  { value: "103571", label: "droxicam" },
  { value: "103572", label: "droxypropine" },
  { value: "103573", label: "dtap-ipv" },
  { value: "100641", label: "Dtap-Ipv Vaccine" },
  { value: "103574", label: "dtap-ipv-hib" },
  { value: "100642", label: "Dtap-Ipv-Hib Vaccine" },
  { value: "103575", label: "dt-ipv" },
  { value: "100640", label: "Dt-Ipv Vaccine" },
  { value: "100643", label: "Duac" },
  { value: "103576", label: "Duaklir" },
  { value: "100644", label: "Dukoral" },
  { value: "103577", label: "dulaglutide" },
  { value: "100645", label: "Dulcobalance" },
  { value: "103578", label: "Dulcolax" },
  { value: "100646", label: "Dulcolax Pico Perles" },
  { value: "630", label: "Duloxetine" },
  { value: "100647", label: "Duobar" },
  { value: "103579", label: "duocal" },
  { value: "100648", label: "Duocal Super Soluble" },
  { value: "631", label: "Duodopa" },
  { value: "100649", label: "Duofilm" },
  { value: "103580", label: "duoresp" },
  { value: "103581", label: "DuoResp Spiromax" },
  { value: "103582", label: "duoresp spiromax inhaler" },
  { value: "632", label: "DuoTrav" },
  { value: "103583", label: "duovent" },
  { value: "100650", label: "Duovent UDV" },
  { value: "103584", label: "dupilumab" },
  { value: "103585", label: "Dupixent" },
  { value: "633", label: "Durogesic" },
  { value: "100651", label: "Durogesic DTrans" },
  { value: "100652", label: "Durolane" },
  { value: "103586", label: "durvalumab" },
  { value: "634", label: "Dutasteride" },
  { value: "103587", label: "Dutrebis" },
  { value: "635", label: "Dyazide" },
  { value: "103588", label: "dyclonine" },
  { value: "100653", label: "Dydrogesterone" },
  { value: "100654", label: "Dyloject" },
  { value: "100655", label: "Dynastat" },
  { value: "100656", label: "Dyspamet" },
  { value: "100657", label: "Dysport" },
  { value: "103589", label: "dysprosium (165Dy) colloid" },
  { value: "100658", label: "Dytac" },
  { value: "636", label: "Dytide" },
  { value: "103590", label: "dyzantil" },
  { value: "100659", label: "E.I.D." },
  { value: "100660", label: "E45" },
  { value: "103591", label: "eaa" },
  { value: "100661", label: "EAA Supplement" },
  { value: "100662", label: "EarCalm" },
  { value: "100663", label: "Easiphen" },
  { value: "100664", label: "Easyhaler Beclometasone" },
  { value: "100665", label: "Easyhaler Budesonide" },
  { value: "100666", label: "Easyhaler Formoterol" },
  { value: "100667", label: "Easyhaler Salbutamol" },
  { value: "103592", label: "ebastine" },
  { value: "103593", label: "ebesque" },
  { value: "103594", label: "ebesque xl" },
  { value: "637", label: "Ebixa" },
  { value: "100668", label: "Ecalta" },
  { value: "638", label: "Eccoxolac" },
  { value: "100669", label: "Econazole" },
  { value: "100670", label: "Econazole nitrate" },
  { value: "103595", label: "Ecopace" },
  { value: "100671", label: "Ecostatin" },
  { value: "103596", label: "ecothiopate" },
  { value: "639", label: "Ecotrin" },
  { value: "100672", label: "Eculizumab" },
  { value: "640", label: "ECX" },
  { value: "100673", label: "Eczmol" },
  { value: "103597", label: "Edarbi" },
  { value: "103598", label: "edetates" },
  { value: "103599", label: "Ednyt" },
  { value: "103600", label: "edoxaban" },
  { value: "103601", label: "edoxudine" },
  { value: "103602", label: "edrecolomab" },
  { value: "641", label: "Edronax" },
  { value: "103603", label: "Edurant" },
  { value: "103604", label: "efalizumab" },
  { value: "103605", label: "efaproxiral" },
  { value: "642", label: "Efavirenz" },
  { value: "100674", label: "Efcortesol" },
  { value: "643", label: "Efexor" },
  { value: "100675", label: "Efexor XL" },
  { value: "100676", label: "Effentora" },
  { value: "100677", label: "Effercitrate" },
  { value: "644", label: "Efient" },
  { value: "100678", label: "Eflornithine" },
  { value: "103606", label: "efloxate" },
  { value: "103607", label: "Eformoterol fumarate" },
  { value: "103608", label: "Eformoterol(Formoterol)" },
  { value: "100679", label: "Efracea" },
  { value: "645", label: "Efudix" },
  { value: "103609", label: "eicosapentaenoic" },
  { value: "646", label: "Eicosapentaenoic acid" },
  { value: "103610", label: "Eklira" },
  { value: "103611", label: "Eklira Genuair" },
  { value: "647", label: "Elantan" },
  { value: "100680", label: "Elantan LA" },
  { value: "100681", label: "Elaprase" },
  { value: "648", label: "Elavil" },
  { value: "103612", label: "elbasvir and grazoprevir" },
  { value: "103613", label: "elcatonin" },
  { value: "100682", label: "Eldepryl" },
  { value: "100683", label: "Eldisine" },
  { value: "100684", label: "Electrolade" },
  { value: "100685", label: "Electrolytes" },
  { value: "103614", label: "electrolytes in combination with other drugs" },
  { value: "103615", label: "ELECTROLYTES WITH CARBOHYDRATES" },
  { value: "100686", label: "Eletriptan" },
  { value: "100687", label: "Elidel" },
  { value: "103616", label: "Eliquis" },
  { value: "649", label: "Elisor" },
  { value: "100688", label: "Elite" },
  { value: "103617", label: "elleste" },
  { value: "650", label: "Elleste Duet" },
  { value: "100689", label: "Elleste Duet 1mg" },
  { value: "100690", label: "Elleste Duet Conti" },
  { value: "100691", label: "Elleste Solo" },
  { value: "100692", label: "Elleste Solo MX 40" },
  { value: "103618", label: "Elmiron" },
  { value: "651", label: "Elocon" },
  { value: "100693", label: "Elonva" },
  { value: "100694", label: "Eloxatin" },
  { value: "100695", label: "Eltrombopag" },
  { value: "652", label: "Eltroxin" },
  { value: "103619", label: "elvanse" },
  { value: "103620", label: "elvitegravir" },
  { value: "100696", label: "Emadine" },
  { value: "103621", label: "Embolex" },
  { value: "653", label: "Emconcor" },
  { value: "654", label: "Emcor" },
  { value: "655", label: "Emcoretic" },
  { value: "100697", label: "Emedastine" },
  { value: "100698", label: "Emend" },
  { value: "103622", label: "emepronium" },
  { value: "103623", label: "emepronium and psycholeptics" },
  { value: "103624", label: "emepronium, combinations" },
  { value: "103625", label: "Emeside" },
  { value: "100699", label: "Emeside Syrup" },
  { value: "103626", label: "emetine" },
  { value: "103627", label: "emetine, combinations" },
  { value: "100700", label: "Emflex" },
  { value: "103628", label: "Emgality" },
  { value: "100701", label: "Emla" },
  { value: "100702", label: "Emollin" },
  { value: "103629", label: "emozul" },
  { value: "100703", label: "Empagliflozin" },
  { value: "100704", label: "Emselex" },
  { value: "100705", label: "Emsogen" },
  { value: "656", label: "Emtricitabine" },
  { value: "100706", label: "Emtriva" },
  { value: "100707", label: "Emulsiderm" },
  { value: "103630", label: "emulsifying" },
  { value: "100708", label: "Emulsifying Ointment" },
  { value: "103631", label: "emylcamate" },
  { value: "657", label: "Enalapril" },
  { value: "103632", label: "enalapril and diuretics" },
  { value: "103633", label: "Enalapril Comp" },
  { value: "103634", label: "Enalapril with hydrochlorothiazide 20/12.5mg" },
  { value: "658", label: "Enbrel" },
  { value: "103635", label: "encainide" },
  {
    value: "103636",
    label: "encephalitis, Japanese, inactivated, whole virus",
  },
  { value: "103637", label: "encephalitis, tick borne immunoglobulin" },
  {
    value: "103638",
    label: "encephalitis, tick borne, inactivated, whole virus",
  },
  { value: "103639", label: "encorafenib" },
  { value: "103640", label: "endekay" },
  { value: "100709", label: "Endekay Fluotabs" },
  { value: "103641", label: "endralazine" },
  { value: "100710", label: "Energivit" },
  { value: "103642", label: "enflurane" },
  { value: "100711", label: "Enfuvirtide" },
  { value: "103643", label: "engerix" },
  { value: "100712", label: "Engerix B" },
  { value: "103644", label: "Enhertu" },
  { value: "103645", label: "enoxacin" },
  { value: "659", label: "Enoxaparin" },
  { value: "103646", label: "Enoxaparin Sodium" },
  { value: "103647", label: "enoximone" },
  { value: "103648", label: "enoxolone" },
  { value: "103649", label: "enprostil" },
  { value: "100713", label: "Enshake" },
  { value: "660", label: "Ensure" },
  { value: "661", label: "Entacapone" },
  { value: "103650", label: "Entacavir" },
  { value: "100714", label: "Entecavir" },
  { value: "103651", label: "Entocort" },
  { value: "100715", label: "Entocort CR" },
  { value: "103652", label: "entrectinib" },
  { value: "103653", label: "Entresto" },
  { value: "103654", label: "Entyvio" },
  { value: "103655", label: "Envarsus" },
  { value: "103656", label: "enyglid" },
  { value: "103657", label: "enzalutamide" },
  { value: "100716", label: "Enzira" },
  { value: "103658", label: "eosin" },
  { value: "103659", label: "epaderm" },
  { value: "100717", label: "Epaderm Cream" },
  { value: "103660", label: "epanolol" },
  { value: "662", label: "Epanutin" },
  { value: "100718", label: "Epanutin Parenteral" },
  { value: "103661", label: "epanutin suspension" },
  { value: "663", label: "Epavirenz" },
  { value: "100719", label: "Epaxal" },
  { value: "103662", label: "Epclusa" },
  { value: "103663", label: "eperisone" },
  { value: "103664", label: "eperzan" },
  { value: "664", label: "Ephedrine" },
  { value: "103665", label: "ephedrine, combinations" },
  { value: "103666", label: "epicillin" },
  { value: "100720", label: "Epiduo" },
  { value: "103667", label: "epidyolex" },
  { value: "665", label: "Epilim" },
  { value: "103668", label: "epimestrol" },
  { value: "100721", label: "Epinastine" },
  { value: "103669", label: "epinephrine" },
  {
    value: "103670",
    label: "epinephrine and other drugs for obstructive airway diseases",
  },
  { value: "103671", label: "epinephrine, combinations" },
  { value: "666", label: "EpiPen" },
  { value: "667", label: "Epirubicin" },
  { value: "100722", label: "Episenta" },
  { value: "668", label: "Epistatus" },
  { value: "103672", label: "epitizide and potassium-sparing agents" },
  { value: "103673", label: "Epival" },
  { value: "100723", label: "Epivir" },
  { value: "669", label: "Eplerenone" },
  { value: "670", label: "EPO" },
  { value: "671", label: "Epoetin" },
  { value: "100724", label: "Epoetin alfa" },
  { value: "100725", label: "Epoetin beta" },
  { value: "100726", label: "Epoetin theta" },
  { value: "100727", label: "Epoetin zeta" },
  { value: "103674", label: "epomediol" },
  { value: "100728", label: "Epoprostenol" },
  { value: "100729", label: "Eporatio" },
  { value: "100730", label: "Eposin" },
  { value: "103675", label: "Eppinix" },
  { value: "103676", label: "eprazinone" },
  { value: "672", label: "Eprex" },
  { value: "673", label: "Eprey" },
  { value: "674", label: "Eprosartan" },
  { value: "103677", label: "eprosartan and diuretics" },
  { value: "103678", label: "eprozinol" },
  { value: "103679", label: "eptacog" },
  { value: "100731", label: "Eptacog alfa" },
  { value: "103680", label: "eptacog alfa (activated)" },
  { value: "100732", label: "Eptadone" },
  { value: "100733", label: "Eptifibatide" },
  { value: "103681", label: "eptotermin alfa" },
  { value: "675", label: "Equanil" },
  { value: "103682", label: "equasym" },
  { value: "100734", label: "Equasym XL" },
  { value: "100735", label: "Erbitux" },
  { value: "103683", label: "erbium (169Er) citrate colloid" },
  { value: "100736", label: "Erdosteine" },
  { value: "100737", label: "Erdotin" },
  { value: "100738", label: "ErectAssist" },
  { value: "100739", label: "ErectEase" },
  { value: "103684", label: "Erelzi" },
  { value: "103685", label: "erenumab" },
  { value: "100740", label: "Ergocalciferol" },
  { value: "103686", label: "ergoloid mesylates" },
  { value: "103687", label: "ergoloid mesylates, combinations" },
  { value: "103688", label: "ergometrine" },
  { value: "100741", label: "Ergometrine Maleate" },
  { value: "103689", label: "Ergot alkaloids" },
  { value: "103690", label: "ergotamine" },
  { value: "100742", label: "Ergotamine Tartrate" },
  { value: "103691", label: "ergotamine, combinations excl. psycholeptics" },
  { value: "103692", label: "ergotamine, combinations with psycholeptics" },
  { value: "103693", label: "eribulin" },
  { value: "103694", label: "eritrityl tetranitrate" },
  { value: "103695", label: "eritrityl tetranitrate, combinations" },
  { value: "103696", label: "Erivedge" },
  { value: "103697", label: "Erleada" },
  { value: "676", label: "Erlotinib" },
  { value: "100743", label: "Ertapenem" },
  { value: "103698", label: "ertugliflozin" },
  { value: "100744", label: "Eryacne" },
  { value: "100745", label: "Erymax" },
  { value: "100746", label: "Erythrocin" },
  { value: "103699", label: "erythrocytes" },
  { value: "677", label: "Erythromycin" },
  { value: "103700", label: "erythromycin, combinations" },
  { value: "103701", label: "erythroped" },
  { value: "100747", label: "Erythroped A" },
  { value: "678", label: "Erythropoietin" },
  { value: "103702", label: "Esbriet" },
  { value: "679", label: "Escitalopram" },
  { value: "103703", label: "esketamine" },
  { value: "100748", label: "Eslicarbazepine" },
  { value: "103704", label: "Eslicarbazepine Acetate" },
  { value: "100749", label: "Esmeron" },
  { value: "100750", label: "Esmolol" },
  { value: "680", label: "Esomeprazole" },
  { value: "103705", label: "estazolam" },
  { value: "100751", label: "Estracyt" },
  { value: "681", label: "Estraderm" },
  { value: "100752", label: "Estraderm MX" },
  { value: "682", label: "Estradiol" },
  { value: "100753", label: "Estradiol Implant" },
  { value: "103706", label: "estradiol, combinations" },
  { value: "100754", label: "Estradot" },
  { value: "100755", label: "Estramustine" },
  { value: "100756", label: "Estring" },
  { value: "100757", label: "Estriol" },
  { value: "100758", label: "Estrone" },
  { value: "103707", label: "eszopiclone" },
  { value: "103708", label: "etacrynic acid" },
  { value: "103709", label: "etafenone" },
  { value: "103710", label: "etallobarbital" },
  { value: "683", label: "Etalpha" },
  { value: "103711", label: "etamiphylline" },
  { value: "103712", label: "etamiphylline and adrenergics" },
  { value: "103713", label: "etamivan" },
  { value: "100759", label: "Etamsylate" },
  { value: "103714", label: "etanautine" },
  { value: "684", label: "Etanercept" },
  { value: "103715", label: "ethacridine lactate" },
  { value: "103716", label: "ethadione" },
  { value: "685", label: "Ethambutol" },
  { value: "103717", label: "ethanol" },
  { value: "103718", label: "ethanolamine" },
  { value: "100760", label: "Ethanolamine oleate" },
  { value: "103719", label: "ethchlorvynol" },
  { value: "103720", label: "ethenzamide" },
  { value: "103721", label: "ethenzamide, combinations excl. psycholeptics" },
  { value: "103722", label: "ethenzamide, combinations with psycholeptics" },
  { value: "103723", label: "ethibide" },
  { value: "103724", label: "Ethibide XL" },
  { value: "100761", label: "Ethinylestradiol" },
  { value: "103725", label: "ethionamide" },
  { value: "103726", label: "ethisterone" },
  { value: "100762", label: "Ethosuximide" },
  { value: "103727", label: "ethosuximide, combinations" },
  { value: "103728", label: "ethotoin" },
  { value: "103729", label: "ethulose" },
  { value: "103730", label: "ethyl biscoumacetate" },
  { value: "100763", label: "Ethyl chloride" },
  { value: "103731", label: "ethyl esters of iodised fatty acids" },
  { value: "103732", label: "ethyl hydroxybenzoate" },
  { value: "103733", label: "ethyl loflazepate" },
  { value: "100764", label: "Ethyl Nicotinate" },
  { value: "103734", label: "ethylestrenol" },
  { value: "103735", label: "ethylmorphine" },
  { value: "103736", label: "etidocaine" },
  { value: "103737", label: "etidocaine, combinations" },
  { value: "686", label: "Etidronate" },
  { value: "103738", label: "etidronic acid" },
  { value: "103739", label: "etifoxine" },
  { value: "103740", label: "etilamfetamine" },
  { value: "103741", label: "etilefrine" },
  { value: "103742", label: "etilefrine, combinations" },
  { value: "103743", label: "etilevodopa and decarboxylase inhibitor" },
  { value: "103744", label: "etizolam" },
  { value: "687", label: "Etodolac" },
  { value: "103745", label: "etofamide" },
  { value: "103746", label: "etofenamate" },
  { value: "103747", label: "etofibrate" },
  { value: "103748", label: "etofylline nicotinate" },
  { value: "103749", label: "etoglucid" },
  { value: "103750", label: "etohexadiol" },
  { value: "100765", label: "Etomidate" },
  { value: "103751", label: "etonogestrel" },
  { value: "103752", label: "etopan" },
  { value: "100766", label: "Etopan XL" },
  { value: "103753", label: "etoperidone" },
  { value: "100767", label: "Etopophos" },
  { value: "100768", label: "Etoposide" },
  { value: "688", label: "Etoricoxib" },
  { value: "103754", label: "etozolin" },
  { value: "689", label: "Etravirine" },
  { value: "103755", label: "etretinate" },
  { value: "100769", label: "Etrivex" },
  { value: "103756", label: "etybenzatropine" },
  { value: "103757", label: "etynodiol" },
  { value: "690", label: "Eucardic" },
  { value: "100770", label: "Eucerin" },
  { value: "691", label: "Eucreas" },
  { value: "100771", label: "Eudemine" },
  { value: "103758", label: "euflavine" },
  { value: "100772", label: "Euflexxa" },
  { value: "100773", label: "Euglucon" },
  { value: "100774", label: "Eumobase" },
  { value: "100775", label: "Eumovate" },
  { value: "692", label: "Eupantol" },
  { value: "100776", label: "Eurax" },
  { value: "103759", label: "eurax hc" },
  { value: "100777", label: "Eurax-hydrocortisone" },
  { value: "693", label: "Eutirox" },
  { value: "103760", label: "Evacal D3" },
  { value: "100778", label: "Evening primrose oil" },
  { value: "103761", label: "Evenity" },
  { value: "694", label: "Everolimus" },
  { value: "103762", label: "Eviplera" },
  { value: "695", label: "Evista" },
  { value: "103763", label: "evolocumab" },
  { value: "100779", label: "Evoltra" },
  { value: "696", label: "Evorel" },
  { value: "100780", label: "Evorel Conti" },
  { value: "100781", label: "Evorel Sequi" },
  { value: "103764", label: "Evotaz" },
  { value: "103765", label: "Evrenzo" },
  { value: "103766", label: "Evrysdi" },
  { value: "697", label: "Exanatide" },
  { value: "698", label: "Exelon" },
  { value: "103767", label: "Exembol" },
  { value: "699", label: "Exemestane" },
  { value: "100782", label: "Exenatide" },
  { value: "103768", label: "Exenatide (injection)" },
  { value: "700", label: "Exforge" },
  { value: "100783", label: "Exjade" },
  { value: "103769", label: "Exkivity" },
  { value: "100784", label: "Exocin" },
  { value: "100785", label: "Exorex" },
  { value: "100786", label: "Extavia" },
  { value: "100787", label: "Exterol" },
  { value: "100788", label: "Exubera" },
  { value: "103770", label: "Exviera" },
  { value: "701", label: "Ezetimibe" },
  { value: "702", label: "Ezetrol" },
  { value: "100789", label: "Factor Ii" },
  { value: "100790", label: "Factor Ix" },
  { value: "100791", label: "Factor Vii" },
  { value: "100792", label: "Factor VIII" },
  { value: "103771", label: "factor VIII inhibitor bypassing activity" },
  { value: "100793", label: "Factor X" },
  { value: "100794", label: "Factor XIII" },
  { value: "703", label: "Famciclovir" },
  { value: "704", label: "Famotidine" },
  { value: "103772", label: "famotidine, combinations" },
  { value: "103773", label: "fampridine" },
  { value: "103774", label: "Fampyra" },
  { value: "705", label: "Famvir" },
  { value: "100795", label: "Fareston" },
  { value: "103775", label: "Faricimab" },
  { value: "103776", label: "Farydak" },
  { value: "103777", label: "Fasenra" },
  { value: "100796", label: "Fasigyn" },
  { value: "706", label: "Faslodex" },
  { value: "100797", label: "Fasturtec" },
  { value: "103778", label: "fasudil" },
  { value: "103779", label: "fat emulsions" },
  { value: "707", label: "Faverin" },
  { value: "103780", label: "fazadinium bromide" },
  { value: "708", label: "FCR" },
  { value: "103781", label: "feather" },
  { value: "103782", label: "febarbamate" },
  { value: "100798", label: "Febuxostat" },
  { value: "103783", label: "Fedratinib" },
  { value: "103784", label: "fedrilate" },
  { value: "103785", label: "Fefol" },
  { value: "100799", label: "Feiba" },
  { value: "103786", label: "felbamate" },
  { value: "100800", label: "Felbinac" },
  { value: "709", label: "Feldene" },
  { value: "100801", label: "Feldene Gel" },
  { value: "710", label: "Felendil" },
  { value: "711", label: "Felodipine" },
  { value: "103787", label: "Felogen" },
  { value: "103788", label: "Felogen XL" },
  { value: "103789", label: "Felotens" },
  { value: "712", label: "Felotens XL" },
  { value: "103790", label: "femapak" },
  { value: "100802", label: "Femapak 40" },
  { value: "713", label: "Femara" },
  { value: "103791", label: "fematrix" },
  { value: "100803", label: "Fematrix 40" },
  { value: "100804", label: "Femmax" },
  { value: "103792", label: "femoston" },
  { value: "100805", label: "Femoston 1/10" },
  { value: "100806", label: "Femoston-Conti" },
  { value: "100807", label: "Femseven" },
  { value: "100808", label: "FemSeven Conti" },
  { value: "100809", label: "FemSeven Sequi" },
  { value: "714", label: "Fenactol" },
  { value: "103793", label: "fenbendazole" },
  { value: "103794", label: "Fenbid" },
  { value: "100810", label: "Fenbid Gel" },
  { value: "100811", label: "Fenbid Spansule" },
  { value: "715", label: "Fenbufen" },
  { value: "103795", label: "fencamfamin" },
  { value: "103796", label: "fendiline" },
  { value: "100812", label: "Fendrix" },
  { value: "103797", label: "fenetylline" },
  { value: "103798", label: "fenfluramine" },
  { value: "716", label: "Fenofenadine" },
  { value: "717", label: "Fenofibrate" },
  { value: "103799", label: "fenoldopam" },
  { value: "100813", label: "Fenoprofen" },
  { value: "100814", label: "Fenopron" },
  { value: "100815", label: "Fenoterol" },
  { value: "103800", label: "Fenoterol & ipratropium 1.25mg/500mcg/4ml" },
  { value: "103801", label: "Fenoterol & ipratropium 100mcg/40mcg" },
  {
    value: "103802",
    label: "fenoterol and other drugs for obstructive airway diseases",
  },
  { value: "103803", label: "fenoverine" },
  { value: "103804", label: "fenoxazoline" },
  { value: "103805", label: "fenozolone" },
  { value: "103806", label: "fenpiprane" },
  { value: "103807", label: "fenpiverinium" },
  { value: "103808", label: "fenquizone" },
  { value: "103809", label: "fenspiride" },
  { value: "100816", label: "Fentalis" },
  { value: "718", label: "Fentanyl" },
  { value: "103810", label: "Fentanyl patches (50mcg)" },
  { value: "103811", label: "fentanyl, combinations" },
  { value: "100817", label: "Fentazin" },
  { value: "103812", label: "fentiazac" },
  { value: "103813", label: "fenticonazole" },
  { value: "103814", label: "fentonium" },
  { value: "103815", label: "fenyramidol" },
  { value: "719", label: "Feospan" },
  { value: "103816", label: "Feprapax" },
  { value: "103817", label: "feprazone" },
  { value: "103818", label: "feprazone, combinations" },
  { value: "100818", label: "Ferinject" },
  { value: "103819", label: "ferric (59Fe) citrate" },
  { value: "103820", label: "ferric acetyl transferrin" },
  { value: "103821", label: "ferric ammonium citrate" },
  { value: "100819", label: "Ferric carboxymaltose" },
  { value: "103822", label: "ferric citrate" },
  { value: "103823", label: "ferric hydroxide" },
  { value: "103824", label: "ferric oxide dextran complexes" },
  { value: "103825", label: "ferric oxide polymaltose complexes" },
  { value: "103826", label: "ferric proteinsuccinylate" },
  { value: "103827", label: "ferric sodium citrate" },
  { value: "103828", label: "ferric sodium gluconate complex" },
  { value: "103829", label: "ferric sorbitol gluconic acid complex" },
  { value: "100820", label: "Ferriprox" },
  { value: "103830", label: "ferristene" },
  { value: "100821", label: "Ferrograd" },
  { value: "103831", label: "Ferrograd C" },
  { value: "100822", label: "Ferrograd Folic" },
  { value: "103832", label: "ferrous amino acid complex" },
  { value: "103833", label: "ferrous ascorbate" },
  { value: "103834", label: "ferrous aspartate" },
  { value: "103835", label: "ferrous carbonate" },
  { value: "103836", label: "ferrous chloride" },
  { value: "100823", label: "Ferrous fumarate" },
  { value: "720", label: "Ferrous Gluconate" },
  { value: "103837", label: "ferrous glycine sulfate" },
  { value: "103838", label: "ferrous iodine" },
  { value: "103839", label: "ferrous succinate" },
  { value: "103840", label: "ferrous sulfate" },
  { value: "721", label: "Ferrous Sulphate" },
  { value: "103841", label: "ferrous tartrate" },
  { value: "722", label: "Fersaday" },
  { value: "103842", label: "ferumoxsil" },
  { value: "103843", label: "Ferumoxytol" },
  { value: "723", label: "Fesoterodine" },
  { value: "724", label: "Fexofenadine" },
  { value: "103844", label: "Fiasp" },
  { value: "725", label: "Fibrazate" },
  { value: "103845", label: "fibrinogen (125I)" },
  { value: "103846", label: "fibrinogen, human" },
  { value: "103847", label: "fibrinolysin" },
  { value: "103848", label: "fibrogammin" },
  { value: "100825", label: "Fibrogammin P" },
  { value: "100824", label: "Fibro-Vein" },
  { value: "726", label: "Filair" },
  { value: "103849", label: "Filgotinib" },
  { value: "727", label: "Filgrastim" },
  { value: "100826", label: "Finacea" },
  { value: "728", label: "Finasteride" },
  { value: "103850", label: "fingolimod" },
  { value: "103851", label: "fipexide" },
  { value: "100827", label: "Firazyr" },
  { value: "100828", label: "Firdapse" },
  { value: "100829", label: "Firmagon" },
  { value: "729", label: "Flagyl" },
  { value: "100830", label: "Flamasacard" },
  { value: "100831", label: "Flamazine" },
  { value: "100832", label: "FlavourPac" },
  { value: "100833", label: "Flavoxate" },
  { value: "103852", label: "flebogamma" },
  { value: "103853", label: "flebogamma dif" },
  { value: "100834", label: "Flebogammadif" },
  { value: "730", label: "Flecaine" },
  { value: "731", label: "Flecainide" },
  { value: "103854", label: "Flecainide Acet" },
  { value: "103855", label: "fleet" },
  { value: "100835", label: "Fleet Phospho-Soda" },
  { value: "100836", label: "Fleet Ready-to-Use Enema" },
  { value: "103856", label: "fleroxacin" },
  { value: "103857", label: "flexitol" },
  { value: "100837", label: "Flexitol Heel Balm" },
  { value: "103858", label: "Flixabi" },
  { value: "732", label: "Flixonase" },
  { value: "733", label: "Flixotide" },
  { value: "103859", label: "flixotide accuhaler" },
  { value: "100838", label: "Flixotide Diskhaler" },
  { value: "103860", label: "floctafenine" },
  { value: "100839", label: "Flolan" },
  { value: "734", label: "Flomax" },
  { value: "735", label: "Flomaxtra" },
  { value: "100840", label: "Flomaxtra XL" },
  { value: "100841", label: "Florinef" },
  { value: "103861", label: "flosequinan" },
  { value: "100842", label: "Flotros" },
  { value: "736", label: "Flovent" },
  { value: "103862", label: "flowers" },
  { value: "100843", label: "Flowfusor" },
  { value: "100844", label: "Floxapen" },
  { value: "103863", label: "fluanisone" },
  { value: "737", label: "Fluanxol" },
  { value: "100845", label: "Fluarix" },
  { value: "103864", label: "flubendazole" },
  { value: "103865", label: "fluclorolone" },
  { value: "738", label: "Flucloxacillin" },
  { value: "100846", label: "Flucloxacillin Sodium" },
  { value: "739", label: "Fluconazole" },
  { value: "100847", label: "Flucytosine" },
  { value: "100848", label: "Fludara" },
  { value: "740", label: "Fludarabine" },
  { value: "103866", label: "fludeoxyglucose (18F)" },
  { value: "741", label: "Fludex" },
  { value: "103867", label: "fludiazepam" },
  { value: "742", label: "Fludrocortisone" },
  { value: "103868", label: "fludrocortisone and antiinfectives" },
  { value: "100849", label: "Fludroxycortide" },
  { value: "103869", label: "fludroxycortide and antibiotics" },
  { value: "103870", label: "flufenamic acid" },
  { value: "103871", label: "Fluimucil" },
  { value: "743", label: "Fluindione" },
  { value: "100850", label: "Flumazenil" },
  { value: "103872", label: "flumedroxone" },
  { value: "103873", label: "flumequine" },
  { value: "100851", label: "Flumetasone" },
  { value: "103874", label: "flumetasone and antibiotics" },
  { value: "103875", label: "flumetasone and antiinfectives" },
  { value: "103876", label: "flumetasone and antiseptics" },
  { value: "103877", label: "flunarizine" },
  { value: "744", label: "Flunisolide" },
  { value: "103878", label: "flunitrazepam" },
  { value: "103879", label: "flunoxaprofen" },
  { value: "745", label: "Fluocinolone" },
  { value: "103880", label: "fluocinolone acetonide" },
  { value: "103881", label: "fluocinolone acetonide and antibiotics" },
  { value: "103882", label: "fluocinolone acetonide and antiinfectives" },
  { value: "103883", label: "fluocinolone acetonide and antiseptics" },
  { value: "100852", label: "Fluocinonide" },
  { value: "103884", label: "fluocinonide and antibiotics" },
  { value: "103885", label: "fluocortin" },
  { value: "100853", label: "Fluocortolone" },
  { value: "103886", label: "fluocortolone and antibiotics" },
  { value: "103887", label: "fluocortolone and antiinfectives" },
  { value: "103888", label: "fluocortolone and antiseptics" },
  { value: "100854", label: "Fluor-a-day" },
  { value: "100855", label: "Fluorescein" },
  { value: "103889", label: "fluorescein, combinations" },
  { value: "103890", label: "fluoride, combinations" },
  { value: "100856", label: "Fluorigard" },
  { value: "103891", label: "fluorocarbon blood substitutes" },
  { value: "103892", label: "fluorodopa (18F)" },
  { value: "103893", label: "fluoroethylcholine (18F)" },
  { value: "100857", label: "Fluorometholone" },
  { value: "103894", label: "fluorometholone and antibiotics" },
  { value: "103895", label: "fluorometholone and antiinfectives" },
  { value: "103896", label: "fluorometholone and mydriatics" },
  { value: "103897", label: "fluoromethylcholine (18F)" },
  { value: "746", label: "Fluorouracil" },
  { value: "103898", label: "fluorouracil, combinations" },
  { value: "103899", label: "fluostigmine" },
  { value: "747", label: "Fluoxetine" },
  { value: "103900", label: "fluoxymesterone" },
  { value: "103901", label: "Flupenthixol" },
  { value: "103902", label: "Flupenthixol Decan" },
  { value: "103903", label: "Flupenthixol HCI" },
  { value: "103904", label: "Flupenthixol Hydrochloride" },
  { value: "748", label: "Flupentixol" },
  { value: "103905", label: "fluperolone" },
  { value: "100858", label: "Fluphenazine" },
  { value: "103906", label: "Fluphenazine Decan" },
  { value: "103907", label: "Fluphenazine HCI" },
  { value: "103908", label: "flupirtine" },
  { value: "103909", label: "fluprednidene" },
  { value: "103910", label: "fluprednidene and antibiotics" },
  { value: "103911", label: "flurazepam" },
  { value: "749", label: "Flurbiprofen" },
  { value: "103912", label: "flurithromycin" },
  { value: "103913", label: "fluspirilene" },
  { value: "750", label: "Flutamide" },
  { value: "751", label: "Fluticasone" },
  { value: "103914", label: "Fluticasone & salmeterol (accuhaler)" },
  { value: "103915", label: "Fluticasone & salmeterol (evohaler)" },
  { value: "100859", label: "Fluticasone furoate" },
  { value: "100860", label: "Fluticasone propionate" },
  { value: "103916", label: "Flutiform" },
  { value: "103917", label: "flutrimazole" },
  { value: "752", label: "Fluvastatin" },
  { value: "753", label: "Fluvestrant" },
  { value: "100861", label: "Fluvirin" },
  { value: "754", label: "Fluvoxamine" },
  { value: "100862", label: "FML" },
  { value: "103918", label: "folic" },
  { value: "755", label: "Folic acid" },
  { value: "103919", label: "folic acid, combinations" },
  { value: "103920", label: "folinic" },
  { value: "100863", label: "Folinic acid" },
  { value: "103921", label: "follitropin" },
  { value: "100864", label: "Follitropin alfa" },
  { value: "100865", label: "Follitropin beta" },
  { value: "756", label: "Folpik" },
  { value: "103922", label: "fomepizole" },
  { value: "103923", label: "fomivirsen" },
  { value: "103924", label: "fondaparinux" },
  { value: "100866", label: "Fondaparinux sodium" },
  { value: "103925", label: "food" },
  { value: "757", label: "Foradil" },
  { value: "103926", label: "Foraven" },
  { value: "103927", label: "Foraven XL" },
  { value: "758", label: "Forceval" },
  { value: "759", label: "Forlax" },
  { value: "100867", label: "Formaldehyde" },
  { value: "103928", label: "formestane" },
  { value: "103929", label: "formocortal" },
  { value: "760", label: "Formoterol" },
  {
    value: "103930",
    label: "formoterol and other drugs for obstructive airway diseases",
  },
  { value: "100868", label: "Forsteo" },
  { value: "100869", label: "Forticare" },
  { value: "100870", label: "Fortini" },
  { value: "103931", label: "Fortipine" },
  { value: "100871", label: "Fortipine LA" },
  { value: "103932", label: "Fortipine LA 40" },
  { value: "103933", label: "fortisip" },
  { value: "100872", label: "Fortisip Bottle" },
  { value: "100873", label: "Fortum" },
  { value: "761", label: "Fortzaar" },
  { value: "103934", label: "Forxiga" },
  { value: "762", label: "Fosamax" },
  { value: "100874", label: "Fosamax Once Weekly" },
  { value: "100875", label: "Fosamprenavir" },
  { value: "100876", label: "Fosaprepitant" },
  { value: "763", label: "Fosavance" },
  { value: "100877", label: "Foscan" },
  { value: "100878", label: "Foscarnet" },
  { value: "100879", label: "Foscavir" },
  { value: "103935", label: "fosfestrol" },
  { value: "103936", label: "fosfocreatine" },
  { value: "103937", label: "fosfomycin" },
  { value: "103938", label: "fosfonet" },
  { value: "764", label: "Fosinopril" },
  { value: "765", label: "Fosphenytoin" },
  { value: "766", label: "Fosrenol" },
  { value: "767", label: "Fostair" },
  { value: "103939", label: "fostamatinib" },
  { value: "100880", label: "Fostimon" },
  { value: "103940", label: "fotemustine" },
  { value: "103941", label: "Fotivda" },
  { value: "768", label: "Fozitec" },
  { value: "100881", label: "Frador" },
  { value: "769", label: "Fragmin" },
  { value: "103942", label: "framycetin" },
  { value: "100882", label: "Framycetin Sulphate" },
  { value: "103943", label: "Fraxiforte" },
  { value: "103944", label: "Fraxiparin" },
  { value: "103945", label: "Fraxiparine" },
  { value: "103946", label: "fraxiparine " },
  { value: "103947", label: "fremanezumab" },
  { value: "100883", label: "Frisium" },
  { value: "103948", label: "froben" },
  { value: "100884", label: "Froben SR" },
  { value: "100885", label: "Frovatriptan" },
  { value: "100886", label: "Fru-Co" },
  { value: "103949", label: "fructose" },
  { value: "103950", label: "fructose 1,6-diphosphate" },
  { value: "770", label: "Frumil" },
  { value: "100887", label: "Frusemide" },
  { value: "100888", label: "Frusene" },
  { value: "100889", label: "Frusol" },
  { value: "771", label: "FuciBET" },
  { value: "100890", label: "Fucidin" },
  { value: "100891", label: "Fucidin H Cream" },
  { value: "772", label: "Fucithalmic" },
  { value: "100892", label: "Fulsovin" },
  { value: "103951", label: "fultium" },
  { value: "103952", label: "Fultium D3" },
  { value: "100893", label: "Fulvestrant" },
  { value: "103953", label: "fumagillin" },
  { value: "103954", label: "fumaric acid" },
  { value: "103955", label: "fumaric acid derivatives, combinations" },
  { value: "100894", label: "Fungizone" },
  { value: "100895", label: "Furadantin" },
  { value: "103956", label: "furazolidone" },
  { value: "773", label: "Furosemide" },
  { value: "103957", label: "furosemide and potassium-sparing agents" },
  { value: "103958", label: "fusafungine" },
  { value: "103959", label: "fusidic" },
  { value: "100896", label: "Fusidic acid" },
  { value: "774", label: "Fuzatal" },
  { value: "100897", label: "Fuzeon" },
  { value: "775", label: "Fybogel" },
  { value: "100898", label: "Fybogel Mebeverine" },
  { value: "103960", label: "Fycompa" },
  { value: "100899", label: "GA Gel" },
  { value: "776", label: "Gabapentin" },
  { value: "103961", label: "Gabitril" },
  { value: "103962", label: "gadobenic acid" },
  { value: "103963", label: "gadobutrol" },
  { value: "103964", label: "gadodiamide" },
  { value: "103965", label: "gadofosveset" },
  { value: "103966", label: "gadopentetic acid" },
  { value: "103967", label: "gadoteric acid" },
  { value: "103968", label: "gadoteridol" },
  { value: "103969", label: "gadoversetamide" },
  { value: "103970", label: "gadoxetic acid" },
  { value: "103971", label: "galactose" },
  { value: "777", label: "Galantamine" },
  { value: "103972", label: "galantex" },
  { value: "103973", label: "galantex xl" },
  { value: "103974", label: "galcanezumab" },
  { value: "103975", label: "galenphol" },
  { value: "100900", label: "Galenphol Paed Linctus" },
  { value: "100901", label: "Galfer" },
  { value: "103976", label: "Galfer FA" },
  { value: "103977", label: "gallamine" },
  { value: "103978", label: "gallium (67Ga) citrate" },
  { value: "103979", label: "gallopamil" },
  { value: "100902", label: "Galpseud" },
  { value: "100903", label: "Galpseud Plus" },
  { value: "100904", label: "Galsud" },
  { value: "103980", label: "galsulfase" },
  { value: "100905", label: "Galvus" },
  { value: "103981", label: "Gamanil" },
  { value: "778", label: "Gambaran" },
  { value: "103982", label: "gammagard" },
  { value: "100906", label: "Gammagard S/D" },
  { value: "100907", label: "Gammaplex" },
  { value: "103983", label: "gamolenic acid" },
  { value: "103984", label: "gamolenic acid, combinations" },
  { value: "100908", label: "Ganciclovir" },
  { value: "100909", label: "Ganfort" },
  { value: "100910", label: "Ganirelix" },
  { value: "100911", label: "Gardasil" },
  { value: "103985", label: "garenoxacin" },
  { value: "103986", label: "gas-gangrene sera" },
  { value: "100912", label: "Gastrocote" },
  { value: "103987", label: "gatalin" },
  { value: "103988", label: "gatalin xl" },
  { value: "103989", label: "gatifloxacin" },
  { value: "103990", label: "gaviscon" },
  { value: "100913", label: "Gaviscon Advance" },
  { value: "103991", label: "Gazyvaro" },
  { value: "103992", label: "gedocarnil" },
  { value: "103993", label: "gefarnate" },
  { value: "103994", label: "gefarnate, combinations with psycholeptics" },
  { value: "100914", label: "Gefitinib" },
  { value: "100915", label: "Gelatin" },
  { value: "103995", label: "gelatin agents" },
  { value: "100916", label: "Gelclair" },
  { value: "100917", label: "GelTears" },
  { value: "779", label: "GemCis" },
  { value: "780", label: "Gemcisplat" },
  { value: "103996", label: "Gemcisplatin" },
  { value: "781", label: "Gemcitabine" },
  { value: "103997", label: "gemeprost" },
  { value: "782", label: "Gemfibrozil" },
  { value: "103998", label: "gemifloxacin" },
  { value: "103999", label: "gemtuzumab" },
  { value: "783", label: "Gemzar" },
  { value: "100918", label: "Generaid" },
  { value: "100919", label: "Generaid Plus" },
  { value: "100920", label: "Generpharm" },
  { value: "104000", label: "genesis" },
  { value: "100921", label: "Genesis Rings" },
  { value: "100922", label: "Gengigel" },
  { value: "784", label: "Genotropin" },
  { value: "785", label: "Gentamicin" },
  { value: "100923", label: "Gentamicin Sulphate" },
  { value: "100924", label: "Genticin" },
  { value: "100925", label: "Genticin Injection" },
  { value: "104001", label: "gentisone" },
  { value: "100926", label: "Gentisone HC" },
  { value: "104002", label: "Genuair" },
  { value: "104003", label: "Genvoya" },
  { value: "104004", label: "gepefrine" },
  { value: "104005", label: "gepirone" },
  { value: "104006", label: "gestodene and estrogen" },
  { value: "100927", label: "Gestone" },
  { value: "104007", label: "gestonorone" },
  { value: "104008", label: "gestrinone" },
  { value: "104009", label: "Gilenya" },
  { value: "104010", label: "gilteritinib" },
  { value: "104011", label: "gimeracil" },
  { value: "104012", label: "ginkgo biloba" },
  { value: "104013", label: "Giotrif" },
  { value: "104014", label: "gitoformate" },
  { value: "104015", label: "glafenine" },
  { value: "100928", label: "Glandosane" },
  { value: "104016", label: "Glargine" },
  { value: "786", label: "Glatiramer" },
  { value: "104017", label: "glatiramer acetate" },
  { value: "104018", label: "glecaprevir and pibrentasvir" },
  { value: "104019", label: "Glepark" },
  { value: "100929", label: "Gliadel" },
  { value: "787", label: "Glibenclamide" },
  { value: "100930", label: "Glibenese" },
  { value: "104020", label: "glibornuride" },
  { value: "788", label: "Gliclazide" },
  { value: "104021", label: "glidipion" },
  { value: "789", label: "Glimepiride" },
  { value: "790", label: "Glipizide" },
  { value: "791", label: "Gliquidone" },
  { value: "104022", label: "glisoxepide" },
  { value: "792", label: "Glivec" },
  { value: "100931", label: "GlucaGen" },
  { value: "100932", label: "Glucagon" },
  { value: "104023", label: "glucarpidase" },
  { value: "104024", label: "Glucidoral" },
  { value: "104025", label: "Glucient" },
  { value: "104026", label: "Glucient SR" },
  { value: "793", label: "Glucobay" },
  { value: "100933", label: "GlucoGel" },
  { value: "794", label: "Gluconorm" },
  { value: "795", label: "Glucophage" },
  { value: "100934", label: "Glucophage SR" },
  { value: "796", label: "Glucor" },
  { value: "100935", label: "Glucosamine" },
  { value: "797", label: "Glucosamine Hydrochloride" },
  { value: "798", label: "Glucosamine Sulphate" },
  { value: "104027", label: "glucosaminoglycan polysulfate" },
  { value: "100936", label: "Glucose" },
  { value: "104028", label: "glucose, combinations" },
  { value: "799", label: "Glucovance" },
  { value: "104029", label: "Glucovil" },
  { value: "800", label: "Glucozene" },
  { value: "104030", label: "Glureg" },
  { value: "801", label: "Glurenorm" },
  { value: "100937", label: "Glusartel" },
  { value: "100938", label: "Glutafin" },
  { value: "104031", label: "glutamic acid hydrochloride" },
  { value: "104032", label: "glutamine" },
  { value: "100939", label: "Glutaraldehyde" },
  { value: "100940", label: "Glutarol" },
  { value: "104033", label: "glutathione" },
  { value: "104034", label: "glutethimide" },
  { value: "104035", label: "Glybera" },
  { value: "802", label: "Glyburide" },
  { value: "100941", label: "Glycerdex" },
  { value: "100942", label: "Glycerin" },
  { value: "100943", label: "Glycerol" },
  { value: "104036", label: "Glycerol (as suppository)" },
  { value: "104037", label: "glyceryl" },
  { value: "803", label: "Glyceryl Trinitrate" },
  { value: "104038", label: "glyceryl trinitrate, combinations" },
  { value: "104039", label: "glycine" },
  { value: "104040", label: "glycobiarsol" },
  { value: "104041", label: "glycobiarsol, combinations" },
  { value: "100944", label: "Glycogen" },
  { value: "104042", label: "glycopyrronium" },
  { value: "104043", label: "glycopyrronium and psycholeptics" },
  { value: "100945", label: "Glycopyrronium bromide" },
  { value: "100946", label: "Glycosade" },
  { value: "104044", label: "glycyrrhizic acid" },
  { value: "104045", label: "glymidine" },
  { value: "804", label: "Glypressin" },
  { value: "805", label: "Glytrin" },
  { value: "100947", label: "Glytrin Spray" },
  { value: "104046", label: "Gold" },
  { value: "104047", label: "gold (198Au) colloidal" },
  { value: "100948", label: "Golden Eye" },
  { value: "104048", label: "golimumab" },
  { value: "104049", label: "gonadorelin" },
  { value: "100949", label: "Gonal-F" },
  { value: "100950", label: "Gonapeptyl" },
  { value: "806", label: "Gopten" },
  { value: "807", label: "Goserelin" },
  { value: "100951", label: "Gramicidin" },
  { value: "100952", label: "Granisetron" },
  { value: "100953", label: "Granocyte" },
  { value: "104050", label: "grass pollen" },
  { value: "100954", label: "Grazax" },
  { value: "104051", label: "grepafloxacin" },
  { value: "808", label: "Grepid" },
  { value: "100955", label: "Griseofulvin" },
  { value: "104052", label: "grisol" },
  { value: "100956", label: "Grisol AF" },
  { value: "104053", label: "gsf-syrup" },
  { value: "104054", label: "g-strophanthin" },
  { value: "809", label: "GTN" },
  { value: "104055", label: "guacetisal" },
  { value: "104056", label: "guaiacolsulfonate" },
  { value: "104057", label: "guaiazulen" },
  { value: "104058", label: "guaifenesin" },
  { value: "104059", label: "guanazodine" },
  { value: "100957", label: "Guanethidine" },
  { value: "104060", label: "guanethidine and diuretics" },
  { value: "104061", label: "guanfacine" },
  { value: "104062", label: "guanoclor" },
  { value: "104063", label: "guanoxabenz" },
  { value: "104064", label: "guanoxan" },
  { value: "104065", label: "guar gum" },
  { value: "104066", label: "guselkumab" },
  { value: "104067", label: "gusperimus" },
  { value: "810", label: "Gutron" },
  { value: "104068", label: "gynest" },
  { value: "100958", label: "Gynest Cream" },
  { value: "104069", label: "gyno-daktarin" },
  { value: "100959", label: "Gyno-Daktarin 1" },
  { value: "104070", label: "gyno-pevaryl" },
  { value: "100960", label: "Gyno-Pevaryl 1" },
  { value: "104071", label: "HAART" },
  { value: "104072", label: "hachimycin" },
  { value: "100961", label: "Haelan" },
  { value: "104073", label: "haemate" },
  { value: "100962", label: "Haemate P" },
  { value: "100963", label: "Haemophilus Influenzae Type B" },
  { value: "104074", label: "Halaven" },
  { value: "104075", label: "halazepam" },
  { value: "104076", label: "halcinonide" },
  { value: "100964", label: "Haldol" },
  { value: "104077", label: "haldol oral liquid" },
  { value: "811", label: "Half Beta Prograne" },
  { value: "104078", label: "Half Securon SR" },
  { value: "104079", label: "Half Sinemet" },
  { value: "104080", label: "Half Sinemet CR" },
  { value: "104081", label: "half-inderal" },
  { value: "100965", label: "Half-Inderal LA" },
  { value: "104082", label: "halofantrine" },
  { value: "104083", label: "halometasone" },
  { value: "812", label: "Haloperidol" },
  { value: "104084", label: "Haloperidol Decan" },
  { value: "104085", label: "haloprogin" },
  { value: "104086", label: "halothane" },
  { value: "100966", label: "Harifen" },
  { value: "104087", label: "Harvoni" },
  { value: "104088", label: "havrix" },
  { value: "100967", label: "Havrix Monodose" },
  { value: "100968", label: "Hay-Crom" },
  { value: "100969", label: "Haymine" },
  { value: "100970", label: "HBvaxPRO" },
  { value: "813", label: "HCTZ" },
  { value: "100971", label: "HCU Express" },
  { value: "100972", label: "HCU-LV" },
  { value: "814", label: "Helicidine" },
  { value: "104089", label: "helicobacter" },
  { value: "100973", label: "Helicobacter Test Infai" },
  { value: "104090", label: "helium" },
  { value: "104091", label: "helixate" },
  { value: "100974", label: "Helixate NexGen" },
  { value: "100975", label: "Hemabate" },
  { value: "104092", label: "hematin" },
  { value: "815", label: "Hemigoxine" },
  { value: "100976", label: "Hemin" },
  { value: "100977", label: "Heminevrin" },
  { value: "100978", label: "Hemocane" },
  { value: "104093", label: "hemoglobin crosfumaril" },
  { value: "104094", label: "hemoglobin glutamer (bovine)" },
  { value: "104095", label: "hemoglobin raffimer" },
  { value: "104096", label: "hemophilus influenzae B and hepatitis B" },
  { value: "104097", label: "hemophilus influenzae B and poliomyelitis" },
  {
    value: "104098",
    label:
      "hemophilus influenzae B, combinations with meningococcus C, conjugated",
  },
  {
    value: "104099",
    label: "hemophilus influenzae B, combinations with pertussis and toxoids",
  },
  {
    value: "104100",
    label: "hemophilus influenzae B, combinations with toxoids",
  },
  {
    value: "104101",
    label: "hemophilus influenzae B, purified antigen conjugated",
  },
  { value: "816", label: "Heparin" },
  { value: "104102", label: "heparin calcium" },
  { value: "104103", label: "heparin sodium" },
  { value: "104104", label: "heparin, combinations" },
  { value: "100979", label: "Heparinoid" },
  { value: "104105", label: "heparinoid, combinations" },
  { value: "104106", label: "heparon" },
  { value: "100980", label: "Heparon Junior" },
  { value: "104107", label: "hepatitis A immunoglobulin" },
  { value: "104108", label: "hepatitis A, inactivated, whole virus" },
  { value: "104109", label: "hepatitis B immunoglobulin" },
  { value: "104110", label: "hepatitis B, purified antigen" },
  { value: "100983", label: "Hepatyrix" },
  { value: "100984", label: "Hepsal" },
  { value: "100985", label: "Hepsera" },
  { value: "104111", label: "heptabarbital" },
  { value: "104112", label: "heptaminol" },
  { value: "817", label: "Herceptin" },
  { value: "100986", label: "Herpid" },
  { value: "104113", label: "hetacillin" },
  { value: "104114", label: "hexachlorophene" },
  { value: "104115", label: "hexafluronium" },
  { value: "104116", label: "hexamidine" },
  { value: "104117", label: "Hexamine hippurate" },
  { value: "104118", label: "hexapropymate" },
  { value: "100987", label: "Hexetidine" },
  { value: "104119", label: "hexobarbital" },
  { value: "104120", label: "hexobendine" },
  { value: "104121", label: "hexocyclium" },
  { value: "100988", label: "Hexopal" },
  { value: "104122", label: "hexopal forte" },
  { value: "104123", label: "hexoprenaline" },
  { value: "104124", label: "hexyl" },
  { value: "100989", label: "Hexyl Nicotinate" },
  { value: "104125", label: "hexylresorcinol" },
  { value: "100990", label: "Hib Vaccine" },
  { value: "100991", label: "Hiberix" },
  { value: "100992", label: "HiBi Liquid Hand Rub+" },
  { value: "100993", label: "Hibi Tane Plus" },
  { value: "100994", label: "Hibiscrub" },
  { value: "818", label: "Hidrosaluretil" },
  { value: "104126", label: "hidrosmin" },
  { value: "819", label: "Hidroxil" },
  { value: "100995", label: "Hiprex" },
  { value: "100996", label: "Hirudoid" },
  { value: "100997", label: "Histamine" },
  { value: "104127", label: "histamine dihydrochloride" },
  { value: "104128", label: "histamine phosphate" },
  { value: "104129", label: "histapyrrodine" },
  { value: "104130", label: "histapyrrodine, combinations" },
  { value: "100998", label: "Histrelin" },
  { value: "820", label: "Hjerdyl" },
  { value: "100999", label: "Homatropine" },
  { value: "104131", label: "Horizem" },
  { value: "101000", label: "Hormonin" },
  { value: "104132", label: "house dust mites" },
  { value: "821", label: "Humalog" },
  { value: "101001", label: "Humalog Mix25" },
  { value: "104133", label: "Humalog Mix50" },
  { value: "104134", label: "human fibrinogen" },
  { value: "822", label: "Human Insulatard" },
  { value: "104135", label: "human menopausal gonadotrophin" },
  { value: "823", label: "Human Mixtard" },
  { value: "101002", label: "Human papillomavirus vaccine" },
  { value: "101003", label: "Human protein C" },
  { value: "101004", label: "Humatrope" },
  { value: "824", label: "Humira" },
  { value: "825", label: "Humulin" },
  { value: "101005", label: "Humulin I" },
  { value: "101006", label: "Humulin M3" },
  { value: "101007", label: "Humulin S" },
  { value: "101008", label: "Hyabak" },
  { value: "101009", label: "Hyalase" },
  { value: "101010", label: "Hyalgan" },
  { value: "104136", label: "hyaluronic" },
  { value: "101011", label: "Hyaluronic acid" },
  { value: "104137", label: "hyaluronic acid, combinations" },
  { value: "101012", label: "Hyaluronidase" },
  { value: "101013", label: "Hycamtin" },
  { value: "826", label: "Hydralazine" },
  { value: "104138", label: "hydralazine and diuretics" },
  { value: "104139", label: "Hydralazine HCI" },
  { value: "827", label: "Hydrea" },
  { value: "101014", label: "Hydrex" },
  { value: "104140", label: "hydrochloric acid" },
  { value: "828", label: "Hydrochlorothiazide" },
  {
    value: "104141",
    label: "hydrochlorothiazide and potassium-sparing agents",
  },
  { value: "104142", label: "hydrochlorothiazide, combinations" },
  { value: "104143", label: "hydrocodone" },
  { value: "829", label: "Hydrocortisone" },
  { value: "104144", label: "hydrocortisone aceponate" },
  { value: "104145", label: "Hydrocortisone acetate (foam enema)" },
  { value: "104146", label: "hydrocortisone and antibiotics" },
  { value: "104147", label: "hydrocortisone and antiinfectives" },
  { value: "104148", label: "hydrocortisone and antiseptics" },
  { value: "104149", label: "hydrocortisone and mydriatics" },
  { value: "104150", label: "hydrocortisone buteprate" },
  { value: "101015", label: "Hydrocortisone butyrate" },
  { value: "104151", label: "hydrocortisone butyrate and antiseptics" },
  { value: "104152", label: "hydrocortisone, combinations" },
  { value: "101016", label: "Hydrocortistab" },
  { value: "101017", label: "Hydroflumethiazide" },
  { value: "104153", label: "hydroflumethiazide, combinations" },
  { value: "101018", label: "Hydrogen peroxide" },
  { value: "101019", label: "Hydromol" },
  { value: "101020", label: "Hydromoor" },
  { value: "101021", label: "Hydromorphone" },
  { value: "104154", label: "hydromorphone and antispasmodics" },
  { value: "104155", label: "Hydromorphone hydrochloride" },
  { value: "104156", label: "hydroquinine" },
  { value: "104157", label: "hydroquinone" },
  { value: "104158", label: "hydrotalcite" },
  { value: "830", label: "Hydroxocobalamin" },
  { value: "104159", label: "hydroxocobalamin, combinations" },
  { value: "831", label: "Hydroxycarbamide" },
  { value: "832", label: "Hydroxychloroquine" },
  { value: "101022", label: "Hydroxyethylcellulose" },
  { value: "104160", label: "hydroxyethylpromethazine" },
  { value: "104161", label: "hydroxyethylpromethazine, combinations" },
  { value: "104162", label: "hydroxyethylstarch" },
  { value: "104163", label: "hydroxyprogesterone" },
  { value: "104164", label: "hydroxypropyl" },
  { value: "101023", label: "Hydroxypropyl Guar" },
  { value: "833", label: "Hydroxyurea" },
  { value: "834", label: "Hydroxyzine" },
  { value: "104165", label: "hydroxyzine, combinations" },
  { value: "104166", label: "Hydventia" },
  { value: "835", label: "Hygroton" },
  { value: "101024", label: "Hylan" },
  { value: "101025", label: "Hylo-Tear" },
  { value: "104167", label: "hymecromone" },
  { value: "836", label: "Hyoscine" },
  { value: "837", label: "Hyoscine butylbromide" },
  { value: "104168", label: "Hyoscine hydrobromide" },
  { value: "104169", label: "Hyoscine Patches (all strengths)" },
  { value: "104170", label: "hyoscyamine" },
  { value: "104171", label: "hyoscyamine and psycholeptics" },
  { value: "104172", label: "hyperglycarm" },
  { value: "838", label: "Hyperium" },
  { value: "101026", label: "Hypnomidate" },
  { value: "101027", label: "Hypnovel" },
  { value: "101028", label: "Hypo-Fit" },
  { value: "104173", label: "Hypolar" },
  { value: "839", label: "Hypovase" },
  { value: "840", label: "Hypromellose" },
  { value: "841", label: "Hypurin" },
  { value: "101029", label: "Hypurin Bovine Isophane" },
  { value: "101030", label: "Hypurin Bovine Lente" },
  { value: "101031", label: "Hypurin Bovine Neutral" },
  { value: "104174", label: "Hypurin Bovine Protamine Zinc" },
  { value: "101032", label: "Hypurin Bovine PZI" },
  { value: "101033", label: "Hypurin Porcine 30/70" },
  { value: "104175", label: "Hypurin Porcine 30/70 Mix" },
  { value: "101034", label: "Hypurin Porcine Isophane" },
  { value: "101035", label: "Hypurin Porcine Neutral" },
  { value: "104176", label: "Hyrimoz" },
  { value: "842", label: "Hytacand" },
  { value: "843", label: "Hytrin" },
  { value: "844", label: "Hyzaar" },
  { value: "104177", label: "ibacitabine" },
  { value: "101036", label: "Ibandronate" },
  { value: "104178", label: "ibandronic" },
  { value: "845", label: "Ibandronic Acid" },
  { value: "104179", label: "Ibandronic Acid Tablets 150mg" },
  { value: "104180", label: "ibopamine" },
  { value: "104181", label: "Ibrance" },
  { value: "104182", label: "ibritumomab tiuxetan [90Y]" },
  { value: "104183", label: "ibrutinib" },
  { value: "104184", label: "ibudilast" },
  { value: "101037", label: "Ibugel" },
  { value: "846", label: "Ibuprofen" },
  { value: "104185", label: "Ibuprofen & codeine 300mg/20mg" },
  { value: "104186", label: "ibuprofen, combinations" },
  { value: "104187", label: "ibuproxam" },
  { value: "104188", label: "ibutilide" },
  { value: "104189", label: "icatibant" },
  { value: "101038", label: "Icatibant acetate" },
  { value: "101039", label: "ICD" },
  { value: "104190", label: "ichtasol" },
  { value: "104191", label: "iclaprim" },
  { value: "104192", label: "Iclusig" },
  { value: "104193", label: "icosapent ethyl" },
  { value: "104194", label: "Idacio" },
  { value: "104195", label: "idanpramine" },
  { value: "101040", label: "Idarubicin" },
  { value: "104196", label: "idebenone" },
  { value: "104197", label: "Idefirix" },
  { value: "104198", label: "idelalisib" },
  { value: "101041", label: "Idoxuridine" },
  { value: "104199", label: "idrocilamide" },
  { value: "101042", label: "Idursulfase" },
  { value: "104200", label: "ifenprodil" },
  { value: "104201", label: "ifosfamide" },
  { value: "847", label: "Ikorel" },
  { value: "104202", label: "Illumetri" },
  { value: "104203", label: "Iloperidone" },
  { value: "848", label: "Iloprost" },
  { value: "104204", label: "Iluvien" },
  { value: "849", label: "Imanitib" },
  { value: "101043", label: "Imatinib" },
  { value: "104205", label: "Imbruvica" },
  { value: "850", label: "Imdur" },
  { value: "104206", label: "Imfinzi" },
  { value: "851", label: "Imidapril" },
  { value: "104207", label: "imidazole salicylate" },
  { value: "104208", label: "imiglucerase" },
  { value: "852", label: "Imigran" },
  { value: "101044", label: "Imipenem" },
  { value: "104209", label: "imipenem and enzyme inhibitor" },
  { value: "853", label: "Imipramine" },
  { value: "104210", label: "imipramine oxide" },
  { value: "854", label: "Imiquimod" },
  { value: "104211", label: "Imlifidase" },
  { value: "104212", label: "Imlygic" },
  { value: "104213", label: "immunocyanin" },
  { value: "101045", label: "Immunoglobulin" },
  {
    value: "104214",
    label: "immunoglobulins, normal human, for extravascular adm.",
  },
  {
    value: "104215",
    label: "immunoglobulins, normal human, for intravascular adm.",
  },
  { value: "104216", label: "Imnovid" },
  { value: "104217", label: "imolamine" },
  { value: "855", label: "Imovane" },
  { value: "104218", label: "Imraldi" },
  { value: "856", label: "Imuran" },
  { value: "857", label: "Imurel" },
  { value: "858", label: "Inacid" },
  { value: "104219", label: "Incivo" },
  { value: "104220", label: "inclisiran" },
  { value: "104221", label: "incruse" },
  { value: "104222", label: "Incruse Ellipta" },
  { value: "101048", label: "Indacaterol" },
  { value: "859", label: "Indapamide" },
  { value: "860", label: "Inderal" },
  { value: "101049", label: "Inderal LA" },
  { value: "104223", label: "indigo carmine" },
  { value: "101050", label: "Indinavir" },
  { value: "104224", label: "Indipam" },
  { value: "104225", label: "indium (111In) antiovariumcarcinoma antibody" },
  { value: "104226", label: "indium (111In) capromab pendetide" },
  { value: "104227", label: "indium (111In) imciromab" },
  { value: "104228", label: "indium (111In) oxinate labelled cells" },
  { value: "104229", label: "indium (111In) pentetic acid" },
  { value: "104230", label: "indium (111In) pentetreotide" },
  { value: "104231", label: "indium (111In) satumomab pendetide" },
  { value: "104232", label: "indium (111In) tropolonate labelled cells" },
  { value: "861", label: "Indivina" },
  { value: "104233", label: "indobufen" },
  { value: "862", label: "Indometacin" },
  { value: "104234", label: "indometacin, combinations" },
  { value: "104235", label: "Indomethacin" },
  { value: "104236", label: "indoprofen" },
  { value: "863", label: "Indoramin" },
  { value: "864", label: "Inegy" },
  { value: "865", label: "Inexium" },
  { value: "104237", label: "Inflectra" },
  { value: "866", label: "Infliximab" },
  { value: "101051", label: "Influenza vaccine" },
  {
    value: "104238",
    label: "influenza, inactivated, split virus or surface antigen",
  },
  { value: "104239", label: "influenza, inactivated, whole virus" },
  { value: "104240", label: "influenza, live attenuated" },
  { value: "101052", label: "Influvac" },
  { value: "101053", label: "Inhaler" },
  { value: "101054", label: "Inhalers" },
  { value: "104241", label: "Inhixa" },
  { value: "104242", label: "Inlyta" },
  { value: "101055", label: "Innohep" },
  { value: "867", label: "Innovace" },
  { value: "868", label: "Innozide" },
  { value: "104243", label: "Inonorm drops" },
  { value: "104244", label: "inosine" },
  { value: "104245", label: "inosine pranobex" },
  { value: "104246", label: "inositol" },
  { value: "101056", label: "Inositol nicotinate" },
  { value: "104247", label: "inotuzumab ozogamicin" },
  { value: "101057", label: "Inovelon" },
  { value: "104248", label: "Inrebic" },
  { value: "104249", label: "insects" },
  { value: "869", label: "Inspra" },
  { value: "101058", label: "Instanyl" },
  { value: "101059", label: "Instillagel" },
  { value: "870", label: "Insulatard" },
  { value: "101060", label: "Insulin" },
  { value: "104250", label: "insulin (beef)" },
  { value: "104251", label: "insulin (human)" },
  { value: "104252", label: "insulin (pork)" },
  { value: "101061", label: "Insulin Aspart" },
  { value: "104253", label: "insulin degludec" },
  { value: "101062", label: "Insulin Detemir" },
  { value: "101063", label: "Insulin Glargine" },
  { value: "101064", label: "Insulin Glulisine" },
  { value: "101065", label: "Insulin Injection" },
  { value: "101066", label: "Insulin Lispro" },
  { value: "101067", label: "Insulin Zinc Suspension" },
  { value: "101068", label: "Insuman" },
  { value: "101069", label: "Insuman Basal" },
  { value: "101070", label: "Insuman Comb" },
  { value: "104254", label: "Insuman Comb 15" },
  { value: "104255", label: "Insuman Comb 25" },
  { value: "104256", label: "Insuman Comb 50" },
  { value: "101071", label: "Insuman Rapid" },
  { value: "104257", label: "Intal" },
  { value: "101072", label: "Intal Inhaler" },
  { value: "101073", label: "Integrilin" },
  { value: "871", label: "Intelence" },
  { value: "104258", label: "interferon" },
  { value: "101074", label: "Interferon alfa" },
  { value: "104259", label: "interferon alfa natural" },
  { value: "104260", label: "interferon alfa-2a" },
  { value: "104261", label: "interferon alfa-2b" },
  { value: "104262", label: "interferon alfacon-1" },
  { value: "104263", label: "interferon alfa-n1" },
  { value: "872", label: "Interferon Alpha" },
  { value: "873", label: "Interferon Beta" },
  { value: "104264", label: "interferon beta natural" },
  { value: "104265", label: "interferon beta-1a" },
  { value: "104266", label: "interferon beta-1b" },
  { value: "874", label: "Interferon Gamma" },
  { value: "104267", label: "interleukin" },
  { value: "875", label: "Interleukin 2" },
  { value: "101075", label: "Intrinsa" },
  { value: "101076", label: "IntronA" },
  { value: "104268", label: "inulin and other polyfructosans" },
  { value: "101077", label: "Invanz" },
  { value: "101078", label: "Invega" },
  { value: "104269", label: "invert sugar" },
  { value: "101079", label: "Invirase" },
  { value: "104270", label: "Invokana" },
  { value: "104271", label: "iobenguane (123I)" },
  { value: "104272", label: "iobenguane (131I)" },
  { value: "104273", label: "iobenzamic acid" },
  { value: "104274", label: "iobitridol" },
  { value: "104275", label: "iocarmic acid" },
  { value: "104276", label: "iocetamic acid" },
  { value: "104277", label: "iodamide" },
  { value: "104278", label: "iodine" },
  {
    value: "104279",
    label: "iodine (124I) 2beta-carbomethoxy-3beta-(4 iodophenyl)-tropane",
  },
  { value: "104280", label: "iodine (125I) CC49-monoclonal antibody" },
  { value: "104281", label: "iodine (125I) human albumin" },
  { value: "104282", label: "iodine (131I) human albumin" },
  { value: "104283", label: "iodine (131I) norcholesterol" },
  { value: "104284", label: "iodine iofetamine (123I)" },
  { value: "104285", label: "iodine ioflupane (123I)" },
  { value: "104286", label: "iodine iolopride (123I)" },
  { value: "104287", label: "iodine/octylphenoxypolyglycolether" },
  { value: "104288", label: "iodixanol" },
  { value: "104289", label: "iodocholesterol (131I)" },
  { value: "104290", label: "iodoform" },
  { value: "104291", label: "iodoheparinate" },
  { value: "104292", label: "iodoxamic acid" },
  { value: "104293", label: "iofendylate" },
  { value: "104294", label: "ioglicic acid" },
  { value: "104295", label: "ioglycamic acid" },
  { value: "104296", label: "iohexol" },
  { value: "104297", label: "iomeprol" },
  { value: "104298", label: "iopamidol" },
  { value: "104299", label: "iopanoic acid" },
  { value: "104300", label: "iopentol" },
  { value: "101080", label: "Iopidine" },
  { value: "104301", label: "iopromide" },
  { value: "104302", label: "iopydol" },
  { value: "104303", label: "iotalamic acid" },
  { value: "104304", label: "iotrolan" },
  { value: "104305", label: "iotroxic acid" },
  { value: "104306", label: "ioversol" },
  { value: "104307", label: "ioxaglic acid" },
  { value: "104308", label: "ioxilan" },
  { value: "104309", label: "ioxitalamic acid" },
  { value: "104310", label: "ipecacuanha" },
  { value: "104311", label: "Iperten" },
  { value: "104312", label: "ipilimumab" },
  { value: "104313", label: "Ipinnia" },
  { value: "101081", label: "Ipocol" },
  { value: "104314", label: "Ipramol" },
  { value: "104315", label: "Ipratropium" },
  { value: "876", label: "Ipratropium Bromide" },
  { value: "101082", label: "Ipratropium Steri-Neb" },
  { value: "104316", label: "iprazochrome" },
  { value: "104317", label: "ipriflavone" },
  { value: "104318", label: "iprindole" },
  { value: "104319", label: "Iprivask" },
  { value: "104320", label: "iproclozide" },
  { value: "104321", label: "iproniazide" },
  { value: "877", label: "Irbesartan" },
  { value: "104322", label: "irbesartan and diuretics" },
  { value: "101083", label: "Iressa" },
  { value: "101084", label: "Irinotecan" },
  { value: "104323", label: "iron and multivitamins" },
  { value: "104324", label: "Iron dextran" },
  { value: "104325", label: "Iron Isomaltoside 1000" },
  { value: "104326", label: "iron oxide, nanoparticles" },
  { value: "104327", label: "Iron sucrose" },
  { value: "104328", label: "iron, multivitamins and folic acid" },
  { value: "104329", label: "iron, multivitamins and minerals" },
  { value: "104330", label: "iron, vitamin B12 and folic acid" },
  { value: "104331", label: "iron-hydroxide" },
  { value: "101085", label: "Iron-hydroxide dextran complex" },
  { value: "101086", label: "Iron-hydroxide sucrose complex" },
  { value: "104332", label: "iron-sorbitol-citric acid complex" },
  { value: "101087", label: "Irriclens" },
  { value: "101088", label: "Irripod" },
  { value: "104333", label: "isatuximab" },
  { value: "878", label: "Iscover" },
  { value: "101089", label: "Isentress" },
  { value: "104334", label: "isepamicin" },
  { value: "879", label: "Isib" },
  { value: "101090", label: "Isib 60 XL" },
  { value: "101091", label: "Ismelin" },
  { value: "880", label: "ISMN" },
  { value: "881", label: "Ismo" },
  { value: "101092", label: "Ismo Retard" },
  { value: "104335", label: "isoaminile" },
  { value: "104336", label: "isobromindione" },
  { value: "101093", label: "Isocarboxazid" },
  { value: "104337", label: "isoconazole" },
  { value: "104338", label: "Isodur" },
  { value: "101094", label: "Isodur XL" },
  { value: "104339", label: "isoetarine" },
  { value: "104340", label: "isoflurane" },
  { value: "882", label: "Isogel" },
  { value: "101095", label: "Isoket" },
  { value: "101096", label: "Isoket Infusion" },
  { value: "101097", label: "Isoket retard" },
  { value: "101098", label: "Isoleucine" },
  { value: "101099", label: "Isoleucine AA Supplement" },
  { value: "101100", label: "Isometheptene" },
  { value: "883", label: "Isoniazid" },
  { value: "104341", label: "isoniazid, combinations" },
  { value: "104342", label: "isophane" },
  { value: "101101", label: "Isophane Insulin" },
  { value: "104343", label: "isoprenaline" },
  {
    value: "104344",
    label: "isoprenaline and other drugs for obstructive airway diseases",
  },
  { value: "104345", label: "isoprenaline, combinations" },
  { value: "104346", label: "isopropamide" },
  { value: "104347", label: "isopropamide and psycholeptics" },
  { value: "104348", label: "isopropanol" },
  { value: "104349", label: "isopropyl" },
  { value: "884", label: "Isopropyl Myristate" },
  { value: "104350", label: "Isoproterenol" },
  { value: "104351", label: "isopto" },
  { value: "101102", label: "Isopto Alkaline" },
  { value: "101103", label: "Isopto Plain" },
  { value: "104352", label: "isosorbide" },
  { value: "885", label: "Isosorbide Dinitrate" },
  { value: "104353", label: "isosorbide dinitrate, combinations" },
  { value: "886", label: "Isosorbide Mononitrate" },
  { value: "887", label: "Isotard" },
  { value: "101104", label: "Isotard XL" },
  { value: "104354", label: "isothipendyl" },
  { value: "888", label: "Isotretinoin" },
  { value: "104355", label: "isotretinoin, combinations" },
  { value: "101105", label: "Isotrex" },
  { value: "101106", label: "Isotrexin" },
  { value: "101107", label: "Isovorin" },
  { value: "104356", label: "isoxsuprine" },
  { value: "101108", label: "Ispagel" },
  { value: "889", label: "Ispaghula" },
  { value: "104357", label: "Ispaghula & senna 54.2%/12.4%" },
  { value: "104358", label: "ispaghula (psylla seeds)" },
  { value: "104359", label: "Ispaghula husk" },
  { value: "104360", label: "ispaghula, combinations" },
  { value: "890", label: "Isradipine" },
  { value: "891", label: "Istin" },
  { value: "104361", label: "Isuprel" },
  { value: "892", label: "Itraconazole" },
  { value: "104362", label: "itramin tosilate" },
  { value: "104363", label: "itramin tosilate, combinations" },
  { value: "893", label: "Ivabradine" },
  { value: "104364", label: "ivacaftor" },
  { value: "101109", label: "Ivemend" },
  { value: "104365", label: "ivermectin" },
  { value: "104366", label: "ixabepilone" },
  { value: "104367", label: "ixazomib" },
  { value: "104368", label: "ixekizumab" },
  { value: "894", label: "Ixia" },
  { value: "101110", label: "Ixiaro" },
  { value: "104369", label: "Jakavi" },
  { value: "101111", label: "Janumet" },
  { value: "895", label: "Januvia" },
  { value: "101112", label: "Japanese encephalitis" },
  { value: "104370", label: "Jardiance" },
  { value: "101113", label: "Javlor" },
  { value: "104371", label: "Jemperli" },
  { value: "104372", label: "Jentadueto" },
  { value: "101114", label: "Jet Nebuliser" },
  { value: "104373", label: "Jevtana" },
  { value: "104374", label: "josamycin" },
  { value: "104375", label: "juvela" },
  { value: "101115", label: "Juvela Gluten-Free" },
  { value: "101116", label: "Juvela Low Protein" },
  { value: "104376", label: "Jyseleca" },
  { value: "104377", label: "Kadcyla" },
  { value: "896", label: "Kaletra" },
  { value: "104378", label: "kallidinogenase" },
  { value: "897", label: "Kalms" },
  { value: "104379", label: "kalpress" },
  { value: "898", label: "Kalpress Plus" },
  { value: "101117", label: "Kalspare" },
  { value: "899", label: "Kalten" },
  { value: "104380", label: "kalydeco" },
  { value: "101118", label: "Kamillosan" },
  { value: "104381", label: "kanamycin" },
  { value: "104382", label: "kaolin" },
  { value: "104383", label: "Kaolin & Morphine Mixture" },
  { value: "104384", label: "Kaolin Mixture BP" },
  { value: "101119", label: "Kapake" },
  { value: "104385", label: "Kaplon" },
  { value: "900", label: "Kardegic" },
  { value: "104386", label: "kebuzone" },
  { value: "101120", label: "Kefadim" },
  { value: "901", label: "Keflex" },
  { value: "104387", label: "Keloc SR" },
  { value: "101121", label: "Kemadrin" },
  { value: "104388", label: "kemicetine" },
  { value: "101122", label: "Kemicetine Succinate" },
  { value: "902", label: "Kenalog" },
  { value: "101123", label: "Kentera" },
  { value: "104389", label: "Kentipine" },
  { value: "104390", label: "Kentipine MR" },
  { value: "104391", label: "Kenzem" },
  { value: "101124", label: "Kepivance" },
  { value: "903", label: "Keppra" },
  { value: "101125", label: "Keral" },
  { value: "904", label: "Kerlone" },
  { value: "101126", label: "Keromask" },
  { value: "104392", label: "Kesimpta" },
  { value: "101127", label: "Ketalar" },
  { value: "101128", label: "Ketamine" },
  { value: "104393", label: "ketanserin" },
  { value: "104394", label: "ketazolam" },
  { value: "101129", label: "Ketek" },
  { value: "104395", label: "ketobemidone" },
  { value: "104396", label: "ketobemidone and antispasmodics" },
  { value: "101130", label: "Ketocal" },
  { value: "101131", label: "Ketocid" },
  { value: "905", label: "Ketoconazole" },
  { value: "906", label: "Ketoprofen" },
  { value: "104397", label: "ketoprofen, combinations" },
  { value: "101132", label: "Ketorolac" },
  { value: "101133", label: "Ketotifen" },
  { value: "907", label: "Ketovite" },
  { value: "104398", label: "Kevzara" },
  { value: "101134", label: "KeyOmega" },
  { value: "104399", label: "Keytruda" },
  { value: "101135", label: "Kineret" },
  { value: "104400", label: "kinidin" },
  { value: "101136", label: "Kinidin Durules" },
  { value: "104401", label: "Kinzalmono" },
  { value: "101137", label: "Kiovig" },
  { value: "104402", label: "Kisplyx" },
  { value: "104403", label: "Kisqali" },
  { value: "908", label: "Kivexa" },
  { value: "104404", label: "klaricid" },
  { value: "101138", label: "Klaricid XL" },
  { value: "101139", label: "Klean-Prep" },
  { value: "909", label: "Kliofem" },
  { value: "910", label: "Kliovance" },
  { value: "911", label: "Klipal" },
  { value: "104405", label: "kogenate" },
  { value: "101140", label: "Kogenate Bayer" },
  { value: "101141", label: "Kolanticon" },
  { value: "104406", label: "Komboglyze" },
  { value: "104407", label: "konakion" },
  { value: "101142", label: "Konakion MM" },
  { value: "104408", label: "krypton (81mKr) gas" },
  { value: "104409", label: "Kymriah" },
  { value: "104410", label: "Kyntheum" },
  { value: "104411", label: "Kyprolis" },
  { value: "101143", label: "Kytril" },
  { value: "104412", label: "laaglyda" },
  { value: "104413", label: "laaglyda mr" },
  { value: "912", label: "Labetalol" },
  { value: "104414", label: "labetalol and other diuretics" },
  { value: "104415", label: "labetalol and thiazides" },
  { value: "104416", label: "Labetolol" },
  { value: "913", label: "Lacerol" },
  { value: "101147", label: "Lacidipine" },
  { value: "914", label: "Lacidpine" },
  { value: "104417", label: "Lacitol" },
  { value: "915", label: "Lacosamide" },
  { value: "104418", label: "Lacosemide" },
  { value: "101148", label: "Lacri-Lube" },
  { value: "101149", label: "Lactase" },
  { value: "101150", label: "Lactic Acid" },
  { value: "104419", label: "lactic acid producing organisms" },
  { value: "104420", label: "lactic acid producing organisms, combinations" },
  { value: "104421", label: "lactitol" },
  { value: "104422", label: "lactobacillus fermentum" },
  { value: "101151", label: "Lactugal" },
  { value: "916", label: "Lactulose" },
  { value: "104423", label: "lactulose, combinations" },
  { value: "104424", label: "lafutidine" },
  { value: "917", label: "Lamictal" },
  { value: "101152", label: "Lamisil" },
  { value: "101153", label: "Lamisil Cream" },
  { value: "104425", label: "Lamistal" },
  { value: "918", label: "Lamivudine" },
  { value: "919", label: "Lamotrigine" },
  { value: "104426", label: "lanadelumab" },
  { value: "104427", label: "lanatoside C" },
  { value: "101154", label: "Lanolin" },
  { value: "920", label: "Lanoxin" },
  { value: "921", label: "Lanreotide" },
  { value: "922", label: "Lansoprazole" },
  { value: "104428", label: "lansoprazole, combinations" },
  { value: "923", label: "Lanthanum" },
  { value: "104429", label: "lanthanum carbonate" },
  { value: "924", label: "Lantus" },
  { value: "101155", label: "Lanvis" },
  { value: "925", label: "Lanzopral" },
  { value: "926", label: "Lapatinib" },
  { value: "104430", label: "Largactil" },
  { value: "101156", label: "Largactil Injection" },
  { value: "101157", label: "Lariam" },
  { value: "104431", label: "laronidase" },
  { value: "101158", label: "Laropiprant" },
  { value: "104432", label: "Laropripant" },
  { value: "104433", label: "larotrectinib" },
  { value: "104434", label: "Lartruvo" },
  { value: "101159", label: "LarvE" },
  { value: "101160", label: "Lasikal" },
  { value: "101161", label: "Lasilactone" },
  { value: "927", label: "Lasilix" },
  { value: "928", label: "Lasix" },
  { value: "101162", label: "Lasix Injection" },
  { value: "104435", label: "lasofoxifene" },
  { value: "104436", label: "Lasoride" },
  { value: "104437", label: "latamoxef" },
  { value: "929", label: "Latanoprost" },
  { value: "104438", label: "Latuda" },
  { value: "104439", label: "laurilsulfate, incl. combinations" },
  { value: "101163", label: "Lauromacrogol" },
  { value: "101144", label: "L-Cystine" },
  { value: "104440", label: "Ledaga" },
  { value: "101164", label: "Ledclair" },
  { value: "930", label: "Lederfen" },
  { value: "104441", label: "ledipasvir" },
  { value: "931", label: "Leflunomide" },
  { value: "104442", label: "Lemtrada" },
  { value: "932", label: "Lenalidomide" },
  { value: "101165", label: "Lenograstim" },
  { value: "104443", label: "lentinan" },
  { value: "104444", label: "lenvatinib" },
  { value: "104445", label: "Lenvima" },
  { value: "101166", label: "Lepirudin" },
  { value: "104446", label: "Leqvio" },
  { value: "933", label: "Lercan" },
  { value: "934", label: "Lercanidipine" },
  { value: "935", label: "Lerka" },
  { value: "936", label: "Lescol" },
  { value: "104447", label: "lescol capsules" },
  { value: "101167", label: "Lescol XL" },
  { value: "937", label: "Letairis" },
  { value: "104448", label: "letermovir" },
  { value: "104449", label: "letosteine" },
  { value: "938", label: "Letrozole" },
  { value: "101168", label: "Leucine" },
  { value: "101169", label: "Leucine AA Supplement" },
  { value: "101170", label: "Leukeran" },
  { value: "939", label: "Leuprolide" },
  { value: "940", label: "Leuprorelin" },
  { value: "101171", label: "Leustat" },
  { value: "104450", label: "levacetylmethadol" },
  { value: "104451", label: "levact" },
  { value: "104452", label: "Levadopa/Carbidopa/Entacapone" },
  { value: "104453", label: "levamisole" },
  { value: "941", label: "Levemir" },
  { value: "942", label: "Levetiracetam" },
  { value: "101172", label: "Levitra" },
  { value: "943", label: "Levobunolol" },
  { value: "101173", label: "Levobupivacaine" },
  { value: "104454", label: "levocabastine" },
  { value: "101174", label: "Levocarnitine" },
  { value: "944", label: "Levocetirizine" },
  { value: "104455", label: "Levocetrizine" },
  { value: "945", label: "Levodopa" },
  { value: "104456", label: "levodopa and decarboxylase inhibitor" },
  {
    value: "104457",
    label: "levodopa, decarboxylase inhibitor and COMT inhibitor",
  },
  { value: "104458", label: "levodropropizine" },
  { value: "946", label: "Levofloxacin" },
  { value: "947", label: "Levomepromazine" },
  { value: "101175", label: "Levonorgestrel" },
  { value: "104459", label: "levosimendan" },
  { value: "104460", label: "levosulpiride" },
  { value: "948", label: "Levothyroxine" },
  { value: "104461", label: "levothyroxine sodium" },
  { value: "104462", label: "levoverbenone" },
  { value: "949", label: "Lexatin" },
  { value: "101176", label: "Lexpec" },
  { value: "950", label: "Libradin" },
  { value: "951", label: "Librium" },
  { value: "104463", label: "Libtayo" },
  { value: "952", label: "Lidocaine" },
  { value: "104464", label: "lidocaine, combinations" },
  { value: "104465", label: "lidoflazine" },
  { value: "953", label: "Lignocaine" },
  { value: "101177", label: "Li-Liquid" },
  { value: "104466", label: "linaclotide" },
  { value: "101178", label: "linagliptin" },
  { value: "104467", label: "linagliptin," },
  { value: "104468", label: "linagliptin, metformin combination" },
  { value: "104469", label: "lincomycin" },
  { value: "104470", label: "lindane" },
  { value: "104471", label: "linezolid" },
  { value: "104472", label: "linopirdine" },
  { value: "104473", label: "linseed" },
  { value: "104474", label: "linseed, combinations" },
  { value: "104475", label: "linsidomine" },
  { value: "104476", label: "Linzess" },
  { value: "954", label: "Lioresal" },
  { value: "104477", label: "Lioresel" },
  { value: "955", label: "Liothyronine" },
  { value: "104478", label: "liothyronine sodium" },
  { value: "956", label: "Lipantil" },
  { value: "101179", label: "Lipantil Micro" },
  { value: "957", label: "Lipex" },
  { value: "958", label: "Lipicard" },
  { value: "101180", label: "Lipid regulation - Other" },
  { value: "959", label: "Lipidol" },
  { value: "960", label: "Lipitor" },
  { value: "961", label: "Lipitrol" },
  { value: "962", label: "Liplat" },
  { value: "101181", label: "Lipobase" },
  { value: "101182", label: "Liposic" },
  { value: "963", label: "Lipostat" },
  { value: "104479", label: "Liprosil" },
  { value: "101183", label: "Liqui-Char" },
  { value: "101184", label: "Liquid paraffin" },
  {
    value: "104480",
    label: "Liquid paraffin & Magnesium Hydroxide Oral Emulsion",
  },
  { value: "104481", label: "Liquid paraffin Oral Emulsion" },
  { value: "104482", label: "liquid paraffin, combinations" },
  { value: "101185", label: "Liquid Paraffin/White Soft Paraffin" },
  { value: "104483", label: "liquifilm" },
  { value: "101186", label: "Liquifilm Tears" },
  { value: "101187", label: "Liquigen" },
  { value: "964", label: "Liraglutide" },
  { value: "104484", label: "lisdexamfetamine" },
  { value: "104485", label: "Lisicostad" },
  { value: "965", label: "Lisinopril" },
  { value: "104486", label: "lisinopril and diuretics" },
  { value: "104487", label: "Lisinopril with hydrochlorothiazide 10/12.5mg" },
  { value: "104488", label: "Lisinopril with hydrochlorothiazide 20/12.5mg" },
  { value: "101188", label: "Liskonum" },
  { value: "104489", label: "Lisopress" },
  { value: "966", label: "Lisoretic" },
  { value: "101189", label: "Lispro" },
  { value: "104490", label: "lisuride" },
  { value: "104491", label: "litak" },
  { value: "104492", label: "litarex" },
  { value: "967", label: "Lithium" },
  { value: "104493", label: "Lithium Carbonate" },
  { value: "104494", label: "Lithium Citrate" },
  { value: "104495", label: "lithium salts" },
  { value: "104496", label: "lithium succinate" },
  { value: "104497", label: "lithonate" },
  { value: "968", label: "Livial" },
  { value: "104498", label: "Livtencity" },
  { value: "101190", label: "Livwell" },
  { value: "104499", label: "Lixiana" },
  { value: "104500", label: "lixisenatide" },
  { value: "104501", label: "Lixisenatide " },
  { value: "101191", label: "LMX4" },
  { value: "969", label: "Lobivon" },
  { value: "970", label: "Loceryl" },
  { value: "101192", label: "Locoid" },
  { value: "101193", label: "Locorten-Vioform" },
  { value: "971", label: "Lodine" },
  { value: "101194", label: "Lodine SR" },
  { value: "104502", label: "Lodotra" },
  { value: "101195", label: "Lodoxamide" },
  { value: "972", label: "Lodoz" },
  { value: "973", label: "Lofepramine" },
  { value: "104503", label: "Lofepramine Hydrocloride" },
  { value: "101196", label: "Lofexidine" },
  { value: "104504", label: "Lojuxta" },
  { value: "104505", label: "Lokelma" },
  { value: "104506", label: "lomefloxacin" },
  { value: "104507", label: "lomitapide" },
  { value: "101197", label: "Lomont" },
  { value: "974", label: "Lomotil" },
  { value: "104508", label: "lomustine" },
  { value: "104509", label: "lonazolac" },
  { value: "104510", label: "Longtec" },
  { value: "104511", label: "lonidamine" },
  { value: "101198", label: "Loniten" },
  { value: "104512", label: "Lonsurf" },
  { value: "101199", label: "Loop diuretic - Other" },
  { value: "975", label: "Lopace" },
  { value: "976", label: "Loperamide" },
  { value: "104513", label: "loperamide oxide" },
  { value: "104514", label: "loperamide, combinations" },
  { value: "101200", label: "Lophlex" },
  { value: "101201", label: "Lopid" },
  { value: "977", label: "Lopinavir" },
  { value: "978", label: "Loprazolam" },
  { value: "101202", label: "Lopresor" },
  { value: "101203", label: "Lopresor SR" },
  { value: "101204", label: "Loprofin" },
  { value: "104515", label: "loracarbef" },
  { value: "104516", label: "lorajmine" },
  { value: "101205", label: "Loramyc" },
  { value: "979", label: "Loratadine" },
  { value: "980", label: "Loratine" },
  { value: "981", label: "Lorazepam" },
  { value: "104517", label: "lorazepam, combinations" },
  { value: "104518", label: "lorcainide" },
  { value: "104519", label: "lorlatinib" },
  { value: "101206", label: "Lormetazepam" },
  { value: "104520", label: "lornoxicam" },
  { value: "982", label: "Loron" },
  { value: "104521", label: "Lorvacs" },
  { value: "104522", label: "Lorvacs XL" },
  { value: "104523", label: "Lorviqua" },
  { value: "983", label: "Losartan" },
  { value: "104524", label: "losartan and diuretics" },
  { value: "104525", label: "Losartan with hydrochlorothiazide 50/12.5mg" },
  { value: "984", label: "Losec" },
  { value: "101207", label: "Lotemax" },
  { value: "101208", label: "Loteprednol" },
  { value: "104526", label: "lotprosin" },
  { value: "104527", label: "lotprosin xl" },
  { value: "985", label: "Lotrel" },
  { value: "101209", label: "Lotriderm" },
  { value: "986", label: "Lovastatin" },
  { value: "987", label: "Lovaza" },
  { value: "104528", label: "low molecular weight heparin" },
  { value: "104529", label: "Lowmorin" },
  { value: "104530", label: "loxapine" },
  { value: "101145", label: "L-Tyrosine" },
  { value: "101146", label: "L-Tyrosine AA Supplement" },
  { value: "104531", label: "lubiprostone" },
  { value: "101210", label: "Lucentis" },
  { value: "104532", label: "Lumaricoxib" },
  { value: "101211", label: "Lumefantrine" },
  { value: "988", label: "Lumigan" },
  { value: "104533", label: "lumiracoxib" },
  { value: "104534", label: "Lumykras" },
  { value: "989", label: "Lupron" },
  { value: "104535", label: "lurasidone" },
  { value: "104536", label: "Lurasidone Hydrochloride" },
  { value: "990", label: "Lustral" },
  { value: "104537", label: "Lutathera" },
  { value: "104538", label: "lutetium (177Lu) oxodotreotide" },
  { value: "104539", label: "lutropin" },
  { value: "101212", label: "Lutropin Alfa" },
  { value: "101213", label: "Luveris" },
  { value: "104540", label: "Luvinsta" },
  { value: "104541", label: "Luvinsta XL" },
  { value: "991", label: "Luvox" },
  { value: "101214", label: "Lyflex" },
  { value: "992", label: "Lymecycline" },
  { value: "104542", label: "lynestrenol" },
  { value: "104543", label: "Lynparza" },
  { value: "104544", label: "lypressin" },
  { value: "993", label: "Lyrica" },
  { value: "104545", label: "lyrinel" },
  { value: "994", label: "Lyrinel XL" },
  { value: "104546", label: "lysine" },
  { value: "104547", label: "lysodren" },
  { value: "101215", label: "Lysovir" },
  { value: "104548", label: "lysozyme" },
  { value: "104549", label: "Lyxumia" },
  { value: "101217", label: "Maalox" },
  { value: "101218", label: "MabCampath" },
  { value: "101219", label: "MabThera" },
  { value: "104550", label: "macitentan" },
  { value: "101220", label: "Macrobid" },
  { value: "995", label: "Macrodantin" },
  { value: "996", label: "Macrogol" },
  { value: "101221", label: "Macrogol 4 Lauryl Ether" },
  { value: "104551", label: "Macrogol Combination" },
  { value: "104552", label: "macrogol, combinations" },
  { value: "101222", label: "Macugen" },
  { value: "997", label: "Madopar" },
  { value: "104553", label: "mafenide" },
  { value: "104554", label: "Mag Trisilicate & Belladonna mixture BPC" },
  { value: "104555", label: "magaldrate" },
  { value: "104556", label: "magaldrate and antiflatulents" },
  { value: "998", label: "Magnapen" },
  { value: "104557", label: "magnesium" },
  { value: "104558", label: "magnesium (different salts in combination)" },
  { value: "104559", label: "magnesium aspartate" },
  { value: "101223", label: "Magnesium Carbonate" },
  { value: "104560", label: "Magnesium Carbonate Mixture" },
  { value: "104561", label: "magnesium chloride" },
  { value: "101224", label: "Magnesium citrate" },
  { value: "104562", label: "magnesium gluconate" },
  { value: "999", label: "Magnesium Hydroxide" },
  { value: "104563", label: "Magnesium Hydroxide Mixture" },
  { value: "104564", label: "magnesium lactate" },
  { value: "104565", label: "magnesium levulinate" },
  { value: "104566", label: "magnesium orotate" },
  { value: "101225", label: "Magnesium Oxide" },
  { value: "104567", label: "magnesium peroxide" },
  { value: "104568", label: "magnesium phosphate" },
  { value: "104569", label: "magnesium pidolate" },
  { value: "104570", label: "magnesium pyridoxal 5-phosphate glutamate" },
  { value: "104571", label: "magnesium silicate" },
  { value: "104572", label: "magnesium sulfate" },
  { value: "101226", label: "Magnesium sulphate" },
  { value: "101227", label: "Magnesium Trisilicate" },
  { value: "104573", label: "Magnesium Trisilicate Mixture" },
  { value: "104574", label: "malathion" },
  { value: "104575", label: "malic" },
  { value: "101228", label: "Malic Acid" },
  { value: "104576", label: "mandelic acid" },
  { value: "104577", label: "Manerix" },
  { value: "1000", label: "Manevac" },
  { value: "104578", label: "mangafodipir" },
  { value: "104579", label: "manidipine" },
  { value: "1001", label: "Manidon" },
  { value: "101229", label: "Mannitol" },
  { value: "104580", label: "mannosulfan" },
  { value: "1002", label: "Maprosyn" },
  { value: "104581", label: "maprotiline" },
  { value: "101230", label: "Maraviroc" },
  { value: "101231", label: "Marcain" },
  { value: "1003", label: "Marevan" },
  { value: "104582", label: "maribavir" },
  { value: "104583", label: "Martapan" },
  { value: "104584", label: "masoprocol" },
  { value: "101232", label: "Matolazone" },
  { value: "104585", label: "Matrifen" },
  { value: "104586", label: "Mavenclad" },
  { value: "104587", label: "Maviret" },
  { value: "1004", label: "Maxalt" },
  { value: "101233", label: "Maxepa" },
  { value: "1005", label: "Maxidex" },
  { value: "104588", label: "maxijul" },
  { value: "101234", label: "Maxijul Super Soluble" },
  { value: "1006", label: "Maxilase" },
  { value: "104589", label: "Maxitram" },
  { value: "101235", label: "Maxitram SR" },
  { value: "101236", label: "Maxitrol" },
  { value: "101237", label: "Maxolon" },
  { value: "1007", label: "Maxtrex" },
  { value: "104590", label: "Mayzent" },
  { value: "104591", label: "mazaticol" },
  { value: "104592", label: "mazindol" },
  { value: "101238", label: "MCT Pepdite" },
  { value: "104593", label: "MDV3100" },
  { value: "104594", label: "measles immunoglobulin" },
  { value: "101239", label: "Measles Virus" },
  {
    value: "104595",
    label: "measles, combinations with mumps and rubella, live attenuated",
  },
  {
    value: "104596",
    label: "measles, combinations with mumps, live attenuated",
  },
  {
    value: "104597",
    label:
      "measles, combinations with mumps, rubella and varicella, live attenuated",
  },
  {
    value: "104598",
    label: "measles, combinations with rubella, live attenuated",
  },
  { value: "104599", label: "measles, live attenuated" },
  { value: "101240", label: "Mebendazole" },
  { value: "104600", label: "mebendazole, combinations" },
  { value: "1008", label: "Mebeverine" },
  { value: "104601", label: "Mebeverine & ispaghula husk 135mg/3.5g" },
  { value: "104602", label: "mebhydrolin" },
  { value: "104603", label: "mebutamate" },
  { value: "104604", label: "mebutizide" },
  { value: "104605", label: "mebutizide and potassium-sparing agents" },
  { value: "104606", label: "mecamylamine" },
  { value: "1009", label: "Mecardis" },
  { value: "104607", label: "mecasermin" },
  { value: "104608", label: "mecasermin rinfabate" },
  { value: "104609", label: "mecillinam" },
  { value: "104610", label: "meclocycline" },
  { value: "104611", label: "meclofenamic acid" },
  { value: "104612", label: "meclofenoxate" },
  { value: "104613", label: "meclozine" },
  { value: "104614", label: "meclozine, combinations" },
  { value: "104615", label: "mecobalamin" },
  { value: "1010", label: "Mecysteine" },
  { value: "104616", label: "medazepam" },
  { value: "104617", label: "medical air" },
  { value: "104618", label: "medicinal charcoal" },
  { value: "104619", label: "medicinal charcoal, combinations" },
  { value: "104620", label: "medifoxamine" },
  { value: "101241", label: "Medikinet" },
  { value: "104621", label: "medinol" },
  { value: "101242", label: "Medinol Paediatric" },
  { value: "104622", label: "medrogestone" },
  { value: "101243", label: "Medrone" },
  { value: "1011", label: "Medroxyprogesterone" },
  { value: "104623", label: "medrysone" },
  { value: "104624", label: "mefenamic" },
  { value: "101244", label: "Mefenamic acid" },
  { value: "104625", label: "mefenorex" },
  { value: "101245", label: "Mefloquine" },
  { value: "104626", label: "mefruside" },
  { value: "101246", label: "Megace" },
  { value: "1012", label: "Megestrol" },
  { value: "104627", label: "meglumine antimonate" },
  { value: "104628", label: "meglutol" },
  { value: "104629", label: "Mekinist" },
  { value: "104630", label: "Mektovi" },
  { value: "104631", label: "meladrazine" },
  { value: "104632", label: "melagatran" },
  { value: "104633", label: "melanoma vaccine" },
  { value: "104634", label: "melarsoprol" },
  { value: "101247", label: "Melatonin" },
  { value: "104635", label: "melevodopa" },
  { value: "104636", label: "melevodopa and decarboxylase inhibitor" },
  { value: "104637", label: "melitracen" },
  { value: "104638", label: "melitracen and psycholeptics" },
  { value: "1013", label: "Meloclopramide" },
  { value: "1014", label: "Meloxicam" },
  { value: "104639", label: "melperone" },
  { value: "1015", label: "Melphalan" },
  { value: "101248", label: "Memantine" },
  { value: "104640", label: "menadione" },
  { value: "104641", label: "meniere's disease treatments" },
  { value: "101249", label: "Meningitec" },
  { value: "101250", label: "Meningitis And Hib Vaccine" },
  { value: "101251", label: "Meningitis Vaccine" },
  { value: "101252", label: "Meningococcal Oligosaccharides" },
  {
    value: "104642",
    label: "meningococcus A, purified polysaccharides antigen",
  },
  { value: "104643", label: "meningococcus B, outer membrane vesicle vaccine" },
  {
    value: "104644",
    label: "meningococcus C, purified polysaccharides antigen conjugated",
  },
  {
    value: "104645",
    label: "meningococcus, bivalent purified polysaccharides antigen",
  },
  {
    value: "104646",
    label: "meningococcus, tetravalent purified polysaccharides antigen",
  },
  {
    value: "104647",
    label:
      "meningococcus, tetravalent purified polysaccharides antigen conjugated",
  },
  { value: "101253", label: "Menitorix" },
  { value: "101254", label: "Menopur" },
  { value: "101255", label: "Menotrophin" },
  { value: "104648", label: "menthae piperitae aetheroleum" },
  { value: "104649", label: "menthol" },
  { value: "101256", label: "Menthol in Aqueous Cream" },
  { value: "101257", label: "Menveo" },
  { value: "1016", label: "Mepacrine" },
  { value: "101258", label: "Mepact" },
  { value: "104650", label: "mepartricin" },
  { value: "104651", label: "mepenzolate" },
  { value: "104652", label: "mephenesin" },
  { value: "104653", label: "mephenoxalone" },
  { value: "104654", label: "mephentermine" },
  { value: "104655", label: "mephenytoin" },
  { value: "104656", label: "mephenytoin, combinations" },
  { value: "104657", label: "mepindolol" },
  { value: "104658", label: "mepivacaine" },
  { value: "104659", label: "mepivacaine, combinations" },
  { value: "104660", label: "mepixanox" },
  { value: "104661", label: "mepolizumab" },
  { value: "1017", label: "Mepradec" },
  { value: "104662", label: "meprednisone" },
  { value: "1018", label: "Meprobamate" },
  { value: "104663", label: "meprobamate, combinations" },
  { value: "104664", label: "meprotixol" },
  { value: "1019", label: "Meptazinol" },
  { value: "101259", label: "Meptid" },
  { value: "104665", label: "mepyramine" },
  { value: "104666", label: "mequinol" },
  { value: "104667", label: "mequitazine" },
  { value: "1020", label: "Merbentyl" },
  { value: "101260", label: "Mercaptamine" },
  { value: "1021", label: "Mercaptopurine" },
  { value: "104668", label: "mercuric amidochloride" },
  { value: "104669", label: "mercuric chloride" },
  { value: "104670", label: "mercuric iodide" },
  { value: "104671", label: "mercurochrome" },
  { value: "104672", label: "mercury compounds" },
  { value: "104673", label: "mercury, metallic" },
  { value: "101261", label: "Merocaine" },
  { value: "101262", label: "Merocets" },
  { value: "101263", label: "Meronem" },
  { value: "101264", label: "Meropenem" },
  { value: "104674", label: "mersalyl" },
  { value: "1022", label: "Mesalazine" },
  { value: "101265", label: "Mesna" },
  { value: "104675", label: "mesoridazine" },
  { value: "104676", label: "mesren" },
  { value: "1023", label: "Mesren MR" },
  { value: "101266", label: "Mesterolone" },
  { value: "1024", label: "Mestinon" },
  { value: "104677", label: "mesulfen" },
  { value: "104678", label: "mesuximide" },
  { value: "104679", label: "Metabet" },
  { value: "104680", label: "Metabet SR" },
  { value: "101267", label: "Metabolic Mineral Mixture" },
  { value: "104681", label: "metabutethamine" },
  { value: "104682", label: "metacycline" },
  { value: "104683", label: "metahexamide" },
  { value: "101268", label: "Metalyse" },
  { value: "104684", label: "metamfetamine" },
  { value: "104685", label: "metamizole sodium" },
  {
    value: "104686",
    label: "metamizole sodium, combinations excl. psycholeptics",
  },
  {
    value: "104687",
    label: "metamizole sodium, combinations with psycholeptics",
  },
  { value: "104688", label: "metampicillin" },
  { value: "104689", label: "metandienone" },
  { value: "104690", label: "metaraminol" },
  { value: "101269", label: "Meted" },
  { value: "101270", label: "Metenix" },
  { value: "101271", label: "Metenix 5" },
  { value: "104691", label: "metenolone" },
  { value: "104692", label: "metergoline" },
  { value: "1025", label: "Metforal" },
  { value: "1026", label: "Metformin" },
  { value: "104693", label: "metformin and alogliptin" },
  { value: "104694", label: "metformin and sulfonamides" },
  { value: "104695", label: "metformin and sulfonylureas" },
  { value: "1027", label: "Methadone" },
  { value: "104696", label: "methadone, comb. excl. psycholeptics" },
  { value: "104697", label: "methallenestril" },
  { value: "104698", label: "methantheline" },
  { value: "104699", label: "methapyrilene" },
  { value: "104700", label: "methaqualone" },
  { value: "104701", label: "methaqualone, combinations" },
  { value: "104702", label: "metharbital" },
  { value: "104703", label: "methazolamide" },
  { value: "104704", label: "methdilazine" },
  { value: "101272", label: "Methenamine" },
  { value: "104705", label: "Methimazole" },
  { value: "104706", label: "methiodal" },
  { value: "101273", label: "Methionine" },
  { value: "104707", label: "methiosulfonium chloride" },
  { value: "1028", label: "Methocarbamol" },
  { value: "104708", label: "methocarbamol, combinations excl. psycholeptics" },
  { value: "104709", label: "methocarbamol, combinations with psycholeptics" },
  { value: "104710", label: "methohexital" },
  { value: "104711", label: "methoserpidine" },
  { value: "104712", label: "methoserpidine and diuretics" },
  { value: "1029", label: "Methotrexate" },
  { value: "1030", label: "Methotrimeprazine" },
  { value: "104713", label: "Methotrimeprazine Mal (Levomepromazine)" },
  { value: "104714", label: "methoxamine" },
  { value: "104715", label: "methoxsalen" },
  { value: "104716", label: "methoxy polyethylene glycol-epoetin beta" },
  { value: "104717", label: "methoxyflurane" },
  { value: "104718", label: "methoxyphenamine" },
  { value: "104719", label: "methoxypolyethylene" },
  { value: "101274", label: "Methoxypolyethylene glycol-epoetin beta" },
  { value: "104720", label: "methyclothiazide" },
  { value: "101275", label: "Methyl aminolaevulinate" },
  { value: "104721", label: "methyl aminolevulinate" },
  { value: "101276", label: "Methyl Hydroxybenzoate" },
  { value: "101277", label: "Methyl Salicylate" },
  { value: "104722", label: "methylatropine" },
  { value: "1031", label: "Methylcellulose" },
  { value: "1032", label: "Methyldopa" },
  { value: "104723", label: "methyldopa (levorotatory)" },
  { value: "104724", label: "methyldopa (levorotatory) and diuretics" },
  { value: "104725", label: "methyldopa (racemic)" },
  { value: "104726", label: "methylergometrine" },
  { value: "104727", label: "methylestrenolone" },
  { value: "104728", label: "methylhomatropine and psycholeptics" },
  { value: "104729", label: "methylnaltrexone" },
  { value: "101278", label: "Methylnaltrexone bromide" },
  { value: "104730", label: "methylnortestosterone and estrogen" },
  { value: "104731", label: "methylpentynol" },
  { value: "104732", label: "methylpentynol, combinations" },
  { value: "101279", label: "Methylphenidate" },
  { value: "104733", label: "methylphenobarbital" },
  { value: "101280", label: "Methylprednisolone" },
  { value: "104734", label: "methylprednisolone aceponate" },
  { value: "104735", label: "methylprednisolone and antibiotics" },
  { value: "104736", label: "methylprednisolone and antiinfectives" },
  { value: "104737", label: "methylprednisolone, combinations" },
  { value: "104738", label: "methylpropylpropanediol dinitrate" },
  { value: "104739", label: "methylpropylpropanediol dinitrate, combinations" },
  { value: "104740", label: "methylrosaniline" },
  { value: "104741", label: "methylscopolamine" },
  { value: "104742", label: "methylscopolamine and psycholeptics" },
  { value: "104743", label: "methyltestosterone" },
  { value: "104744", label: "methylthioninium chloride" },
  { value: "104745", label: "methylthiouracil" },
  { value: "104746", label: "methyprylon" },
  { value: "101281", label: "Methysergide" },
  { value: "104747", label: "meticillin" },
  { value: "104748", label: "meticrane" },
  { value: "104749", label: "metildigoxin" },
  { value: "104750", label: "metipranolol" },
  { value: "104751", label: "metirosine" },
  { value: "104752", label: "metisazone" },
  { value: "104753", label: "metixene" },
  { value: "104754", label: "metizoline" },
  { value: "104755", label: "Metoclopramiac" },
  { value: "1033", label: "Metoclopramide" },
  { value: "104756", label: "Metoject" },
  { value: "1034", label: "Metolazone" },
  { value: "104757", label: "metolazone and potassium-sparing agents" },
  { value: "104758", label: "metopimazine" },
  { value: "1035", label: "Metopirone" },
  { value: "1036", label: "Metoprolol" },
  {
    value: "104759",
    label: "Metoprolol with hydrochlorothiazide 100mg/12.5mg",
  },
  { value: "104760", label: "Metoprolol with hydrochlorothiazide 200mg/25mg" },
  { value: "104761", label: "metoprolol, combinations" },
  { value: "104762", label: "metrifonate" },
  { value: "104763", label: "metrizamide" },
  { value: "104764", label: "metrizoic acid" },
  { value: "101282", label: "Metrogel" },
  { value: "1037", label: "Metronidazole" },
  { value: "101283", label: "Metrosa" },
  { value: "101284", label: "Metvix" },
  { value: "1038", label: "Metyrapone" },
  { value: "101285", label: "Mexiletine" },
  { value: "104765", label: "Mexiletine HCI" },
  { value: "101286", label: "Mexitil" },
  { value: "1039", label: "Mezavant" },
  { value: "101287", label: "Mezavant XL" },
  { value: "104766", label: "mezlocillin" },
  { value: "104767", label: "mezolar" },
  { value: "101288", label: "Mezolar Matrix" },
  { value: "104768", label: "miacalcic" },
  { value: "101289", label: "Miacalcic Nasal Spray" },
  { value: "101290", label: "Mianserin" },
  { value: "104769", label: "mibefradil" },
  { value: "1040", label: "MIBG treatment" },
  { value: "101291", label: "Micafungin" },
  { value: "101292", label: "Micanol" },
  { value: "1041", label: "Micardis" },
  { value: "101293", label: "Micardis plus" },
  { value: "101294", label: "Micolette" },
  { value: "101295", label: "Miconazole" },
  { value: "104770", label: "miconazole, combinations" },
  { value: "104771", label: "Miconazoleb" },
  { value: "101296", label: "Micralax" },
  { value: "104772", label: "micronomicin" },
  { value: "104773", label: "microparticles of galactose" },
  { value: "1042", label: "Micropirin" },
  { value: "104774", label: "microspheres of human albumin" },
  { value: "104775", label: "microspheres of phospholipids" },
  { value: "1043", label: "Midazolam" },
  { value: "104776", label: "midecamycin" },
  { value: "1044", label: "Midodrine" },
  { value: "104777", label: "midostaurin" },
  { value: "101297", label: "Midrid" },
  { value: "101298", label: "Mifamurtide" },
  { value: "101299", label: "Mifegyne" },
  { value: "101300", label: "Mifepristone" },
  { value: "1045", label: "Miflasone" },
  { value: "101301", label: "Migard" },
  { value: "104778", label: "miglitol" },
  { value: "101302", label: "Miglustat" },
  { value: "1046", label: "Migraleve" },
  { value: "101303", label: "MigraMax" },
  { value: "101304", label: "Migril" },
  { value: "104779", label: "mildison" },
  { value: "101305", label: "Mildison Lipocream" },
  { value: "104780", label: "milnacipran" },
  { value: "101306", label: "Milrinone" },
  { value: "104781", label: "miltefosine" },
  { value: "104782", label: "milupa" },
  { value: "101307", label: "Milupa lpd" },
  { value: "101308", label: "MIMMS" },
  { value: "101309", label: "Mimpara" },
  { value: "104783", label: "minaprine" },
  { value: "1047", label: "Minax" },
  { value: "104784", label: "mineral salts in combination" },
  { value: "1048", label: "Minidab" },
  { value: "104785", label: "minijet" },
  { value: "104786", label: "Minijet Furosemide" },
  { value: "101311", label: "Minijet Lignocaine" },
  { value: "104787", label: "minims" },
  { value: "101312", label: "Minims Artificial Tears" },
  { value: "101313", label: "Minims Atropine" },
  { value: "101314", label: "Minims Chloramphenicol" },
  { value: "101315", label: "Minims Cyclopentolate" },
  { value: "101316", label: "Minims Dexamethasone" },
  { value: "101317", label: "Minims Fluorescein" },
  { value: "101318", label: "Minims Lidocaine and Fluorescein" },
  { value: "101319", label: "Minims Metipranolol" },
  { value: "101320", label: "Minims Oxybuprocaine" },
  { value: "101321", label: "Minims Phenylephrine" },
  { value: "101322", label: "Minims Pilocarpine" },
  { value: "101323", label: "Minims Prednisolone" },
  { value: "101324", label: "Minims Proxymetacaine" },
  { value: "101326", label: "Minims Sodium Chloride" },
  { value: "101327", label: "Minims Tetracaine" },
  { value: "101328", label: "Minims Tropicamide" },
  { value: "1049", label: "Minitran" },
  { value: "101329", label: "Miniversol" },
  { value: "101310", label: "Mini-Wright" },
  { value: "104788", label: "minocin" },
  { value: "101330", label: "Minocin MR" },
  { value: "1050", label: "Minocycline" },
  { value: "104789", label: "Minodab" },
  { value: "101331", label: "Minodiab" },
  { value: "1051", label: "Minoxidil" },
  { value: "101332", label: "Mintec" },
  { value: "104790", label: "miocamycin" },
  { value: "101333", label: "Miochol-E" },
  { value: "104791", label: "mirabegron" },
  { value: "1052", label: "Mirapexin" },
  { value: "104792", label: "mircena" },
  { value: "101334", label: "Mircera" },
  { value: "101335", label: "Mirena" },
  { value: "1053", label: "Mirtazapine" },
  { value: "1054", label: "Misoprostol" },
  { value: "104793", label: "mitiglinide" },
  { value: "104794", label: "mitobronitol" },
  { value: "104795", label: "mitoguazone" },
  { value: "104796", label: "mitomycin" },
  { value: "101336", label: "Mitomycin-C" },
  { value: "104797", label: "mitomycin-c kyowa" },
  { value: "104798", label: "mitotane" },
  { value: "1055", label: "Mitoxantrone" },
  { value: "101337", label: "Mivacron" },
  { value: "101338", label: "Mivacurium" },
  { value: "104799", label: "mivacurium chloride" },
  { value: "1056", label: "Mixtard" },
  { value: "101339", label: "Mixtard 30" },
  { value: "1057", label: "Mizolastine" },
  { value: "101340", label: "Mizollen" },
  { value: "1058", label: "MMF" },
  { value: "104800", label: "mmr" },
  { value: "101341", label: "Mmr Vaccine" },
  { value: "101216", label: "M-M-RvaxPro" },
  { value: "101342", label: "Mobic" },
  { value: "101343", label: "Mobiflex" },
  { value: "101344", label: "Mobigel" },
  { value: "104801", label: "mobocertinib" },
  { value: "101345", label: "Moclobemide" },
  { value: "1059", label: "Modafinil" },
  { value: "1060", label: "Modalim" },
  { value: "1061", label: "Modamide" },
  { value: "101346", label: "Modecate" },
  { value: "101347", label: "Modigraf" },
  { value: "104802", label: "Modisal XL" },
  { value: "104803", label: "modisial" },
  { value: "104804", label: "modjul" },
  { value: "101348", label: "Modjul Flavour" },
  { value: "101349", label: "Modrasone" },
  { value: "101350", label: "Moducren" },
  { value: "104805", label: "modulen" },
  { value: "101351", label: "Modulen IBD" },
  { value: "104806", label: "Moduret" },
  { value: "101352", label: "Moduret 25" },
  { value: "1062", label: "Moduretic" },
  { value: "101353", label: "Moexipril" },
  { value: "104807", label: "moexipril and diuretics" },
  { value: "104808", label: "mofebutazone" },
  { value: "104809", label: "Mogamulizumab" },
  { value: "101354", label: "Molaxole" },
  { value: "104810", label: "molgramostim" },
  { value: "104811", label: "Molidone" },
  { value: "104812", label: "molindone" },
  { value: "1063", label: "Molipaxin" },
  { value: "1064", label: "Molsidain" },
  { value: "1065", label: "Molsidomine" },
  { value: "1066", label: "Mometasone" },
  { value: "1067", label: "Monicor" },
  { value: "104813", label: "monit" },
  { value: "1068", label: "Monit SR" },
  { value: "104814", label: "monobenzone" },
  { value: "104815", label: "Mono-embolex" },
  { value: "104816", label: "monoethanolamine oleate" },
  { value: "104817", label: "Monofer" },
  { value: "101355", label: "Monogen" },
  { value: "1069", label: "Monolitum" },
  { value: "1070", label: "Monomax" },
  { value: "1071", label: "Monomil" },
  { value: "101356", label: "Monomil XL" },
  { value: "101357", label: "Mononine" },
  { value: "101358", label: "Monoparin" },
  { value: "104818", label: "Monopost" },
  { value: "104819", label: "monoprost" },
  { value: "104820", label: "monoprost eye drops" },
  { value: "104821", label: "Monosorb" },
  { value: "104822", label: "monosorb XL60" },
  { value: "1072", label: "Mono-Tildiem" },
  { value: "104823", label: "monoxerutin" },
  { value: "1073", label: "Monoxidine" },
  { value: "1074", label: "Montelukast" },
  { value: "104824", label: "moperone" },
  { value: "1075", label: "Mopral" },
  { value: "104825", label: "moracizine" },
  { value: "104826", label: "morclofone" },
  { value: "101359", label: "Morhulin" },
  { value: "104827", label: "morinamide" },
  { value: "104828", label: "morniflumate" },
  { value: "104829", label: "moroctocog" },
  { value: "101360", label: "Moroctocog Alfa" },
  { value: "104830", label: "moroxydine" },
  { value: "104831", label: "morphgesic" },
  { value: "1076", label: "Morphgesic SR" },
  { value: "104832", label: "morphgesis" },
  { value: "1077", label: "Morphine" },
  { value: "104833", label: "morphine and antispasmodics" },
  { value: "104834", label: "Morphine hydrochloride" },
  { value: "104835", label: "Morphine sulphate" },
  { value: "104836", label: "morphine, combinations" },
  { value: "104837", label: "morpholine salicylate" },
  { value: "104838", label: "mosapramine" },
  { value: "1078", label: "Motens" },
  { value: "101361", label: "Motifene" },
  { value: "1079", label: "Motilium" },
  { value: "104839", label: "motretinide" },
  { value: "104840", label: "mould fungus and yeast fungus" },
  { value: "1080", label: "Movelat" },
  { value: "1081", label: "Movicol" },
  { value: "101362", label: "Moviprep" },
  { value: "104841", label: "moxaverine" },
  { value: "104842", label: "moxestrol" },
  { value: "1082", label: "Moxifloxacin" },
  { value: "101363", label: "Moxisylyte" },
  { value: "1083", label: "Moxonidine" },
  { value: "104843", label: "moxonidine and diuretics" },
  { value: "101364", label: "Mozobil" },
  { value: "104844", label: "mst" },
  { value: "1084", label: "MST Continus" },
  { value: "104845", label: "msud" },
  { value: "101365", label: "MSUD Aid III" },
  { value: "101366", label: "MSUD Anamix Junior" },
  { value: "101367", label: "MSUD Express" },
  { value: "101368", label: "Mucin" },
  { value: "101369", label: "MucoClear" },
  { value: "1085", label: "Mucodyne" },
  { value: "101370", label: "Mucogel" },
  { value: "104846", label: "mucopolysaccharide" },
  { value: "101371", label: "Mucopolysaccharide Polysulphate" },
  { value: "101372", label: "MuGard" },
  { value: "101373", label: "Multaq" },
  { value: "104847", label: "multienzymes (lipase, protease etc.)" },
  { value: "104848", label: "multienzymes and acid preparations" },
  { value: "101374", label: "Multiparin" },
  { value: "101375", label: "Multivitamins" },
  {
    value: "104849",
    label: "multivitamins and other minerals, incl. combinations",
  },
  { value: "104850", label: "multivitamins and trace elements" },
  { value: "104851", label: "mumps immunoglobulin" },
  { value: "104852", label: "mumps, live attenuated" },
  { value: "101377", label: "Mupirocin" },
  { value: "104853", label: "muromonab-CD3" },
  { value: "101378", label: "MUSE" },
  { value: "104854", label: "muzolimine" },
  { value: "101379", label: "MXL" },
  { value: "101380", label: "Mycamine" },
  { value: "101381", label: "Mycobutin" },
  { value: "101382", label: "Mycophenolate" },
  { value: "1086", label: "Mycophenolate Mofetil" },
  { value: "104855", label: "Mycophenolate Sodium" },
  { value: "104856", label: "mycophenolic acid" },
  { value: "101383", label: "Mydriacyl" },
  { value: "101384", label: "Mydrilate" },
  { value: "104857", label: "Myfenax" },
  { value: "101385", label: "Myfortic" },
  { value: "101386", label: "Myleran" },
  { value: "104858", label: "Mylotarg" },
  { value: "101387", label: "Myocet" },
  { value: "1087", label: "Myocrisin" },
  { value: "101388", label: "Myotonine" },
  { value: "104859", label: "myristyl-benzalkonium" },
  { value: "1088", label: "Mysoline" },
  { value: "101389", label: "Nabilone" },
  { value: "104860", label: "Nabiximols" },
  { value: "104861", label: "nab-paclitaxel" },
  { value: "1089", label: "Nabumetone" },
  { value: "104862", label: "n-acetylcysteine" },
  { value: "104863", label: "nacl" },
  { value: "104864", label: "nacrez" },
  { value: "1090", label: "Nadolol" },
  { value: "104865", label: "Nadolol with bendrofluazide 40mg/5mg" },
  { value: "104866", label: "Nadolol with bendrofluazide 80mg/5mg" },
  { value: "104867", label: "nadroparin" },
  { value: "101390", label: "Nafarelin" },
  { value: "104868", label: "naftazone" },
  { value: "1091", label: "Naftidrofuryl" },
  { value: "104869", label: "naftifine" },
  { value: "104870", label: "nairn's" },
  { value: "104871", label: "nalbuphine" },
  { value: "101391", label: "Nalcrom" },
  { value: "104872", label: "naldemedine" },
  { value: "104873", label: "nalfurafine" },
  { value: "104874", label: "nalidixic" },
  { value: "101392", label: "Nalidixic acid" },
  { value: "101393", label: "Nalorex" },
  { value: "104875", label: "nalorphine" },
  { value: "101394", label: "Naloxone" },
  { value: "1092", label: "Naltrexone" },
  { value: "104876", label: "nandrolone" },
  { value: "101395", label: "Nandrolone decanoate" },
  { value: "104877", label: "naphazoline" },
  { value: "104878", label: "naphazoline, combinations" },
  { value: "1093", label: "Napratec" },
  { value: "1094", label: "Naprosyn" },
  { value: "101396", label: "Naprosyn EC" },
  { value: "104879", label: "naproxcinod" },
  { value: "1095", label: "Naproxen" },
  { value: "104880", label: "Naproxen & misoprostol 500mg/200mcg" },
  { value: "101397", label: "Naramig" },
  { value: "1096", label: "Naratriptan" },
  { value: "104881", label: "narcobarbital" },
  { value: "101398", label: "Nardil" },
  { value: "101399", label: "Naropin" },
  { value: "1097", label: "Nasacort" },
  { value: "101400", label: "Naseptin" },
  { value: "1098", label: "Nasobec" },
  { value: "104882", label: "nasofan" },
  { value: "101401", label: "Nasofan Aqueous" },
  { value: "1099", label: "Nasonex" },
  { value: "101402", label: "Nasonex Alcohol Free" },
  { value: "101403", label: "Natalizumab" },
  { value: "104883", label: "natamycin" },
  { value: "104884", label: "Natecal" },
  { value: "1100", label: "Natecal D3" },
  { value: "1101", label: "Nateglinide" },
  { value: "1102", label: "Natrilix" },
  { value: "101404", label: "Natrilix SR" },
  { value: "1103", label: "Nattokinase" },
  { value: "104885", label: "natural phospholipids" },
  { value: "101405", label: "Navelbine" },
  { value: "1104", label: "Navidrex" },
  { value: "1105", label: "Navispare" },
  { value: "104886", label: "nazdol" },
  { value: "1106", label: "Nazdol MR" },
  { value: "104887", label: "nebacumab" },
  { value: "104888", label: "nebbaro" },
  { value: "101406", label: "Nebido" },
  { value: "1107", label: "Nebilet" },
  { value: "104889", label: "Nebilox" },
  { value: "1108", label: "Nebivolol" },
  { value: "101407", label: "NebuChamber" },
  { value: "101408", label: "Nebuliser" },
  { value: "104890", label: "nebusal" },
  { value: "101409", label: "Nebusal 7%" },
  { value: "104891", label: "necitumumab" },
  { value: "104892", label: "Neditol" },
  { value: "104893", label: "neditol xl" },
  { value: "1109", label: "Nedocromil" },
  { value: "104894", label: "Nedocromil Sodium" },
  { value: "104895", label: "nefazodone" },
  { value: "1110", label: "Nefopam" },
  { value: "101410", label: "Nefopam hydrochloride" },
  { value: "104896", label: "neisseria" },
  { value: "101411", label: "Neisseria Meningitidis Group C" },
  { value: "101412", label: "NeisVac-C" },
  { value: "101413", label: "Nelarabine" },
  { value: "101414", label: "Nelfinavir" },
  { value: "104897", label: "neltenexine" },
  { value: "104898", label: "nemdatine" },
  { value: "104899", label: "neocate" },
  { value: "101416", label: "Neocate LCP" },
  { value: "101417", label: "NeoClarityn" },
  { value: "104900", label: "Neo-cytamen" },
  { value: "104901", label: "Neofel" },
  { value: "1111", label: "Neofel XL" },
  { value: "101418", label: "Neokay" },
  { value: "101419", label: "Neomercazole" },
  { value: "1112", label: "Neo-Mercazole" },
  { value: "101420", label: "Neomycin" },
  { value: "104902", label: "neomycin, combinations" },
  { value: "104903", label: "Neo-Naclex" },
  { value: "101415", label: "Neo-Naclex-K" },
  { value: "1113", label: "Neoral" },
  { value: "1114", label: "NeoRecormon" },
  { value: "101421", label: "Neosporin" },
  { value: "104904", label: "neostigmine" },
  { value: "104905", label: "neostigmine, combinations" },
  { value: "1115", label: "Neotigason" },
  { value: "104906", label: "Neovent" },
  { value: "1116", label: "Neozipine" },
  { value: "101422", label: "Nepafenac" },
  { value: "104907", label: "nepinalone" },
  { value: "101423", label: "Nepro" },
  { value: "104908", label: "nepro hp" },
  { value: "104909", label: "neratinib" },
  { value: "101424", label: "Nerisone" },
  { value: "101425", label: "Nerisone Forte" },
  { value: "104910", label: "Nerlynx" },
  { value: "101426", label: "Nesina" },
  { value: "104911", label: "nesiritide" },
  { value: "104912", label: "netilmicin" },
  { value: "101427", label: "Neulasta" },
  { value: "104913", label: "Neulin SA" },
  { value: "101428", label: "Neupogen" },
  { value: "1117", label: "Neupro" },
  { value: "101429", label: "NeuroBloc" },
  { value: "101430", label: "Neurontin" },
  { value: "101431", label: "Neutral Insulin" },
  { value: "104914", label: "neutrogena" },
  { value: "101432", label: "Neutrogena T Gel" },
  { value: "101433", label: "Nevanac" },
  { value: "1118", label: "Nevirapine" },
  { value: "101435", label: "Nexavar" },
  { value: "1119", label: "Nexium" },
  { value: "104915", label: "Nexletol" },
  { value: "104916", label: "Nexviadyme" },
  { value: "104917", label: "Niacin" },
  { value: "104918", label: "nialamide" },
  { value: "104919", label: "niaprazine" },
  { value: "1120", label: "Niaspan" },
  { value: "101436", label: "Nicam" },
  { value: "1121", label: "Nicardipine" },
  { value: "104920", label: "nicergoline" },
  { value: "104921", label: "niceritrol" },
  { value: "104922", label: "niclosamide" },
  { value: "104923", label: "nicofetamide" },
  { value: "104924", label: "nicofuranose" },
  { value: "104925", label: "nicomorphine" },
  { value: "1122", label: "Nicorandil" },
  { value: "101437", label: "Nicorette" },
  { value: "101438", label: "Nicotinamide" },
  { value: "101439", label: "Nicotine" },
  { value: "101440", label: "Nicotinell" },
  { value: "104926", label: "nicotinic" },
  { value: "1123", label: "Nicotinic Acid" },
  { value: "104927", label: "nicotinic acid, combinations" },
  { value: "104928", label: "nicotinyl alcohol (pyridylcarbinol)" },
  { value: "104929", label: "nicotinyl methylamide" },
  { value: "1124", label: "Nifedipine" },
  { value: "104930", label: "nifedipine and diuretics" },
  { value: "104931", label: "nifedipine, combinations" },
  { value: "104932", label: "nifedipress" },
  { value: "1125", label: "Nifedipress MR" },
  { value: "104933", label: "nifenazone" },
  { value: "104934", label: "Niferex" },
  { value: "104935", label: "niflumic acid" },
  { value: "104936", label: "Nifopress" },
  { value: "104937", label: "nifuratel" },
  { value: "104938", label: "nifuroxazide" },
  { value: "104939", label: "nifurtimox" },
  { value: "104940", label: "nifurtoinol" },
  { value: "104941", label: "nifurzide" },
  { value: "104942", label: "nikethamide" },
  { value: "104943", label: "nikethamide, combinations" },
  { value: "104944", label: "Nilemdo" },
  { value: "101441", label: "Nilotinib" },
  { value: "104945", label: "nilutamide" },
  { value: "104946", label: "nilvadipine" },
  { value: "101442", label: "Nimbex" },
  { value: "104947", label: "nimesulide" },
  { value: "1126", label: "Nimodipine" },
  { value: "104948", label: "nimorazole" },
  { value: "1127", label: "Nimotop" },
  { value: "104949", label: "nimustine" },
  { value: "104950", label: "Ninlaro" },
  { value: "104951", label: "nintedanib" },
  { value: "104952", label: "Nintendanib" },
  { value: "104953", label: "nipatra" },
  { value: "101443", label: "Nipent" },
  { value: "104954", label: "niperotidine" },
  { value: "104955", label: "niquitin" },
  { value: "101444", label: "Niquitin CQ" },
  { value: "104956", label: "niraparib" },
  { value: "104957", label: "niridazole" },
  { value: "101445", label: "Nisoldipine" },
  { value: "104958", label: "nitazoxanide" },
  { value: "101446", label: "Nitisinone" },
  { value: "101447", label: "Nitrate - Other" },
  { value: "1128", label: "Nitrazepam" },
  { value: "104959", label: "nitrendipine" },
  { value: "104960", label: "nitric oxide" },
  { value: "101449", label: "Nitrocine" },
  { value: "101448", label: "Nitro-Dur" },
  { value: "104961", label: "nitrofural" },
  { value: "1129", label: "Nitrofurantoin" },
  { value: "104962", label: "nitrogen" },
  { value: "1130", label: "Nitrolingual" },
  { value: "101450", label: "Nitrolingual Pumpspray" },
  { value: "101451", label: "Nitromin" },
  { value: "101452", label: "Nitronal" },
  { value: "104963", label: "nitroprusside" },
  { value: "104964", label: "nitrous oxide" },
  { value: "104965", label: "nitrous oxide, combinations" },
  { value: "104966", label: "nitroxoline" },
  { value: "1131", label: "Nivaquine" },
  { value: "101453", label: "Nivaquine Syrup" },
  { value: "101454", label: "Nivemycin" },
  { value: "101455", label: "Nivestim" },
  { value: "104967", label: "Nivolumab" },
  { value: "104968", label: "nixyflex" },
  { value: "1132", label: "Nizatidine" },
  { value: "104969", label: "nizofenone" },
  { value: "101456", label: "Nizoral" },
  { value: "101457", label: "Nizoral Cream" },
  { value: "101458", label: "Nizoral Shampoo" },
  { value: "1133", label: "Noliprel" },
  { value: "104970", label: "Nolvadex" },
  { value: "104971", label: "nomegestrol" },
  { value: "104972", label: "nomifensine" },
  { value: "104973", label: "nonacog" },
  { value: "101459", label: "Nonacog Alfa" },
  { value: "1134", label: "Nootropil" },
  { value: "101460", label: "Norcuron" },
  { value: "104974", label: "nordazepam" },
  { value: "104975", label: "norditropin" },
  { value: "101461", label: "Norditropin SimpleXx" },
  { value: "104976", label: "norelgestromin and estrogen" },
  { value: "104977", label: "norepinephrine" },
  { value: "104978", label: "norethandrolone" },
  { value: "101462", label: "Norethisterone" },
  { value: "104979", label: "noretynodrel and estrogen" },
  { value: "104980", label: "norfenefrine" },
  { value: "101463", label: "Norfloxacin" },
  { value: "101464", label: "Norgalax" },
  { value: "104981", label: "norgestimate and estrogen" },
  { value: "101465", label: "Norgestrel" },
  { value: "104982", label: "norgestrienone" },
  { value: "101466", label: "Norimode" },
  { value: "101467", label: "Normacol" },
  { value: "1135", label: "Normacol Plus" },
  { value: "101468", label: "Normasol" },
  { value: "101469", label: "Normax" },
  { value: "104983", label: "normethadone" },
  { value: "101470", label: "Normosang" },
  { value: "104984", label: "Norpace" },
  { value: "101471", label: "Norprolac" },
  { value: "1136", label: "Nortriptyline" },
  { value: "104985", label: "Nortriptyline & fluphenazine 10mg/500mcg" },
  { value: "104986", label: "Nortriptyline & fluphenazine 30mg/1.5mg" },
  { value: "1137", label: "Norvasc" },
  { value: "1138", label: "Norvir" },
  { value: "104987", label: "noscapine" },
  { value: "104988", label: "nosefrida" },
  { value: "1636", label: "Not listed" },
  { value: "104989", label: "novasource" },
  { value: "101472", label: "Novasource GI Control" },
  { value: "101473", label: "Novofem" },
  { value: "1139", label: "Novomix" },
  { value: "101474", label: "NovoMix 30" },
  { value: "104990", label: "NovoMix30" },
  { value: "1140", label: "NovoNorm" },
  { value: "1141", label: "Novorapid" },
  { value: "101475", label: "NovoSeven" },
  { value: "101476", label: "Noxafil" },
  { value: "104991", label: "noxyflex" },
  { value: "101477", label: "Noxyflex S" },
  { value: "101478", label: "Noxythiolin" },
  { value: "104992", label: "noxytiolin" },
  { value: "104993", label: "Noyada" },
  { value: "101479", label: "Nozinan" },
  { value: "104994", label: "nozoil" },
  { value: "101480", label: "Nplate" },
  { value: "104995", label: "Nu Seals" },
  { value: "104996", label: "Nubeqa" },
  { value: "104997", label: "Nucala" },
  { value: "104998", label: "nuelin" },
  { value: "1142", label: "Nuelin SA" },
  { value: "104999", label: "Nulojix" },
  { value: "105000", label: "nurofen" },
  { value: "1143", label: "Nu-Seals" },
  { value: "101481", label: "Nu-Seals Aspirin" },
  { value: "105001", label: "nusinersen" },
  { value: "105002", label: "Nustendi" },
  { value: "101483", label: "Nutilis" },
  { value: "101484", label: "Nutraplus" },
  { value: "105003", label: "nutricrem" },
  { value: "105004", label: "nutrineal" },
  { value: "101485", label: "Nutrineal PD4" },
  { value: "101486", label: "Nutrini" },
  { value: "105005", label: "nutriplen" },
  { value: "101488", label: "Nutrison" },
  { value: "105006", label: "nutrizym" },
  { value: "105007", label: "nutrizym 22" },
  { value: "1144", label: "Nutrizym GR" },
  { value: "101490", label: "NutropinAq" },
  { value: "105008", label: "nuvelle" },
  { value: "101491", label: "Nuvelle Continuous" },
  { value: "101492", label: "Nyogel" },
  { value: "101493", label: "Nystaform" },
  { value: "101494", label: "Nystaform-HC" },
  { value: "105009", label: "nystan" },
  { value: "101495", label: "Nystan Oral Suspension" },
  { value: "1145", label: "Nystatin" },
  { value: "105010", label: "nystatin, combinations" },
  { value: "101496", label: "Oatmeal" },
  { value: "105011", label: "obeticholic acid" },
  { value: "105012", label: "obidoxime" },
  { value: "105013", label: "obinutuzumab" },
  { value: "105014", label: "oblimersen" },
  { value: "105015", label: "Ocaliva" },
  { value: "101497", label: "Occlusal" },
  { value: "105016", label: "ocrelizumab" },
  { value: "105017", label: "Ocrevus" },
  { value: "101498", label: "Octagam" },
  { value: "105018", label: "Octasa" },
  { value: "105019", label: "octenidine, combinations" },
  { value: "101499", label: "Octim" },
  { value: "105020", label: "octinoxate" },
  { value: "105021", label: "octocog" },
  { value: "101500", label: "Octocog Alfa" },
  { value: "105022", label: "octopamine" },
  { value: "1146", label: "Octreotide" },
  { value: "101501", label: "Ocufen" },
  { value: "101502", label: "Oculotect" },
  { value: "101503", label: "Ocusan" },
  { value: "105023", label: "ocuvite" },
  { value: "105024", label: "Odefsey" },
  { value: "101504", label: "Oestrogel" },
  { value: "101505", label: "Oestrogen" },
  { value: "101506", label: "Ofatumumab" },
  { value: "105025", label: "Ofev" },
  { value: "101507", label: "Ofloxacin" },
  { value: "101508", label: "Oftaquix" },
  { value: "105026", label: "oil" },
  { value: "105027", label: "oilatum" },
  { value: "101509", label: "Oilatum Cream" },
  { value: "105028", label: "olaflur" },
  { value: "1147", label: "Olanzapine" },
  { value: "105029", label: "olaparib" },
  { value: "105030", label: "olaratumab" },
  { value: "101510", label: "Olbetam" },
  { value: "101511", label: "Oldaram" },
  { value: "105031", label: "oleandomycin" },
  { value: "105032", label: "Olena" },
  { value: "101512", label: "Olive oil" },
  { value: "101513", label: "Olmesartan" },
  { value: "1148", label: "Olmesartan medoxomil" },
  { value: "105033", label: "olmesartan medoxomil and diuretics" },
  { value: "1149", label: "Olmetec" },
  { value: "101514", label: "Olmetec Plus" },
  { value: "105034", label: "Olodaterol" },
  { value: "105035", label: "olodaterol hydrochloride" },
  { value: "101515", label: "Olopatadine" },
  { value: "1150", label: "Olsalazine" },
  { value: "105036", label: "olsar" },
  { value: "1151", label: "Olsar Plus" },
  { value: "105037", label: "Olumiant" },
  { value: "105038", label: "Olysio" },
  { value: "105039", label: "omacetaxine mepesuccinate" },
  { value: "1152", label: "Omacor" },
  { value: "101516", label: "Omalizumab" },
  { value: "105040", label: "Ombitasvir" },
  { value: "105041", label: "Omega 3" },
  { value: "105042", label: "omega-3" },
  { value: "105043", label: "Omega-3 marine triglycerides" },
  { value: "105044", label: "omega-3-acid" },
  { value: "105045", label: "Omega-3-acid ethyl esters" },
  {
    value: "105046",
    label: "omega-3-triglycerides incl. other esters and acids",
  },
  { value: "1153", label: "Omeprazole" },
  { value: "105047", label: "omnic" },
  { value: "1154", label: "Omnic OCAS" },
  { value: "101517", label: "Omnitrope" },
  { value: "105048", label: "omoconazole" },
  { value: "105049", label: "onbrez" },
  { value: "105050", label: "Onbrez Breezehaler" },
  { value: "101518", label: "Onbrez Breezhaler" },
  { value: "105051", label: "Oncaspar" },
  { value: "101519", label: "OncoTICE" },
  { value: "101520", label: "Oncovin" },
  { value: "1155", label: "Ondansetron" },
  { value: "105052", label: "ondansetron orodispersible" },
  { value: "105053", label: "ondemet" },
  { value: "1156", label: "One-Alpha" },
  { value: "105054", label: "Ongentys" },
  { value: "101521", label: "Onglyza" },
  { value: "105055", label: "Onivyde" },
  { value: "101522", label: "Onkotrone" },
  { value: "101523", label: "Onsenal" },
  { value: "105056", label: "Ontozry" },
  { value: "105057", label: "Onureg" },
  { value: "101524", label: "Opatanol" },
  { value: "105058", label: "Opdivo" },
  { value: "105059", label: "Opicapone" },
  { value: "101525", label: "Opilon" },
  { value: "105060", label: "opiodur" },
  { value: "105061", label: "opipramol" },
  { value: "105062", label: "opium" },
  { value: "105063", label: "Opium derivatives and expectorants" },
  { value: "105064", label: "opium derivatives and mucolytics" },
  { value: "101526", label: "Opizone" },
  { value: "105065", label: "oprelvekin" },
  { value: "105066", label: "opsil" },
  { value: "105067", label: "Opsumit" },
  { value: "101528", label: "Opticrom" },
  { value: "105068", label: "optiflo" },
  { value: "101529", label: "Optiflo G" },
  { value: "101530", label: "Optilast" },
  { value: "101531", label: "Optimax" },
  { value: "101532", label: "Optivate" },
  { value: "101533", label: "Optive" },
  { value: "101535", label: "Oral Impact" },
  { value: "101536", label: "Oraldene" },
  { value: "1157", label: "Oramorph" },
  { value: "101537", label: "Orap" },
  { value: "105069", label: "orciprenaline" },
  { value: "105070", label: "orciprenaline, combinations" },
  { value: "105071", label: "ordinary salt combinations" },
  { value: "105072", label: "ordinary salt combinations and antiflatulents" },
  { value: "101538", label: "Orelox" },
  { value: "101539", label: "Orencia" },
  { value: "101540", label: "Orfadin" },
  { value: "101541", label: "Orgalutran" },
  { value: "105073", label: "organic nitrates in combination" },
  {
    value: "105074",
    label: "organic nitrates in combination with psycholeptics",
  },
  { value: "105075", label: "organo-heparinoid" },
  { value: "101542", label: "Orgaran" },
  { value: "105076", label: "orgotein" },
  { value: "101543", label: "Orgran" },
  { value: "105077", label: "oritavancin" },
  { value: "105078", label: "Orladeyo" },
  { value: "105079", label: "Orlept" },
  { value: "1158", label: "Orlistat" },
  { value: "105080", label: "ornidazole" },
  { value: "105081", label: "ornipressin" },
  { value: "105082", label: "ornithine oxoglurate" },
  { value: "1159", label: "Orphenadrine" },
  { value: "105083", label: "orphenadrine (chloride)" },
  { value: "105084", label: "orphenadrine (citrate)" },
  { value: "105085", label: "Orphenadrine Hydrochloride" },
  { value: "105086", label: "orphenadrine, combinations" },
  { value: "101544", label: "Ortho-Gynest" },
  { value: "101545", label: "Orthovisc" },
  { value: "101546", label: "Orudis" },
  { value: "1160", label: "Oruvail" },
  { value: "101547", label: "Oruvail Gel" },
  { value: "105087", label: "osbon" },
  { value: "101548", label: "Osbon ErecAid" },
  { value: "1161", label: "Oseltamivir" },
  { value: "105088", label: "osimertinib" },
  { value: "101549", label: "Osmanil" },
  { value: "101550", label: "Osmolite" },
  { value: "101551", label: "Ostenil" },
  { value: "101552", label: "Osvaren" },
  { value: "105089", label: "oteracil" },
  { value: "105090", label: "Otezia" },
  {
    value: "105091",
    label: "other meningococcal monovalent purified polysaccharides antigen",
  },
  {
    value: "105092",
    label: "other meningococcal polyvalent purified polysaccharides antigen",
  },
  { value: "105093", label: "other plasma protein fractions" },
  { value: "105094", label: "other preparations, combinations" },
  { value: "105095", label: "others" },
  { value: "105096", label: "otilonium bromide" },
  { value: "105097", label: "otilonium bromide and psycholeptics" },
  { value: "1162", label: "Otomize" },
  { value: "101553", label: "Otosporin" },
  { value: "101554", label: "Otovent" },
  { value: "105098", label: "otrivine" },
  { value: "105099", label: "otrivine adult nasal spray" },
  { value: "101555", label: "Otrivine-Antistin" },
  { value: "105100", label: "ovestin" },
  { value: "101556", label: "Ovestin Cream" },
  { value: "101557", label: "Ovitrelle" },
  { value: "105101", label: "oxabolone cipionate" },
  { value: "105102", label: "oxaceprol" },
  { value: "105103", label: "oxacillin" },
  { value: "1163", label: "Oxactin" },
  { value: "105104", label: "oxaflozane" },
  { value: "1164", label: "Oxaliplatin" },
  { value: "105105", label: "oxametacin" },
  { value: "105106", label: "oxamniquine" },
  { value: "105107", label: "oxandrolone" },
  { value: "105108", label: "oxantel" },
  { value: "105109", label: "oxaprozin" },
  { value: "105110", label: "oxatomide" },
  { value: "1165", label: "Oxazepam" },
  { value: "101558", label: "Oxcarbazepine" },
  { value: "105111", label: "oxedrine" },
  { value: "105112", label: "oxedrine, combinations" },
  { value: "105113", label: "oxeladin" },
  { value: "101559", label: "Oxerutin" },
  { value: "105114", label: "oxetacaine" },
  { value: "105115", label: "oxetorone" },
  { value: "105116", label: "oxiconazole" },
  { value: "105117", label: "oxidized cellulose" },
  { value: "105118", label: "oxiracetam" },
  { value: "1166", label: "Oxis" },
  { value: "101560", label: "Oxis Turbohaler" },
  { value: "105119", label: "oxitriptan" },
  { value: "105120", label: "Oxitropium" },
  { value: "105121", label: "oxitropium bromide" },
  { value: "1167", label: "Oxivent" },
  { value: "105122", label: "oxolamine" },
  { value: "105123", label: "oxolinic acid" },
  { value: "105124", label: "oxomemazine" },
  { value: "1168", label: "Oxprenolol" },
  {
    value: "105125",
    label: "Oxprenolol with cyclopenthiazide 160mg/0.25mg (Co-prenozide)",
  },
  { value: "101561", label: "Oxyal" },
  { value: "101562", label: "Oxybuprocaine" },
  { value: "1169", label: "Oxybutynin" },
  { value: "105126", label: "oxycinchophen" },
  { value: "1170", label: "Oxycodone" },
  { value: "101563", label: "Oxycodone Hydrochloride" },
  { value: "105127", label: "oxycodone, combinations" },
  { value: "1171", label: "OxyContin" },
  { value: "105128", label: "oxyfedrine" },
  { value: "105129", label: "oxyfedrine, combinations" },
  { value: "105130", label: "oxygen" },
  { value: "101564", label: "Oxygen Services" },
  { value: "105131", label: "oxymetazoline" },
  { value: "105132", label: "oxymetholone" },
  { value: "1172", label: "OxyNorm" },
  { value: "105133", label: "oxypertine" },
  { value: "105134", label: "oxyphenbutazone" },
  { value: "105135", label: "oxyphencyclimine" },
  { value: "105136", label: "oxyphencyclimine and psycholeptics" },
  { value: "105137", label: "oxyphenisatine" },
  { value: "105138", label: "oxyphenonium" },
  { value: "105139", label: "oxyphenonium, combinations" },
  { value: "101565", label: "Oxyprenolol" },
  { value: "105140", label: "oxyquinoline" },
  { value: "1173", label: "Oxytetracycline" },
  { value: "105141", label: "oxytetracycline, combinations" },
  { value: "101566", label: "Oxytocin" },
  { value: "105142", label: "ozanimod" },
  { value: "105143", label: "Ozempic" },
  { value: "105144", label: "Ozurdex" },
  { value: "101567", label: "Pabal" },
  { value: "105145", label: "pabrinex" },
  { value: "1174", label: "Paclitaxel" },
  { value: "105146", label: "paclitaxel poliglumex" },
  { value: "105147", label: "palbociclib" },
  { value: "105148", label: "palexia" },
  { value: "105149", label: "Palforzia" },
  { value: "101568", label: "Palifermin" },
  { value: "101569", label: "Paliperidone" },
  { value: "101570", label: "Palivizumab" },
  { value: "101571", label: "Palladone" },
  { value: "101572", label: "Palonosetron" },
  { value: "101573", label: "Paludrine" },
  { value: "105150", label: "pamergan" },
  { value: "101574", label: "Pamergan P100" },
  { value: "1175", label: "Pamidronate" },
  { value: "105151", label: "pamidronic acid" },
  { value: "1176", label: "Pamsvax" },
  { value: "105152", label: "panadol" },
  { value: "101575", label: "Panadol OA" },
  { value: "105153", label: "pancrease" },
  { value: "101576", label: "Pancrease HL" },
  { value: "101577", label: "Pancreatin" },
  { value: "105154", label: "pancreozymin (cholecystokinin)" },
  { value: "1177", label: "Pancrex" },
  { value: "101578", label: "Pancrex V Forte Tablets" },
  { value: "105155", label: "pancuronium" },
  { value: "101579", label: "Pandemrix" },
  { value: "105156", label: "panipenem and betamipron" },
  { value: "101580", label: "Panitumumab" },
  { value: "105157", label: "panobinostat" },
  { value: "101581", label: "Panoxyl" },
  { value: "105158", label: "pantethine" },
  { value: "105159", label: "pantoloc" },
  { value: "1178", label: "Pantoprazole" },
  { value: "105160", label: "papaveretum" },
  { value: "105161", label: "papaverine" },
  { value: "105162", label: "papaverine, combinations" },
  { value: "105163", label: "papillomavirus (human types 16, 18)" },
  { value: "105164", label: "papillomavirus (human types 6, 11, 16, 18)" },
  { value: "101582", label: "Paracetamol" },
  { value: "105165", label: "paracetamol, combinations excl. psycholeptics" },
  { value: "105166", label: "paracetamol, combinations with psycholeptics" },
  { value: "101583", label: "Paradote" },
  { value: "105167", label: "paraldehyde" },
  { value: "101584", label: "Paramax" },
  { value: "105168", label: "paramethadione" },
  { value: "105169", label: "paramethasone" },
  { value: "105170", label: "paraoxon" },
  { value: "105171", label: "parathyroid gland extract" },
  { value: "101585", label: "Parathyroid hormone" },
  { value: "105172", label: "pardelprin" },
  { value: "105173", label: "pardelprin mr" },
  { value: "101586", label: "Parecoxib" },
  { value: "105174", label: "pargyline" },
  { value: "105175", label: "pargyline and diuretics" },
  { value: "101587", label: "Paricalcitol" },
  { value: "1179", label: "Pariet" },
  { value: "105176", label: "paritaprevir" },
  { value: "101588", label: "Parlodel" },
  { value: "105177", label: "Parmid" },
  { value: "105178", label: "Parmid XL" },
  { value: "105179", label: "parnaparin" },
  { value: "105180", label: "paromomycin" },
  { value: "101589", label: "Paroven" },
  { value: "1180", label: "Paroxetine" },
  { value: "101590", label: "Partobulin" },
  { value: "101591", label: "Parvolex" },
  { value: "105181", label: "pasireotide" },
  { value: "105182", label: "Pasrugel" },
  { value: "105183", label: "patiromer calcium" },
  { value: "1181", label: "Patupilone" },
  { value: "101592", label: "Pavacol-D" },
  { value: "105184", label: "Paxoran" },
  { value: "101593", label: "Pazopanib" },
  { value: "105185", label: "pazufloxacin" },
  { value: "101594", label: "Peak flow meter" },
  { value: "105186", label: "pecfent" },
  { value: "105187", label: "pecilocin" },
  { value: "105188", label: "pectin" },
  { value: "101595", label: "Pedea" },
  { value: "101596", label: "Pediacel" },
  { value: "101597", label: "Peezy" },
  { value: "105189", label: "pefloxacin" },
  { value: "105190", label: "pegademase" },
  { value: "101598", label: "Pegaptanib" },
  { value: "105191", label: "pegaspargase" },
  { value: "101599", label: "Pegasys" },
  { value: "101600", label: "Pegfilgrastim" },
  { value: "105192", label: "Peginterferon alfa" },
  { value: "105193", label: "peginterferon alfa-2a" },
  { value: "105194", label: "peginterferon alfa-2a, combinations" },
  { value: "105195", label: "peginterferon alfa-2b" },
  { value: "105196", label: "peginterferon alfa-2b, combinations" },
  { value: "105197", label: "peginterferon beta-1a" },
  { value: "105198", label: "pegloticase" },
  { value: "101601", label: "Pegvisomant" },
  { value: "105199", label: "Pemaryze" },
  { value: "105200", label: "Pembrolizumab" },
  { value: "101602", label: "Pemetrexed" },
  { value: "105201", label: "pemigatinib" },
  { value: "105202", label: "pemoline" },
  { value: "1182", label: "Pen V" },
  { value: "105203", label: "penamecillin" },
  { value: "101603", label: "Penbritin" },
  { value: "105204", label: "penbutolol" },
  { value: "101604", label: "Penciclovir" },
  { value: "105205", label: "penfluridol" },
  { value: "101605", label: "Penicillamine" },
  { value: "105206", label: "penicillin" },
  { value: "101606", label: "Penicillin V" },
  {
    value: "105207",
    label: "penicillins, combinations with other antibacterials",
  },
  { value: "105208", label: "penimepicycline" },
  { value: "101607", label: "Pennsaid" },
  { value: "101608", label: "Pentacarinat" },
  { value: "105209", label: "pentaerithrityl" },
  { value: "105210", label: "pentaerithrityl tetranitrate" },
  { value: "105211", label: "pentaerithrityl tetranitrate, combinations" },
  { value: "105212", label: "pentagastrin" },
  { value: "101609", label: "Pentamidine" },
  { value: "105213", label: "pentamidine isethionate" },
  { value: "105214", label: "pentamycin" },
  { value: "1183", label: "Pentasa" },
  { value: "101610", label: "Pentazocine" },
  { value: "105215", label: "pentetrazol" },
  { value: "105216", label: "pentetrazol, combinations" },
  { value: "105217", label: "penthienate" },
  { value: "105218", label: "pentifylline" },
  { value: "105219", label: "pentobarbital" },
  { value: "105220", label: "pentosan polysulfate sodium" },
  { value: "105221", label: "pentostam" },
  { value: "101611", label: "Pentostatin" },
  { value: "1184", label: "Pentoxifylline" },
  { value: "105222", label: "pentoxyverine" },
  { value: "101612", label: "Pentrax" },
  { value: "101613", label: "Pepcid" },
  { value: "105223", label: "peppermint" },
  { value: "101615", label: "Peppermint oil" },
  { value: "105224", label: "pepsin" },
  { value: "105225", label: "pepsin and acid preparations" },
  { value: "1185", label: "Peptac" },
  { value: "105226", label: "peptamen" },
  { value: "105227", label: "perampanel" },
  { value: "105228", label: "perative" },
  { value: "105229", label: "perazine" },
  { value: "101616", label: "Percutol" },
  { value: "105230", label: "Percutrol" },
  { value: "101617", label: "Perdix" },
  { value: "101618", label: "Perfalgan" },
  { value: "105231", label: "perflenapent" },
  { value: "105232", label: "perflubron" },
  { value: "1186", label: "Pergolide" },
  { value: "101619", label: "Pergoveris" },
  { value: "105233", label: "perhexiline" },
  { value: "101620", label: "Periactin" },
  { value: "101621", label: "Periciazine" },
  { value: "1187", label: "Pericyazine" },
  { value: "101622", label: "Perinal" },
  { value: "1188", label: "Perindopril" },
  { value: "105235", label: "perindopril and diuretics" },
  { value: "105234", label: "Perindopril with indapamide 4/1.25mg" },
  { value: "101623", label: "Periostat" },
  { value: "1189", label: "Peritone" },
  { value: "105236", label: "Perjeta" },
  { value: "105237", label: "permethrin" },
  { value: "105238", label: "permethrin, combinations" },
  { value: "101624", label: "Permitabs" },
  { value: "1190", label: "Permixon" },
  { value: "101625", label: "Perphenazine" },
  { value: "1191", label: "Persantin" },
  { value: "101626", label: "Persantin Retard" },
  { value: "101628", label: "Pertussis" },
  { value: "105239", label: "pertussis immunoglobulin" },
  { value: "105240", label: "pertussis, inactivated, whole cell" },
  {
    value: "105241",
    label: "pertussis, inactivated, whole cell, combinations with toxoids",
  },
  { value: "105242", label: "pertussis, purified antigen" },
  {
    value: "105243",
    label: "pertussis, purified antigen, combinations with toxoids",
  },
  { value: "105244", label: "pertuzumab" },
  { value: "101629", label: "Peru Balsam" },
  { value: "105245", label: "peruvoside" },
  { value: "1192", label: "Pethidine" },
  { value: "105246", label: "pethidine and antispasmodics" },
  { value: "105247", label: "pethidine, combinations excl. psycholeptics" },
  { value: "105248", label: "pethidine, combinations with psycholeptics" },
  { value: "101630", label: "Pevaryl" },
  { value: "105249", label: "peyona" },
  { value: "105250", label: "phanquinone" },
  { value: "101631", label: "Pharmorubicin" },
  { value: "105251", label: "pheburane" },
  { value: "105252", label: "phenacemide" },
  { value: "105253", label: "phenacetin" },
  { value: "105254", label: "phenacetin, combinations excl. psycholeptics" },
  { value: "105255", label: "phenacetin, combinations with psycholeptics" },
  { value: "105256", label: "phenazocine" },
  { value: "105257", label: "phenazone" },
  { value: "105258", label: "phenazone, combinations excl. psycholeptics" },
  { value: "105259", label: "phenazone, combinations with psycholeptics" },
  { value: "105260", label: "phenazopyridine" },
  { value: "101632", label: "Phenelzine" },
  { value: "101633", label: "Phenergan" },
  { value: "105261", label: "pheneticillin" },
  { value: "105262", label: "pheneturide" },
  { value: "105263", label: "phenformin" },
  { value: "105264", label: "phenformin and sulfonamides" },
  { value: "105265", label: "phenglutarimide" },
  { value: "105266", label: "phenindamine" },
  { value: "1193", label: "Phenindione" },
  { value: "105267", label: "pheniramine" },
  { value: "1194", label: "Phenobarbital" },
  { value: "105268", label: "Phenobarbitone" },
  { value: "105269", label: "phenol" },
  { value: "105270", label: "phenolphthalein" },
  { value: "105271", label: "phenolsulfonphthalein" },
  { value: "105272", label: "phenoperidine" },
  { value: "105273", label: "phenothrin" },
  { value: "105274", label: "phenothrin, combinations" },
  { value: "101634", label: "Phenoxybenzamine" },
  { value: "1195", label: "Phenoxymethylpenicillin" },
  { value: "105275", label: "Phenoxymethylpenicillin (Penicillin V)" },
  { value: "105276", label: "phenprobamate" },
  { value: "105277", label: "phenprobamate, combinations excl. psycholeptics" },
  { value: "105278", label: "phenprobamate, combinations with psycholeptics" },
  { value: "105279", label: "phenprocoumon" },
  { value: "105280", label: "phensuximide" },
  { value: "105281", label: "phentermine" },
  { value: "101635", label: "Phentolamine" },
  { value: "101636", label: "Phentolamine Mesilate" },
  { value: "105282", label: "phentolamine mesylate" },
  { value: "105283", label: "phenyl salicylate" },
  { value: "105284", label: "phenylalanine" },
  { value: "105285", label: "phenylalanine 50" },
  { value: "101637", label: "Phenylalanine AA Supplement" },
  { value: "105286", label: "phenylbutazone" },
  { value: "105287", label: "phenylbutazone and corticosteroids" },
  { value: "101638", label: "Phenylephrine" },
  { value: "105288", label: "phenylephrine, combinations" },
  { value: "105289", label: "phenylethyl" },
  { value: "101639", label: "Phenylethyl Alcohol" },
  { value: "105290", label: "phenylmercuric borate" },
  { value: "105291", label: "phenylmercuric nitrate" },
  { value: "105292", label: "phenylpropanolamine" },
  { value: "105293", label: "phenylpropanolamine, combinations" },
  { value: "1196", label: "Phenytoin" },
  { value: "105294", label: "Phenytoin (as liquid) 30mg/5ml" },
  { value: "105295", label: "Phenytoin sodium (as tablets/capsules)" },
  { value: "105296", label: "phenytoin, combinations" },
  { value: "105297", label: "phlexy-10" },
  { value: "101640", label: "Phlexy-10 Drink Mix" },
  { value: "1197", label: "Phloretin" },
  { value: "105298", label: "phloroglucinol" },
  { value: "1198", label: "Pholcodine" },
  { value: "1199", label: "Phosex" },
  { value: "101641", label: "PhosLo" },
  { value: "105299", label: "phosphates" },
  { value: "105300", label: "Phosphates (rectal)" },
  { value: "105301", label: "phosphates enema bp" },
  { value: "105302", label: "phosphorous (32P) chromicphosphate colloid" },
  { value: "105303", label: "Phospho-soda oral solution" },
  { value: "105304", label: "phthalylsulfathiazole" },
  { value: "105305", label: "phyllocontin" },
  { value: "1200", label: "Phyllocontin Continus" },
  { value: "101642", label: "Physeptone" },
  { value: "101643", label: "Physeptone Mixture" },
  { value: "1201", label: "Physiotens" },
  { value: "105306", label: "physostigmine" },
  { value: "105307", label: "phytex" },
  { value: "105308", label: "phytex paint" },
  { value: "101644", label: "Phytomenadione" },
  { value: "105309", label: "picato" },
  { value: "105310", label: "picloxydine" },
  { value: "105311", label: "picodralazine and diuretics" },
  {
    value: "105312",
    label: "picodralazine and diuretics, combinations with psycholeptics",
  },
  { value: "101645", label: "Picolax" },
  { value: "105313", label: "picotamide" },
  { value: "105314", label: "pidotimod" },
  { value: "101646", label: "Piko-1" },
  { value: "101647", label: "Pilocarpine" },
  { value: "105315", label: "pilocarpine, combinations" },
  { value: "101648", label: "Pilogel" },
  { value: "101649", label: "Pimecrolimus" },
  { value: "105316", label: "pimethixene" },
  { value: "1202", label: "Pimozide" },
  { value: "105317", label: "pinacidil" },
  { value: "105318", label: "pinacidil and diuretics" },
  { value: "105319", label: "pinaverium" },
  { value: "105320", label: "pinazepam" },
  { value: "1203", label: "Pindolol" },
  { value: "105321", label: "pindolol and other diuretics" },
  { value: "105322", label: "Pindolol with clopamide 10mg/5mg" },
  { value: "105323", label: "Pinefeld" },
  { value: "105324", label: "pinetarsol" },
  { value: "101650", label: "Pinetarsol Bath Oil" },
  { value: "105325", label: "pinexel" },
  { value: "105326", label: "pinexel pr" },
  { value: "105327", label: "Pinmactil" },
  { value: "1204", label: "Pioglitazone" },
  { value: "105328", label: "pipamperone" },
  { value: "105329", label: "pipazetate" },
  { value: "105330", label: "pipecuronium bromide" },
  { value: "105331", label: "pipemidic acid" },
  { value: "105332", label: "pipenzolate" },
  { value: "101651", label: "Piperacillin" },
  { value: "105333", label: "piperacillin and enzyme inhibitor" },
  { value: "101652", label: "Piperazine" },
  { value: "105334", label: "piperidione" },
  { value: "105335", label: "piperidolate" },
  { value: "105336", label: "Pipexus" },
  { value: "105337", label: "pipobroman" },
  { value: "105338", label: "piportil" },
  { value: "101653", label: "Piportil Depot" },
  { value: "105339", label: "Pipothiazone Palm" },
  { value: "1205", label: "Pipotiazine" },
  { value: "105340", label: "pipradrol" },
  { value: "105341", label: "piprozolin" },
  { value: "105342", label: "Piqray" },
  { value: "1206", label: "Piracetam" },
  { value: "105343", label: "pirarubicin" },
  { value: "105344", label: "pirbuterol" },
  { value: "105345", label: "pirenzepine" },
  { value: "105346", label: "piretanide" },
  { value: "105347", label: "pirfenidone" },
  { value: "105348", label: "piribedil" },
  { value: "105349", label: "pirisudanol" },
  { value: "1207", label: "Piriton" },
  { value: "105350", label: "piritramide" },
  { value: "105351", label: "piromidic acid" },
  { value: "1208", label: "Piroxicam" },
  { value: "105352", label: "pirprofen" },
  { value: "105353", label: "pitavastatin" },
  { value: "105354", label: "pitofenone and analgesics" },
  { value: "101654", label: "Pitressin" },
  { value: "105355", label: "pivagabine" },
  { value: "105356", label: "pivampicillin" },
  { value: "101655", label: "Pivmecillinam" },
  { value: "105357", label: "pixantrone" },
  { value: "105358", label: "Pixuvri" },
  { value: "1209", label: "Pizotifen" },
  { value: "105359", label: "plague, inactivated, whole cell" },
  { value: "1210", label: "Plaquenil" },
  { value: "105360", label: "plastic IUD" },
  { value: "105361", label: "plastic IUD with copper" },
  { value: "105362", label: "plastic IUD with progestogen" },
  { value: "1211", label: "Plavix" },
  { value: "105363", label: "pleconaril" },
  { value: "105364", label: "Plegidry" },
  { value: "105365", label: "Plenadren" },
  { value: "105366", label: "plenandren" },
  { value: "1212", label: "Plendil" },
  { value: "101656", label: "Plerixafor" },
  { value: "1213", label: "Pletal" },
  { value: "105367", label: "plicamycin" },
  { value: "105368", label: "pneumococcal" },
  { value: "101657", label: "Pneumococcal vaccine" },
  {
    value: "105369",
    label:
      "pneumococcus purified polysaccharides antigen and Haemophilus influenzae, conjugated",
  },
  { value: "105370", label: "pneumococcus, purified polysaccharides antigen" },
  {
    value: "105371",
    label: "pneumococcus, purified polysaccharides antigen conjugated",
  },
  { value: "105372", label: "pneumovax" },
  { value: "101658", label: "Pneumovax II" },
  { value: "101659", label: "Pocket Chamber" },
  { value: "101660", label: "Pocket Peak" },
  { value: "101661", label: "Podophyllotoxin" },
  { value: "105373", label: "polatuzumab vedotin" },
  { value: "105374", label: "poldine" },
  { value: "105375", label: "policosanol" },
  { value: "105376", label: "policresulen" },
  { value: "105377", label: "polidocanol" },
  { value: "105378", label: "polihexanide" },
  { value: "105379", label: "poliomyelitis oral, monovalent live attenuated" },
  { value: "105380", label: "poliomyelitis oral, trivalent, live attenuated" },
  {
    value: "105381",
    label: "poliomyelitis, trivalent, inactivated, whole virus",
  },
  { value: "105382", label: "Politid" },
  { value: "105383", label: "Politid XL" },
  { value: "105384", label: "Polivy" },
  { value: "101662", label: "Pollens" },
  { value: "101663", label: "Pollinex" },
  { value: "105385", label: "poly I:C" },
  { value: "105386", label: "poly ICLC" },
  { value: "101664", label: "Polycal" },
  { value: "1214", label: "Polycal Powder" },
  { value: "105387", label: "polycarbophil calcium" },
  { value: "105388", label: "polyestradiol phosphate" },
  { value: "105389", label: "polyethylene" },
  { value: "101665", label: "Polyethylene Glycol" },
  { value: "101666", label: "Polyfax" },
  { value: "105390", label: "polyglucose" },
  { value: "101667", label: "Polyglucose polymer" },
  { value: "101668", label: "Polymyxin" },
  { value: "101669", label: "Polymyxin B" },
  { value: "105391", label: "polynoxylin" },
  { value: "105392", label: "polyplatillen" },
  { value: "105393", label: "Polysaccharide Iron Complex" },
  { value: "101670", label: "Polysorbate" },
  { value: "105394", label: "polystyrene" },
  { value: "105395", label: "polystyrene sulfonate" },
  { value: "101671", label: "Polystyrene sulphonate" },
  { value: "105396", label: "polytar" },
  { value: "101672", label: "Polytar Liquid" },
  { value: "105397", label: "polythiazide" },
  { value: "105398", label: "polyvinyl" },
  { value: "101673", label: "Polyvinyl alcohol" },
  { value: "101674", label: "Polyvinylpyrrolidone" },
  { value: "105399", label: "pomalidomide" },
  { value: "105400", label: "ponatinib" },
  { value: "105401", label: "Ponesimod" },
  { value: "101675", label: "Ponstan" },
  { value: "105402", label: "ponstan forte" },
  { value: "105403", label: "Ponvory" },
  { value: "101676", label: "Poractant" },
  { value: "105404", label: "porfimer sodium" },
  { value: "105405", label: "Pork Actrapid" },
  { value: "105406", label: "Pork Mixtard" },
  { value: "1215", label: "Portiron" },
  { value: "105407", label: "Portrazza" },
  { value: "1216", label: "Posaconazole" },
  { value: "101677", label: "Pos-T-Vac" },
  { value: "101678", label: "Potaba" },
  { value: "105408", label: "potassium acetate" },
  { value: "101679", label: "Potassium Bicarbonate" },
  { value: "105409", label: "potassium canrenoate" },
  { value: "101680", label: "Potassium Chloride" },
  { value: "105410", label: "potassium chloride, combinations" },
  { value: "1217", label: "Potassium Citrate" },
  { value: "105411", label: "potassium clorazepate" },
  { value: "105412", label: "potassium gluconate" },
  { value: "105413", label: "potassium hydrogencarbonate" },
  { value: "105414", label: "potassium hydrogentartrate" },
  { value: "105415", label: "potassium hydroxyquinoline sulphate" },
  { value: "101681", label: "Potassium Hydroxy-Quinoline Sulphate" },
  { value: "105416", label: "potassium iodide" },
  { value: "105417", label: "potassium lactate" },
  { value: "105418", label: "potassium perchlorate" },
  { value: "101682", label: "Potassium permanganate" },
  {
    value: "105419",
    label: "potassium phosphate, incl. comb. with other potassium salts",
  },
  { value: "105420", label: "potassium polysulfide" },
  { value: "105421", label: "potassium salicylate" },
  { value: "105422", label: "Poteligeo" },
  { value: "101683", label: "Povidone" },
  { value: "101684", label: "Povidone-iodine" },
  { value: "101685", label: "Powerbreathe" },
  { value: "101686", label: "Powergel" },
  { value: "105423", label: "practolol" },
  { value: "101687", label: "Pradaxa" },
  { value: "105424", label: "prajmaline" },
  { value: "105425", label: "pralatrexate" },
  { value: "105426", label: "pralidoxime" },
  { value: "105427", label: "Praluent" },
  { value: "1218", label: "Pramipexole" },
  { value: "105428", label: "Pramiplexole" },
  { value: "105429", label: "pramiracetam" },
  { value: "105430", label: "pramlintide" },
  { value: "101688", label: "Pramocaine" },
  { value: "1219", label: "Prandin" },
  { value: "105431", label: "pranlukast" },
  { value: "105432", label: "pranoprofen" },
  { value: "1220", label: "Prareduct" },
  { value: "105433", label: "prasterone" },
  { value: "1221", label: "Prasugrel" },
  { value: "105434", label: "Pravadual" },
  { value: "1222", label: "Pravaselect" },
  { value: "1223", label: "Pravastatin" },
  { value: "105435", label: "Pravastatin Sodium" },
  { value: "1224", label: "Praxilene" },
  { value: "105436", label: "prazepam" },
  { value: "105437", label: "praziquantel" },
  { value: "1225", label: "Prazosin" },
  { value: "105438", label: "prazosin and diuretics" },
  { value: "105439", label: "Prazosin HCI" },
  { value: "105440", label: "preblacon" },
  { value: "105441", label: "preblacon xl" },
  { value: "105442", label: "pred" },
  { value: "101689", label: "Pred Forte" },
  { value: "1226", label: "Predenema" },
  { value: "1227", label: "Predfoam" },
  { value: "105443", label: "prednicarbate" },
  { value: "105444", label: "prednimustine" },
  { value: "1228", label: "Prednisolone" },
  {
    value: "105445",
    label: "Prednisolone (as sodium phosphate or metasulphobenzoate)*",
  },
  { value: "105446", label: "prednisolone and antibiotics" },
  { value: "105447", label: "prednisolone and antiinfectives" },
  { value: "105448", label: "prednisolone and antiseptics" },
  { value: "105449", label: "prednisolone and mydriatics" },
  { value: "105450", label: "prednisolone, combinations" },
  { value: "105451", label: "prednisone" },
  { value: "105452", label: "prednylidene" },
  { value: "101690", label: "Predsol" },
  { value: "101691", label: "Predsol Enema" },
  { value: "1229", label: "Pregabalin" },
  { value: "1230", label: "Pregaday" },
  { value: "105453", label: "pregestimil" },
  { value: "101692", label: "Pregestimil Lipil" },
  { value: "101693", label: "Pregnyl" },
  { value: "1231", label: "Premarin" },
  { value: "101694", label: "Premique" },
  { value: "101695", label: "Premique Cycle" },
  { value: "1232", label: "Prempak-C" },
  { value: "105454", label: "prenalterol" },
  { value: "105455", label: "prenoxad" },
  { value: "105456", label: "prenoxdiazine" },
  { value: "105457", label: "prenylamine" },
  { value: "105458", label: "prenylamine, combinations" },
  { value: "101696", label: "Preotact" },
  { value: "101697", label: "Prescal" },
  { value: "101698", label: "Preservex" },
  { value: "105459", label: "Presolol" },
  { value: "1233", label: "Prestarium" },
  { value: "101699", label: "Prestim" },
  { value: "1234", label: "Pretanix" },
  { value: "1235", label: "Preterax" },
  { value: "105460", label: "prethcamide" },
  { value: "1236", label: "Prevacid" },
  { value: "105461", label: "prevenar" },
  { value: "101700", label: "Prevenar 13" },
  { value: "1237", label: "Prevencor" },
  { value: "1238", label: "Previscan" },
  { value: "105462", label: "Prevymis" },
  { value: "105463", label: "Prezcobix" },
  { value: "105464", label: "Preziata" },
  { value: "101701", label: "Prezista" },
  { value: "1239", label: "Priadel" },
  { value: "101702", label: "Prialt" },
  { value: "105465", label: "pridinol" },
  { value: "105466", label: "prifinium bromide" },
  { value: "105467", label: "priligy" },
  { value: "101703", label: "Prilocaine" },
  { value: "105468", label: "prilocaine, combinations" },
  { value: "101704", label: "Primacor" },
  { value: "105469", label: "primaquine" },
  { value: "105470", label: "primaxin" },
  { value: "101705", label: "Primaxin IV" },
  { value: "1240", label: "Primidone" },
  { value: "105471", label: "primolut" },
  { value: "101706", label: "Primolut N" },
  { value: "1241", label: "Prinivil" },
  { value: "105472", label: "Prinzide" },
  { value: "101707", label: "Priorix" },
  { value: "101708", label: "Pripsen" },
  { value: "105473", label: "pristinamycin" },
  { value: "1242", label: "Pritor" },
  { value: "101710", label: "Privigen" },
  { value: "1243", label: "Pro-Banthine" },
  { value: "105474", label: "probenecid" },
  { value: "105475", label: "probucol" },
  { value: "101714", label: "Procainamide" },
  { value: "105476", label: "procaine" },
  { value: "105477", label: "procaine benzylpenicillin" },
  { value: "105478", label: "procaine, combinations" },
  { value: "105479", label: "pro-cal" },
  { value: "101711", label: "Pro-Cal Powder" },
  { value: "105480", label: "procarbazine" },
  { value: "105481", label: "procaterol" },
  { value: "105482", label: "proceli" },
  { value: "1244", label: "Prochlorperazine" },
  { value: "1245", label: "Procoralan" },
  { value: "105483", label: "procoralan (ivabradine)" },
  { value: "105484", label: "proctofoam" },
  { value: "101715", label: "Proctofoam HC" },
  { value: "1246", label: "Proctosedyl" },
  { value: "1247", label: "Procyclidine" },
  { value: "105485", label: "Procyclidine Hydrochloride" },
  { value: "101712", label: "Pro-Epanutin" },
  { value: "105486", label: "profenamine" },
  { value: "105487", label: "progabide" },
  { value: "101716", label: "Progesterone" },
  { value: "105488", label: "proglumetacin" },
  { value: "105489", label: "proglumide" },
  { value: "1248", label: "Prograf" },
  { value: "101717", label: "Proguanil" },
  { value: "105490", label: "proguanil, combinations" },
  { value: "1249", label: "Progynova" },
  { value: "101718", label: "Progynova TS" },
  { value: "105491", label: "proleukin" },
  { value: "101719", label: "Proleukin S.C." },
  { value: "101720", label: "Prolia" },
  { value: "105492", label: "prolintane" },
  { value: "1250", label: "Promazine" },
  { value: "105493", label: "Promazine HCI" },
  { value: "105494", label: "promegestone" },
  { value: "105495", label: "promestriene" },
  { value: "105496", label: "prometax" },
  { value: "1251", label: "Promethazine" },
  { value: "105497", label: "Promethazine theoclate" },
  { value: "105498", label: "promethazine, combinations" },
  { value: "101721", label: "Promin" },
  { value: "101722", label: "Promixin" },
  { value: "101723", label: "Pronestyl" },
  { value: "105499", label: "prontoderm" },
  { value: "105500", label: "propacetamol" },
  { value: "1252", label: "Propafenone" },
  { value: "105501", label: "Propafenone HCI" },
  { value: "101724", label: "Propamidine" },
  { value: "105502", label: "propanidid" },
  { value: "105503", label: "propanol" },
  { value: "105504", label: "propanol, combinations" },
  { value: "1253", label: "Propantheline" },
  { value: "105505", label: "propantheline and psycholeptics" },
  { value: "105506", label: "propatylnitrate" },
  { value: "105507", label: "propatylnitrate, combinations" },
  { value: "105508", label: "propenidazole" },
  { value: "105509", label: "propentofylline" },
  { value: "101725", label: "Propess" },
  { value: "105510", label: "propicillin" },
  { value: "105511", label: "propiomazine" },
  { value: "1254", label: "Propiverine" },
  { value: "101726", label: "Propofol" },
  { value: "1255", label: "Propranolol" },
  { value: "105512", label: "propyl" },
  { value: "101727", label: "Propyl Hydroxybenzoate" },
  { value: "105513", label: "propyliodone" },
  { value: "1256", label: "Propylthiouracil" },
  { value: "105514", label: "propyphenazone" },
  {
    value: "105515",
    label: "propyphenazone, combinations excl. psycholeptics",
  },
  { value: "105516", label: "propyphenazone, combinations with psycholeptics" },
  { value: "105517", label: "proquazone" },
  { value: "1257", label: "Proscar" },
  { value: "105518", label: "proscillaridin" },
  { value: "105519", label: "proscillaridin, combinations" },
  { value: "101728", label: "ProSource" },
  { value: "105520", label: "prostap" },
  { value: "1258", label: "Prostap SR" },
  { value: "105521", label: "prostap sr dcs" },
  { value: "105522", label: "prostin" },
  { value: "101729", label: "Prostin E2" },
  { value: "101730", label: "Prostin VR" },
  { value: "101732", label: "ProSure" },
  { value: "1259", label: "Prosurin" },
  { value: "101733", label: "Protamine" },
  { value: "101734", label: "Protamine Zinc Insulin" },
  { value: "105523", label: "protein" },
  { value: "101735", label: "Protein C" },
  { value: "105524", label: "protein hydrolysates" },
  { value: "1260", label: "Protelos" },
  { value: "1261", label: "Prothiaden" },
  { value: "105525", label: "prothipendyl" },
  { value: "101736", label: "Protifar" },
  { value: "105526", label: "protiofate" },
  { value: "105527", label: "protionamide" },
  { value: "105528", label: "protirelin" },
  { value: "1262", label: "Protium" },
  { value: "101737", label: "Protium I.V." },
  { value: "101738", label: "Protopic" },
  { value: "105529", label: "protriptyline" },
  { value: "1263", label: "Provera" },
  { value: "105530", label: "provide" },
  { value: "1264", label: "Provigil" },
  { value: "101713", label: "Pro-Viron" },
  { value: "105531", label: "proxazole" },
  { value: "105532", label: "proxibarbal" },
  { value: "101740", label: "Proxymetacaine" },
  { value: "105533", label: "proxyphylline" },
  { value: "105534", label: "proxyphylline and adrenergics" },
  { value: "1265", label: "Prozac" },
  { value: "105535", label: "prozep" },
  { value: "105536", label: "prozep oral solution" },
  { value: "101741", label: "ProZero" },
  { value: "101742", label: "Prucalopride" },
  { value: "105537", label: "prulifloxacin" },
  { value: "105538", label: "prussian blue" },
  { value: "101743", label: "Pseudoephedrine" },
  { value: "105539", label: "pseudoephedrine, combinations" },
  { value: "101744", label: "Psoriderm" },
  { value: "101745", label: "Psorin" },
  { value: "1266", label: "Pulmicort" },
  { value: "101746", label: "Pulmicort Inhaler CFC-free" },
  { value: "105540", label: "pulmicort turbohaler" },
  { value: "101747", label: "Pulmozyme" },
  { value: "105541", label: "pulvinal" },
  { value: "101748", label: "Pulvinal Beclometasone" },
  { value: "101749", label: "Pulvinal Salbutamol" },
  { value: "105542", label: "pure" },
  { value: "101750", label: "Puregon" },
  { value: "1267", label: "Purinethol" },
  { value: "101751", label: "Puri-Nethol" },
  { value: "105543", label: "pva" },
  { value: "105544", label: "pva 1.4 tubilux" },
  { value: "101752", label: "PVA 1.4% Tubilux" },
  { value: "105545", label: "pygeum africanum" },
  { value: "101753", label: "Pylobactell" },
  { value: "101754", label: "Pyralvex" },
  { value: "105546", label: "pyrantel" },
  { value: "1268", label: "Pyrazinamide" },
  { value: "105547", label: "pyrethrum" },
  { value: "105548", label: "pyrethrum, combinations" },
  { value: "1269", label: "Pyridostigmine" },
  { value: "105549", label: "pyridoxal phosphate" },
  { value: "101755", label: "Pyridoxine" },
  { value: "105550", label: "pyridoxine (vit B6)" },
  { value: "1270", label: "Pyridoxine Hydrochloride" },
  { value: "1271", label: "Pyrimethamine" },
  { value: "105551", label: "pyrimethamine, combinations" },
  { value: "105552", label: "pyrithione zinc" },
  { value: "105553", label: "pyrithyldione" },
  { value: "105554", label: "pyritinol" },
  { value: "105555", label: "pyrrobutamine" },
  { value: "105556", label: "pyrrobutamine, combinations" },
  { value: "105557", label: "pyrrolnitrin" },
  { value: "105558", label: "pyrvinium" },
  { value: "105559", label: "Qtern" },
  { value: "105560", label: "quassia" },
  { value: "105561", label: "quazepam" },
  { value: "1272", label: "Questran" },
  { value: "101756", label: "Questran Light" },
  { value: "1273", label: "Quetiapine" },
  { value: "1274", label: "Quinagolide" },
  { value: "1275", label: "Quinapril" },
  { value: "105562", label: "quinapril and diuretics" },
  { value: "105563", label: "Quinapril with hydrochlorothiazide 10/12.5mg" },
  { value: "105564", label: "quinbolone" },
  { value: "105565", label: "quinethazone" },
  { value: "105566", label: "quingestanol" },
  { value: "101758", label: "Quinidine" },
  { value: "105567", label: "Quinidine Bisulph" },
  { value: "105568", label: "Quinidine Sulph" },
  { value: "105569", label: "quinidine, combinations excl. psycholeptics" },
  { value: "105570", label: "quinidine, combinations with psycholeptics" },
  { value: "1276", label: "Quinil" },
  { value: "1277", label: "Quinine" },
  { value: "1278", label: "Quinine Bisulphate" },
  { value: "101759", label: "Quinine sulphate" },
  { value: "105571", label: "quinine, combinations with psycholeptics" },
  { value: "105572", label: "quinisocaine" },
  { value: "105573", label: "quinoderm" },
  { value: "101760", label: "Quinoderm Cream" },
  { value: "105574", label: "Quinoric" },
  { value: "105575", label: "quinupramine" },
  { value: "105576", label: "quinupristin/dalfopristin" },
  { value: "101761", label: "Qutenza" },
  { value: "101762", label: "QV Cream" },
  { value: "1279", label: "Qvar" },
  { value: "1280", label: "Rabeprazole" },
  { value: "105577", label: "rabeprazole, combinations" },
  { value: "105578", label: "rabies immunoglobulin" },
  { value: "105579", label: "rabies serum" },
  { value: "101763", label: "Rabies vaccine" },
  { value: "101764", label: "Rabies Vaccine BP" },
  { value: "105580", label: "rabies, inactivated, whole virus" },
  { value: "101765", label: "Rabipur" },
  { value: "105581", label: "racecadotril" },
  { value: "105582", label: "Radioactive phosphorus (32P)" },
  { value: "105583", label: "radium (223ra) dichloride" },
  { value: "105584", label: "rageay" },
  { value: "105585", label: "Ralnea" },
  { value: "105586", label: "Ralnea XL" },
  { value: "1281", label: "Raloxifene" },
  { value: "1282", label: "Raltegravir" },
  { value: "1283", label: "Raltitrexed" },
  { value: "105587", label: "ramelteon" },
  { value: "105588", label: "Ramic" },
  { value: "1284", label: "Ramipril" },
  { value: "1285", label: "Ranbaxy" },
  { value: "1286", label: "Ranexa" },
  { value: "105589", label: "ranexa (ranolazine)" },
  { value: "105590", label: "Ranfaxine" },
  { value: "105591", label: "Ranfaxine XL" },
  { value: "101766", label: "Ranibizumab" },
  { value: "105592", label: "ranimustine" },
  { value: "1287", label: "Ranitidine" },
  { value: "105593", label: "ranitidine bismuth citrate" },
  { value: "1288", label: "Ranolazine" },
  { value: "1289", label: "Ranopril" },
  { value: "1290", label: "Rantidina" },
  { value: "101767", label: "Rapamune" },
  { value: "101768", label: "Rapifen" },
  { value: "105594", label: "rapilose" },
  { value: "101769", label: "Rapilysin" },
  { value: "101770", label: "Rapitil" },
  { value: "105595", label: "raponer" },
  { value: "105596", label: "raponer xl" },
  { value: "105597", label: "Raporsin" },
  { value: "105598", label: "raporsin xl" },
  { value: "101771", label: "Rapport" },
  { value: "101772", label: "Rapydan" },
  { value: "1291", label: "Rasagiline" },
  { value: "101773", label: "Rasburicase" },
  { value: "1292", label: "Rasilez" },
  { value: "105599", label: "ratiograstim" },
  { value: "105600", label: "rauwolfia alkaloids, whole root" },
  { value: "105601", label: "rauwolfia alkaloids, whole root and diuretics" },
  { value: "105602", label: "ravulizumab" },
  { value: "105603", label: "rawel" },
  { value: "105604", label: "rawel xl" },
  { value: "105605", label: "rebamipide" },
  { value: "101774", label: "Rebetol" },
  { value: "1293", label: "Rebif" },
  { value: "1294", label: "Reboxetine" },
  { value: "1295", label: "Recentin" },
  { value: "105606", label: "recivit" },
  { value: "101775", label: "Rectogesic" },
  { value: "1296", label: "Reductil" },
  { value: "105607", label: "refacto" },
  { value: "101776", label: "ReFacto AF" },
  { value: "101777", label: "Refludan" },
  { value: "101778", label: "Refolinon" },
  { value: "105608", label: "regadenoson" },
  { value: "105609", label: "regelle" },
  { value: "105610", label: "regorafenib" },
  { value: "101779", label: "Regranex" },
  { value: "101780", label: "Regulan" },
  { value: "101781", label: "Regurin" },
  { value: "105611", label: "Rekambys" },
  { value: "101782", label: "Relactagel" },
  { value: "1297", label: "Relafen" },
  { value: "101783", label: "Relaxit" },
  { value: "101784", label: "Relenza" },
  { value: "101785", label: "Relestat" },
  { value: "1298", label: "Relifex" },
  { value: "101786", label: "Relistor" },
  { value: "105612", label: "Relosorb" },
  { value: "101787", label: "Relpax" },
  { value: "105613", label: "reltebon" },
  { value: "105614", label: "Relvar" },
  { value: "105615", label: "Relvar Ellipta" },
  { value: "1299", label: "Remedeine" },
  { value: "101788", label: "Remicade" },
  { value: "101789", label: "Remifentanil" },
  { value: "105616", label: "remikiren" },
  { value: "101790", label: "Reminyl" },
  { value: "1300", label: "Remniyl" },
  { value: "105617", label: "removab" },
  { value: "105618", label: "remoxipride" },
  { value: "105619", label: "Remsima" },
  { value: "105620", label: "Renacet" },
  { value: "1301", label: "Renagel" },
  { value: "101791", label: "Renamil" },
  { value: "1302", label: "Renapro" },
  { value: "101792", label: "Renastart" },
  { value: "105621", label: "renehavis" },
  { value: "105622", label: "renilon" },
  { value: "101793", label: "Renilon 7.5" },
  { value: "105623", label: "renvela" },
  { value: "101794", label: "Reopro" },
  { value: "101795", label: "Repadina" },
  { value: "1303", label: "Repaglinide" },
  { value: "105624", label: "Repatha" },
  { value: "101796", label: "Repevax" },
  { value: "105625", label: "Repinex" },
  { value: "105626", label: "Repinex XL" },
  { value: "101797", label: "Replenine-VF" },
  { value: "105627", label: "replens" },
  { value: "101798", label: "Replens MD" },
  { value: "105628", label: "reposal" },
  { value: "105629", label: "reproterol" },
  {
    value: "105630",
    label: "reproterol and other drugs for obstructive airway diseases",
  },
  { value: "1304", label: "Requip" },
  { value: "105631", label: "Requip XL" },
  { value: "105632", label: "rescinnamine" },
  { value: "105633", label: "rescinnamine and diuretics" },
  {
    value: "105634",
    label: "rescinnamine and diuretics, combinations with other drugs",
  },
  { value: "105635", label: "reserpine" },
  { value: "105636", label: "reserpine and diuretics" },
  {
    value: "105637",
    label: "reserpine and diuretics, combinations with other drugs",
  },
  {
    value: "105638",
    label: "reserpine and diuretics, combinations with psycholeptics",
  },
  { value: "105639", label: "reserpine, combinations" },
  { value: "105640", label: "reslizumab" },
  { value: "101799", label: "Resolor" },
  { value: "101800", label: "Resonium-A" },
  { value: "105641", label: "resorcinol" },
  { value: "101801", label: "Resource Energy" },
  { value: "101802", label: "Resource Optifibre" },
  { value: "101803", label: "Resource Thickenup" },
  { value: "105642", label: "resperate" },
  { value: "101804", label: "Respifor" },
  { value: "101805", label: "Respontin" },
  { value: "1305", label: "Restandol" },
  { value: "101806", label: "Restandol Testocaps" },
  { value: "105643", label: "Resvestive" },
  { value: "101807", label: "Retacrit" },
  { value: "1306", label: "Retalzem" },
  { value: "101808", label: "Retapamulin" },
  { value: "101809", label: "Reteplase" },
  { value: "105644", label: "retigabine" },
  { value: "101810", label: "Retin-A" },
  { value: "105645", label: "retinol" },
  { value: "105646", label: "retinol (vit A)" },
  { value: "1307", label: "Retrovir" },
  { value: "105647", label: "Retsevmo" },
  { value: "105648", label: "Revasc" },
  { value: "101811", label: "Revatio" },
  { value: "101812", label: "Revaxis" },
  { value: "105649", label: "reviparin" },
  { value: "105650", label: "revive" },
  { value: "1308", label: "Revlimid" },
  { value: "105651", label: "revocon" },
  { value: "101813", label: "Revolade" },
  { value: "1309", label: "Reyataz" },
  { value: "105652", label: "Rezolsta" },
  { value: "105653", label: "rhenium (186Re) etidronic acid" },
  { value: "105654", label: "rhenium (186Re) sulfide colloid" },
  { value: "105655", label: "rheumatac" },
  { value: "1310", label: "Rheumatac retard" },
  { value: "105656", label: "rheumatac retard 75" },
  { value: "105657", label: "rhinocort" },
  { value: "101814", label: "Rhinocort Aqua" },
  { value: "101815", label: "Rhinolast" },
  { value: "101816", label: "Rhophylac" },
  { value: "105658", label: "rhubarb" },
  { value: "101817", label: "Rhubarb Extract" },
  { value: "1311", label: "Rhumalgan" },
  { value: "101818", label: "Riamet" },
  { value: "105659", label: "riastap" },
  { value: "101819", label: "Ribavirin" },
  { value: "105660", label: "ribociclib" },
  { value: "105661", label: "riboflavin" },
  { value: "105662", label: "riboflavin (vit B2)" },
  { value: "105663", label: "ribostamycin" },
  { value: "105664", label: "Rienso" },
  { value: "101820", label: "Rifabutin" },
  { value: "101821", label: "Rifadin" },
  { value: "1312", label: "Rifampicin" },
  { value: "105665", label: "Rifampicin with Isoniazid 150mg/100mg" },
  { value: "105666", label: "Rifampicin with Isoniazid 300mg/150mg" },
  {
    value: "105667",
    label: "Rifampicin/Isoniazid/pyrazinamide 120mg/50mg/300mg",
  },
  { value: "105668", label: "rifamycin" },
  { value: "105669", label: "rifapentine" },
  { value: "1313", label: "Rifater" },
  { value: "105670", label: "rifaximin" },
  { value: "1314", label: "Rifinah" },
  { value: "1315", label: "Rilmenidine" },
  { value: "105671", label: "rilonacept" },
  { value: "105672", label: "rilpivirine" },
  { value: "1316", label: "Rilutek" },
  { value: "1317", label: "Riluzole" },
  { value: "101822", label: "Rimactane" },
  { value: "105673", label: "rimantadine" },
  { value: "105674", label: "Rimapam" },
  { value: "105675", label: "rimazolium" },
  { value: "101823", label: "Rimexolone" },
  { value: "105676", label: "rimiterol" },
  { value: "1318", label: "Rimonabant" },
  { value: "101824", label: "Rinatec" },
  { value: "1319", label: "Rinialer" },
  { value: "105677", label: "Rinvoq" },
  { value: "105678", label: "risankizumab" },
  { value: "105679", label: "Risdiplam" },
  { value: "1320", label: "Risedronate" },
  { value: "105680", label: "risedronic acid" },
  { value: "105681", label: "Risidronate sodium" },
  { value: "1321", label: "Risperdal" },
  { value: "1322", label: "Risperidone" },
  { value: "101825", label: "Ritalin" },
  { value: "105682", label: "ritiometan" },
  { value: "101826", label: "Ritodrine" },
  { value: "1323", label: "Ritonavir" },
  { value: "1324", label: "Rituximab" },
  { value: "101827", label: "Rivaroxaban" },
  { value: "1325", label: "Rivastigmine" },
  { value: "1326", label: "Rivotril" },
  { value: "105683", label: "rixathon" },
  { value: "1327", label: "Rizatriptan" },
  { value: "105684", label: "Rizmoic" },
  { value: "101828", label: "Rizopia" },
  { value: "1328", label: "Roaccutane" },
  { value: "101829", label: "RoActemra" },
  { value: "101830", label: "Robaxin" },
  { value: "101831", label: "Robinul" },
  { value: "1329", label: "Rocaltrol" },
  { value: "101832", label: "Rocephin" },
  { value: "105685", label: "rociverine" },
  { value: "101833", label: "Rocuronium" },
  { value: "105686", label: "rocuronium bromide" },
  { value: "105687", label: "Rodomel" },
  { value: "1330", label: "Rodomel XL" },
  { value: "1331", label: "Rofecoxib" },
  { value: "101834", label: "Roferon-A" },
  { value: "105688", label: "roflumilast" },
  { value: "101835", label: "Rogitine" },
  { value: "105689", label: "rohto" },
  { value: "105690", label: "rohto dry eye relief" },
  { value: "105691", label: "rokitamycin" },
  { value: "105692", label: "rolitetracycline" },
  { value: "105693", label: "romidepsin" },
  { value: "101836", label: "Romiplostim" },
  { value: "105694", label: "romosozumab" },
  { value: "105695", label: "ronifibrate" },
  { value: "1332", label: "Ropinirole" },
  { value: "101837", label: "Ropivacaine" },
  { value: "105696", label: "roquinimex" },
  { value: "105697", label: "Rosaglitazone" },
  { value: "105698", label: "rose bengal sodium" },
  { value: "101838", label: "Rosiced" },
  { value: "1333", label: "Rosiglitazone" },
  { value: "105699", label: "rosoxacin" },
  { value: "1334", label: "Rosuvastatin" },
  { value: "105700", label: "rota virus, live attenuated" },
  { value: "105701", label: "rota virus, pentavalent, live, reassorted" },
  { value: "101839", label: "Rotarix" },
  { value: "101840", label: "Rotavirus vaccine" },
  { value: "1335", label: "Rotigotine" },
  { value: "105702", label: "Rotigotine transdermal patch" },
  { value: "105703", label: "Rovastin" },
  { value: "105704", label: "Roxadustat" },
  { value: "105705", label: "roxatidine" },
  { value: "105706", label: "roxithromycin" },
  { value: "101841", label: "Rozex" },
  { value: "105707", label: "Rozlytrek" },
  { value: "105708", label: "rubella immunoglobulin" },
  { value: "101842", label: "Rubella Virus" },
  {
    value: "105709",
    label: "rubella, combinations with mumps, live attenuated",
  },
  { value: "105710", label: "rubella, live attenuated" },
  { value: "105711", label: "Rubraca" },
  { value: "105712", label: "rucaparib" },
  { value: "105713", label: "ruconest" },
  { value: "101843", label: "Rufinamide" },
  { value: "105714", label: "rufloxacin" },
  { value: "101844", label: "Rupafin" },
  { value: "1336", label: "Rupatadine" },
  { value: "105715", label: "Rusyde" },
  { value: "105716", label: "rutoside" },
  { value: "105717", label: "rutoside, combinations" },
  { value: "105718", label: "ruxolitinib" },
  { value: "105719", label: "Rydapt" },
  { value: "105720", label: "Ryeqo" },
  { value: "1337", label: "Rynacrom" },
  { value: "101845", label: "Rynacrom Spray" },
  { value: "1338", label: "Rythmodan" },
  { value: "101846", label: "Rythmodan retard" },
  { value: "1339", label: "Rythmol" },
  { value: "101847", label: "S.O.S. 10" },
  { value: "105721", label: "Sabervel" },
  { value: "101848", label: "Sabril" },
  { value: "105722", label: "saccharated iron oxide" },
  { value: "105723", label: "saccharomyces boulardii" },
  { value: "105724", label: "sacituzumab govitecan" },
  { value: "105725", label: "sacrosidase" },
  { value: "105726", label: "Sacubitril" },
  { value: "105727", label: "safinamide" },
  { value: "101849", label: "Saflutan" },
  { value: "101850", label: "Saizen" },
  { value: "101851", label: "Salactol" },
  { value: "101852", label: "Salagen" },
  { value: "1340", label: "Salamol" },
  { value: "101853", label: "Salamol Easi-Breathe" },
  { value: "105728", label: "Salapin" },
  { value: "101854", label: "Salatac" },
  { value: "1341", label: "Salazopyrin" },
  { value: "101855", label: "Salazopyrin EN-Tabs" },
  { value: "105729", label: "Salbulair" },
  { value: "105730", label: "salbulin" },
  { value: "101856", label: "Salbulin Novolizer" },
  { value: "1342", label: "Salbutamol" },
  { value: "105731", label: "Salbutamol & ipratropium 2.5mg/500mcg" },
  { value: "105732", label: "Salbutamol & ipratropium 20mcg/100mcg" },
  {
    value: "105733",
    label: "salbutamol and other drugs for obstructive airway diseases",
  },
  { value: "105734", label: "Salbutamol CFC-free" },
  { value: "105735", label: "salicylamide" },
  { value: "105736", label: "salicylamide, combinations excl. psycholeptics" },
  { value: "105737", label: "salicylamide, combinations with psycholeptics" },
  { value: "105738", label: "salicylic" },
  { value: "1343", label: "Salicylic Acid" },
  { value: "105739", label: "saline" },
  { value: "101857", label: "Saline Steri-Neb" },
  { value: "101858", label: "Saline Steripoules" },
  { value: "101859", label: "Salinum" },
  { value: "105740", label: "Salipraneb" },
  { value: "101860", label: "Saliveze" },
  { value: "1344", label: "Salivix" },
  { value: "1345", label: "Salmeterol" },
  {
    value: "105741",
    label: "salmeterol and other drugs for obstructive airway diseases",
  },
  { value: "1346", label: "Salofalk" },
  { value: "105742", label: "salsalate" },
  { value: "105743", label: "samarium (153Sm) hydroxyapatite colloid" },
  { value: "105744", label: "samarium (153Sm) lexidronam" },
  { value: "101861", label: "Samsca" },
  { value: "105745", label: "sanctura" },
  { value: "1347", label: "Sanctura XR" },
  { value: "101862", label: "Sandimmun" },
  { value: "105746", label: "sandimmune" },
  { value: "1348", label: "Sandocal" },
  { value: "101863", label: "Sandocal 400" },
  { value: "1349", label: "Sando-K" },
  { value: "1350", label: "Sandostatin" },
  { value: "1351", label: "Sandrena" },
  { value: "101864", label: "Sanomigran" },
  { value: "105747", label: "sapropterin" },
  { value: "1352", label: "Saquinavir" },
  { value: "105748", label: "Sarclisa" },
  { value: "105749", label: "sargramostim" },
  { value: "105750", label: "sarilumab" },
  { value: "105751", label: "saruplase" },
  { value: "105752", label: "Sastravi" },
  { value: "105753", label: "s-atenolol" },
  { value: "1353", label: "Sativex" },
  { value: "105754", label: "satraplatin" },
  { value: "105755", label: "savene" },
  { value: "1354", label: "Saw Palmetto" },
  { value: "1355", label: "Saxagliptin" },
  { value: "105756", label: "saxagliptin," },
  { value: "105757", label: "saxagliptin, metformin combination" },
  { value: "105758", label: "Scemblix" },
  { value: "101865", label: "Scheriproct" },
  { value: "101866", label: "Scopoderm" },
  { value: "105759", label: "scopolamine" },
  { value: "105760", label: "scopolamine, combinations" },
  { value: "1356", label: "Seatone" },
  { value: "101867", label: "Sebco" },
  { value: "101868", label: "Sebivo" },
  { value: "1357", label: "Secalip" },
  { value: "105761", label: "secnidazole" },
  { value: "105762", label: "secobarbital" },
  { value: "101869", label: "Secobarbital Sodium" },
  { value: "105763", label: "secretin" },
  { value: "1358", label: "Sectral" },
  { value: "105764", label: "secukinumab" },
  { value: "101870", label: "Securon" },
  { value: "101871", label: "Securon I.V." },
  { value: "1359", label: "Securon SR" },
  { value: "105765", label: "seebri" },
  { value: "105766", label: "Seebri Breezhaler" },
  { value: "1360", label: "Seguril" },
  { value: "101872", label: "Select" },
  { value: "1361", label: "Selectol" },
  { value: "1362", label: "Selegiline" },
  { value: "105767", label: "Selegiline Hydrochloride" },
  { value: "105768", label: "Selegiline liquid" },
  { value: "1363", label: "Selenium" },
  { value: "105769", label: "selenium (75Se) norcholesterol" },
  { value: "105770", label: "selenium (75Se) tauroselcholic acid" },
  { value: "105771", label: "selenium compounds" },
  { value: "105772", label: "selenium sulfide" },
  { value: "101873", label: "Selenium sulphide" },
  { value: "101874", label: "Selexid" },
  { value: "105773", label: "seloken" },
  { value: "1364", label: "Seloken XL" },
  { value: "1365", label: "Selo-Zok" },
  { value: "105774", label: "selpercatinib" },
  { value: "101875", label: "Selsun" },
  { value: "105775", label: "semaglutide" },
  { value: "101876", label: "Semi-Daonil" },
  { value: "105776", label: "semustine" },
  { value: "105777", label: "senega" },
  { value: "1366", label: "Senna" },
  { value: "105778", label: "senna glycosides" },
  { value: "105779", label: "senna glycosides, combinations" },
  { value: "105780", label: "senokot" },
  { value: "101877", label: "Senokot Syrup" },
  { value: "101878", label: "Sensi-Care" },
  { value: "1367", label: "Septrin" },
  { value: "1368", label: "Sequacor" },
  { value: "101879", label: "Seractil" },
  { value: "105781", label: "seratrodast" },
  { value: "105782", label: "seravit" },
  { value: "101880", label: "Seravit Paediatric" },
  { value: "1369", label: "Serc" },
  { value: "105783", label: "Sereflo" },
  { value: "1370", label: "Serenace" },
  { value: "105784", label: "serenoa repens" },
  { value: "1371", label: "Seretide" },
  { value: "101881", label: "Seretide Accuhaler" },
  { value: "1372", label: "Serevent" },
  { value: "101882", label: "Serevent Evohaler" },
  { value: "105785", label: "sermorelin" },
  { value: "1373", label: "Seroplex" },
  { value: "101883", label: "Seroquel" },
  { value: "1374", label: "Seroquel XL" },
  { value: "1375", label: "Seroxat" },
  { value: "1376", label: "Serpraline" },
  { value: "105786", label: "sertaconazole" },
  { value: "105787", label: "sertindole" },
  { value: "1377", label: "Sertraline" },
  { value: "105788", label: "Sertraline hydrochloride" },
  { value: "105789", label: "serum gonadotrophin" },
  { value: "105790", label: "setofilm" },
  { value: "1378", label: "Sevelamer" },
  { value: "101884", label: "Sevikar" },
  { value: "105791", label: "Sevikar HCT" },
  { value: "105792", label: "sevoflurane" },
  { value: "1379", label: "Sevredol" },
  { value: "1380", label: "Sibutramine" },
  { value: "105793", label: "signifor" },
  { value: "101885", label: "Siklos" },
  { value: "1381", label: "Sildenafil" },
  { value: "105794", label: "silicones" },
  { value: "101886", label: "Silkis" },
  { value: "105795", label: "silodosin" },
  { value: "105796", label: "siltuximab" },
  { value: "105797", label: "silver" },
  { value: "105798", label: "Silver compounds" },
  { value: "101887", label: "Silver nitrate" },
  { value: "101888", label: "Silver sulfadiazine" },
  { value: "105799", label: "silver sulfadiazine, combinations" },
  { value: "105800", label: "silymarin" },
  { value: "105801", label: "simeprevir" },
  { value: "105802", label: "simfibrate" },
  { value: "105803", label: "similac" },
  { value: "101889", label: "Similac High Energy" },
  { value: "101890", label: "Simple Eye Ointment" },
  { value: "101891", label: "Simple linctus" },
  { value: "105804", label: "Simponi" },
  { value: "101892", label: "Simulect" },
  { value: "1382", label: "Simvador" },
  { value: "1383", label: "Simvastatin" },
  { value: "105805", label: "sincalide" },
  { value: "1384", label: "Sinemet" },
  { value: "101893", label: "Sinepin" },
  { value: "1385", label: "Singulair" },
  { value: "1386", label: "Sinthrome" },
  { value: "1387", label: "Sintrom" },
  { value: "101894", label: "Siopel" },
  { value: "105806", label: "siponimod" },
  { value: "105807", label: "Sirdupla" },
  { value: "1388", label: "Sirolimus" },
  { value: "105808", label: "sisomicin" },
  { value: "105809", label: "sitafloxacin" },
  { value: "1389", label: "Sitagliptin" },
  { value: "105810", label: "sitagliptin," },
  { value: "101896", label: "Sitaxentan" },
  { value: "105811", label: "sitimagene ceradenovec" },
  { value: "101897", label: "Skelid" },
  { value: "105812", label: "Skilarence" },
  { value: "101898", label: "Skinoren" },
  { value: "105813", label: "Skyrizi" },
  { value: "101899", label: "Slo Drinks" },
  { value: "105814", label: "slocinx" },
  { value: "1390", label: "Slocinx XL" },
  { value: "1391", label: "Slo-Phyllin" },
  { value: "105815", label: "Slo-Pro" },
  { value: "1392", label: "Slow-FE" },
  { value: "1393", label: "Slow-K" },
  { value: "101900", label: "Slow-Trasicor" },
  { value: "1394", label: "Slozem" },
  { value: "101901", label: "SMA Gold Prem 2" },
  { value: "101902", label: "SMA High Energy" },
  { value: "101903", label: "SMA LF" },
  { value: "101904", label: "SMA Staydown" },
  { value: "105816", label: "snake venom antiserum" },
  { value: "101905", label: "Sno Tears" },
  { value: "105817", label: "sno-pro" },
  { value: "101906", label: "Sno-Pro Drink" },
  { value: "105818", label: "sobrerol" },
  { value: "105819", label: "sodium" },
  { value: "105820", label: "sodium acetate" },
  { value: "101907", label: "Sodium Acid Citrate" },
  { value: "101908", label: "Sodium Acid Phosphate" },
  { value: "101909", label: "Sodium Alginate" },
  { value: "105821", label: "sodium aminosalicylate" },
  { value: "101910", label: "Sodium Amytal" },
  { value: "105822", label: "sodium apolate" },
  { value: "1395", label: "Sodium Aurothiomalate" },
  { value: "105823", label: "sodium aurotiosulfate" },
  { value: "1396", label: "Sodium Bicarbonate" },
  { value: "105824", label: "sodium borate" },
  { value: "101911", label: "Sodium calcium edetate" },
  { value: "105825", label: "sodium cellulose phosphate" },
  { value: "101912", label: "Sodium Chloride" },
  { value: "105826", label: "sodium chloride, hypertonic" },
  { value: "101913", label: "Sodium citrate" },
  { value: "105827", label: "Sodium citrate (rectal)" },
  { value: "1397", label: "Sodium Clodronate" },
  { value: "1398", label: "Sodium Cromoglicate" },
  { value: "105828", label: "Sodium cromoglycate" },
  { value: "105829", label: "Sodium cromoglycate & salbutamol 100mcg/1mg" },
  { value: "105830", label: "Sodium dihydrogen phosphate" },
  { value: "105831", label: "sodium edetate" },
  { value: "101914", label: "Sodium feredetate" },
  { value: "101915", label: "Sodium fluoride" },
  { value: "105832", label: "sodium fluoride (18F)" },
  { value: "105833", label: "sodium fluoride, combinations" },
  { value: "105834", label: "sodium folinate" },
  { value: "101916", label: "Sodium Fusidate" },
  { value: "105835", label: "sodium glycerophosphate" },
  { value: "101917", label: "Sodium Hyaluronate" },
  { value: "105836", label: "sodium hypochlorite" },
  { value: "105837", label: "sodium iodide (123I)" },
  { value: "105838", label: "sodium iodide (124I)" },
  { value: "105839", label: "sodium iodide (131I)" },
  { value: "105840", label: "sodium iodohippurate (123I)" },
  { value: "105841", label: "sodium iodohippurate (131I)" },
  { value: "105842", label: "sodium iopodate" },
  { value: "105843", label: "sodium iothalamate (125I)" },
  { value: "105844", label: "sodium levofolinate" },
  { value: "105845", label: "sodium monofluorophosphate" },
  { value: "105846", label: "sodium nitrite" },
  { value: "101918", label: "Sodium Nitroprusside" },
  { value: "101919", label: "Sodium oxybate" },
  { value: "105847", label: "sodium perborate" },
  { value: "101920", label: "Sodium phenylbutyrate" },
  { value: "101921", label: "Sodium Phosphate" },
  { value: "105848", label: "sodium phosphate (32P)" },
  { value: "1399", label: "Sodium Picosulfate" },
  { value: "105849", label: "sodium picosulfate, combinations" },
  { value: "105850", label: "Sodium Picosulphate" },
  { value: "105851", label: "sodium propionate" },
  { value: "105852", label: "sodium salicylate" },
  { value: "105853", label: "sodium selenate" },
  { value: "105854", label: "sodium selenite" },
  { value: "105855", label: "sodium stibogluconate" },
  { value: "105856", label: "sodium sulfate" },
  { value: "101922", label: "Sodium Sulphate" },
  { value: "105857", label: "sodium tartrate" },
  { value: "105858", label: "sodium tetradecyl sulfate" },
  { value: "101923", label: "Sodium tetradecyl sulphate" },
  { value: "1400", label: "Sodium Valproate" },
  { value: "105859", label: "sodium zirconium cyclosilicate" },
  { value: "105860", label: "sofosbuvir" },
  { value: "101924", label: "Sofradex" },
  { value: "101925", label: "Solaraze" },
  { value: "101926", label: "Solian" },
  { value: "1401", label: "Solifenacin" },
  { value: "101927", label: "Soliris" },
  { value: "1402", label: "Solostar" },
  { value: "1403", label: "Solpadol" },
  { value: "105861", label: "Solriamfetol" },
  { value: "101928", label: "Soltamox" },
  { value: "105862", label: "soltel" },
  { value: "101931", label: "Soluble Insulin" },
  { value: "101929", label: "Solu-Cortef" },
  { value: "101930", label: "Solu-Medrone" },
  { value: "105863", label: "solvadi" },
  { value: "101932", label: "Solvazinc" },
  { value: "1404", label: "Somac" },
  { value: "101933", label: "SomaCorrect" },
  { value: "101934", label: "SomaErect" },
  { value: "105864", label: "somatorelin" },
  { value: "105865", label: "somatostatin" },
  { value: "105866", label: "somatrem" },
  { value: "1405", label: "Somatropin" },
  { value: "105867", label: "Somatuline" },
  { value: "101935", label: "Somatuline Autogel" },
  { value: "101936", label: "Somavert" },
  { value: "101937", label: "Sonata" },
  { value: "105868", label: "sondate" },
  { value: "105869", label: "sondate xl" },
  { value: "101938", label: "Soneryl" },
  { value: "105870", label: "Soprobec" },
  { value: "101939", label: "Sorafenib" },
  { value: "105871", label: "sorbitol" },
  { value: "1406", label: "Sortis" },
  { value: "101940", label: "Sotacor" },
  { value: "105872", label: "sotagliflozin" },
  { value: "1407", label: "Sotalex" },
  { value: "1408", label: "Sotalol" },
  { value: "105873", label: "sotalol, combinations" },
  { value: "105874", label: "Sotorasib" },
  { value: "105875", label: "Sovaldi" },
  { value: "101941", label: "Soya Oil" },
  { value: "105876", label: "spaglumic acid" },
  { value: "105877", label: "sparfloxacin" },
  { value: "105878", label: "Spartalizumab" },
  { value: "105879", label: "sparteine" },
  { value: "1409", label: "Spasmonal" },
  { value: "101942", label: "Spasmonal Forte" },
  { value: "105880", label: "spectinomycin" },
  { value: "105881", label: "spectraban" },
  { value: "101943", label: "Spectraban Ultra" },
  { value: "105882", label: "Spinraza" },
  { value: "105883", label: "spiramycin" },
  {
    value: "105884",
    label: "spiramycin, combinations with other antibacterials",
  },
  { value: "105885", label: "spirapril" },
  { value: "1410", label: "Spiriva" },
  { value: "105886", label: "Spiroco" },
  { value: "105887", label: "Spiroco XL" },
  { value: "105888", label: "Spironol/Frusemide" },
  { value: "1411", label: "Spironolactone" },
  { value: "1412", label: "Sporanox" },
  { value: "101944", label: "Sporanox Pulse" },
  { value: "101945", label: "Sprilon" },
  { value: "1413", label: "Sprycel" },
  { value: "101946", label: "SST" },
  { value: "1414", label: "Stablon" },
  { value: "1415", label: "Stagid" },
  { value: "1416", label: "Stalevo" },
  { value: "101947", label: "Stamaril" },
  { value: "105889", label: "Stanek" },
  { value: "105890", label: "stannous fluoride" },
  { value: "105891", label: "stanozolol" },
  { value: "105892", label: "staphylococcus immunoglobulin" },
  { value: "1417", label: "Staril" },
  { value: "101948", label: "Starlix" },
  { value: "105893", label: "Statin" },
  { value: "105894", label: "statins" },
  { value: "101949", label: "Stavudine" },
  { value: "105895", label: "Stefluvin XL" },
  { value: "105896", label: "Steglatro" },
  { value: "101950", label: "Stelara" },
  { value: "1418", label: "Stelazine" },
  { value: "105897", label: "stem cells from umbilical cord blood" },
  { value: "1419", label: "Stemetil" },
  { value: "105898", label: "stepronin" },
  { value: "101952", label: "Sterculia" },
  { value: "105899", label: "Sterculia & Frangula 62%/8%" },
  { value: "105900", label: "sterculia, combinations" },
  { value: "105901", label: "Sterculia/Alverine Granules 62%/0.5%*" },
  { value: "105902", label: "sterets" },
  { value: "101953", label: "Sterets Aquasol" },
  { value: "101954", label: "Stericlens" },
  { value: "101955", label: "Sterimar" },
  { value: "101956", label: "Steripod" },
  { value: "105903", label: "ster-zac" },
  { value: "101951", label: "Ster-Zac Bath Conc." },
  { value: "101957", label: "Stesolid" },
  { value: "105904", label: "stibophen" },
  { value: "101958", label: "Stiemycin" },
  { value: "1420", label: "Stilboestrol" },
  { value: "101959", label: "Stilnoct" },
  { value: "1421", label: "Stilnox" },
  { value: "105905", label: "stiripentol" },
  { value: "105906", label: "Stivarga" },
  { value: "105907", label: "Storwin" },
  { value: "105908", label: "stramoni preparations" },
  { value: "1422", label: "Strattera" },
  { value: "101960", label: "Strefen" },
  { value: "101961", label: "Streptase" },
  { value: "105909", label: "streptoduocin" },
  { value: "101962", label: "Streptokinase" },
  { value: "105910", label: "streptokinase, combinations" },
  { value: "105911", label: "streptomycin" },
  { value: "105912", label: "streptomycin, combinations" },
  { value: "105913", label: "streptozocin" },
  { value: "105914", label: "Stribild" },
  { value: "105915", label: "Striverdi" },
  { value: "105916", label: "Striverdi Respimat" },
  { value: "105917", label: "stronazon" },
  { value: "1423", label: "Stronazon MR" },
  { value: "105918", label: "strontium" },
  { value: "105919", label: "strontium (89Sr) chloride" },
  { value: "1424", label: "Strontium Ranelate" },
  { value: "1425", label: "Stugeron" },
  { value: "105920", label: "styramate" },
  { value: "101963", label: "Styrax" },
  { value: "101964", label: "Subcuvia" },
  { value: "101965", label: "Subgam" },
  { value: "101966", label: "Sublimaze" },
  { value: "101967", label: "Suboxone" },
  { value: "101968", label: "Subutex" },
  { value: "105921", label: "succinimide" },
  { value: "105922", label: "succinylsulfathiazole" },
  { value: "1426", label: "Sucralfate" },
  { value: "105923", label: "sucrose" },
  { value: "101969", label: "Sudafed" },
  { value: "105924", label: "sudafed decongestant" },
  { value: "101970", label: "Sudocrem" },
  { value: "105925", label: "sufentanil" },
  { value: "101971", label: "Sugammadex" },
  { value: "105926", label: "Sukkarto" },
  { value: "105927", label: "Sular" },
  { value: "105928", label: "Sulazine" },
  { value: "105929", label: "sulbactam" },
  { value: "105930", label: "sulbenicillin" },
  { value: "105931", label: "sulbentine" },
  { value: "105932", label: "sulbutiamine" },
  { value: "105933", label: "sulconazole" },
  { value: "105934", label: "sulfacetamide" },
  { value: "105935", label: "sulfadiazine" },
  { value: "105936", label: "sulfadiazine and tetroxoprim" },
  { value: "105937", label: "sulfadicramide" },
  { value: "105938", label: "sulfadimethoxine" },
  { value: "105939", label: "sulfadimidine" },
  { value: "105940", label: "sulfafenazol" },
  { value: "105941", label: "sulfafurazole" },
  { value: "105942", label: "sulfaguanidine" },
  { value: "105943", label: "sulfaisodimidine" },
  { value: "105944", label: "sulfalene" },
  { value: "105945", label: "sulfamazone" },
  { value: "105946", label: "sulfamerazine" },
  { value: "105947", label: "sulfamethizole" },
  { value: "101972", label: "Sulfamethoxazole" },
  { value: "105948", label: "sulfamethoxypyridazine" },
  { value: "105949", label: "sulfametomidine" },
  { value: "105950", label: "Sulfametopyrazine" },
  { value: "105951", label: "sulfametoxydiazine" },
  { value: "105952", label: "sulfametrole and trimethoprim" },
  { value: "105953", label: "sulfamoxole" },
  { value: "105954", label: "sulfanilamide" },
  { value: "105955", label: "sulfaperin" },
  { value: "105956", label: "sulfaphenazole" },
  { value: "105957", label: "sulfapyridine" },
  { value: "1427", label: "Sulfasalazine" },
  { value: "105958", label: "sulfathiazole" },
  { value: "105959", label: "sulfathiourea" },
  { value: "105960", label: "sulfatolamide" },
  { value: "101973", label: "Sulfinpyrazone" },
  { value: "105961", label: "sulfobromophthalein" },
  {
    value: "105962",
    label:
      "sulfonamides, combinations with other antibacterials (excl. trimethoprim)",
  },
  { value: "105963", label: "sulfur" },
  { value: "105964", label: "sulfur compounds" },
  { value: "105965", label: "sulfur hexafluoride" },
  { value: "105966", label: "sulglicotide" },
  { value: "1428", label: "Sulindac" },
  { value: "105967", label: "suloctidil" },
  { value: "105968", label: "sulodexide" },
  { value: "105969", label: "Sulphasalazine" },
  { value: "101974", label: "Sulphur" },
  { value: "1429", label: "Sulpiride" },
  { value: "1430", label: "Sulpor" },
  { value: "105970", label: "sulprostone" },
  { value: "105971", label: "sultamicillin" },
  { value: "105972", label: "sultiame" },
  { value: "105973", label: "sultopride" },
  { value: "1431", label: "Sumatriptan" },
  { value: "1432", label: "Sunitanib" },
  { value: "101975", label: "Sunitinib" },
  { value: "101976", label: "Sunnyvale" },
  { value: "105974", label: "Sunosi" },
  { value: "105975", label: "sunsense" },
  { value: "101977", label: "Sunsense Ultra SPF 50+" },
  { value: "101978", label: "Suplasyn" },
  { value: "101979", label: "Suplena" },
  { value: "105976", label: "supportan" },
  { value: "101980", label: "Supportan Drink" },
  { value: "1433", label: "Supralip" },
  { value: "101981", label: "Suprax" },
  { value: "101982", label: "Suprecur" },
  { value: "101983", label: "Suprefact" },
  { value: "105977", label: "suprofen" },
  { value: "105978", label: "suramin sodium" },
  { value: "101984", label: "SureEase" },
  { value: "101985", label: "Surgam" },
  { value: "1434", label: "Surmontil" },
  { value: "101986", label: "Survanta" },
  { value: "105979", label: "survimed" },
  { value: "101987", label: "Survimed OPD" },
  { value: "101988", label: "Suscard" },
  { value: "101989", label: "Suscard Buccal" },
  { value: "101990", label: "Sustac" },
  { value: "1435", label: "Sustanon" },
  { value: "101991", label: "Sustanon 100" },
  { value: "1436", label: "Sustiva" },
  { value: "1437", label: "Sutent" },
  { value: "105980", label: "sutherland" },
  { value: "101992", label: "Sutherland Jelly" },
  { value: "101993", label: "Suxamethonium" },
  { value: "105981", label: "suxibuzone" },
  { value: "105982", label: "Sycrest" },
  { value: "101994", label: "Sylk" },
  { value: "105983", label: "sylvant" },
  { value: "1438", label: "Symbicort" },
  { value: "101995", label: "Symbicort 100/6 Turbohaler" },
  { value: "105984", label: "symbicort turbohaler" },
  { value: "1439", label: "Symmetrel" },
  { value: "105985", label: "synacthen" },
  { value: "101996", label: "Synacthen Depot" },
  { value: "101997", label: "Synagis" },
  { value: "101998", label: "Synalar" },
  { value: "101999", label: "Synalar 1 in 4" },
  { value: "102000", label: "Synalar Cream 1 in 10" },
  { value: "102001", label: "Synarel" },
  { value: "102002", label: "Syner-KINASE" },
  { value: "102003", label: "Synflex" },
  { value: "102004", label: "Synflorix" },
  { value: "102005", label: "Synocrom" },
  { value: "102006", label: "Synopsis" },
  { value: "1440", label: "Syntaris" },
  { value: "1441", label: "Synthyroid" },
  { value: "102007", label: "Syntocinon" },
  { value: "102008", label: "Syntometrine" },
  { value: "102009", label: "Synvisc" },
  { value: "105986", label: "syonell" },
  { value: "102010", label: "Syprol" },
  { value: "105987", label: "syrosingopine and diuretics" },
  { value: "105988", label: "syscor" },
  { value: "102011", label: "Syscor MR" },
  { value: "102012", label: "Systane" },
  { value: "102013", label: "Sytron" },
  { value: "105989", label: "tabphyn" },
  { value: "1442", label: "Tabphyn MR" },
  { value: "102014", label: "Tacalcitol" },
  { value: "105990", label: "Tacni" },
  { value: "105991", label: "tacrine" },
  { value: "1443", label: "Tacrolimus" },
  { value: "1444", label: "Tadalafil" },
  { value: "105992", label: "TAF" },
  { value: "105993", label: "tafamidis" },
  { value: "105994", label: "Tafinlar" },
  { value: "102015", label: "Tafluprost" },
  { value: "1445", label: "Tagamet" },
  { value: "105995", label: "Tagrisso" },
  { value: "1446", label: "Tahor" },
  { value: "105996", label: "Takhzyro" },
  { value: "105997", label: "talampicillin" },
  { value: "105998", label: "talastine" },
  { value: "105999", label: "talbutal" },
  { value: "106000", label: "taliglucerase alfa" },
  { value: "106001", label: "talimogene" },
  { value: "106002", label: "talimogene laherparepvec" },
  { value: "106003", label: "talinolol" },
  { value: "106004", label: "Taltz" },
  { value: "1447", label: "Tambocor" },
  { value: "1448", label: "Tamiflu" },
  { value: "1449", label: "Tamoxifen" },
  { value: "1450", label: "Tamsulosin" },
  { value: "102016", label: "Tamsulosin Hydrochloride" },
  { value: "1451", label: "Tamurex" },
  { value: "1452", label: "Tanatril" },
  { value: "102017", label: "Tantril" },
  { value: "106005", label: "Tapazole" },
  { value: "106006", label: "Tapclob" },
  { value: "106007", label: "tapentadol" },
  { value: "102018", label: "Tar" },
  { value: "102019", label: "Taranis" },
  { value: "1453", label: "Tarceva" },
  { value: "106008", label: "Tardisc" },
  { value: "106009", label: "Tardisc XL" },
  { value: "1454", label: "Tareg" },
  { value: "102020", label: "Targinact" },
  { value: "102021", label: "Targocid" },
  { value: "102022", label: "Targretin" },
  { value: "106010", label: "Targrisso" },
  { value: "102023", label: "Tarivid" },
  { value: "102024", label: "Tarka" },
  { value: "102025", label: "Tasigna" },
  { value: "102026", label: "Tasmar" },
  { value: "106011", label: "tasonermin" },
  { value: "106012", label: "tasosartan" },
  { value: "106013", label: "taurolidine" },
  { value: "102027", label: "Tavanic" },
  { value: "102028", label: "Tavegil" },
  { value: "106014", label: "Tavlesse" },
  { value: "106015", label: "Tavneos" },
  { value: "106016", label: "taxceus" },
  { value: "1455", label: "Taxol" },
  { value: "1456", label: "Taxotere" },
  { value: "102029", label: "Tazarotene" },
  { value: "102030", label: "Tazobactam" },
  { value: "102031", label: "Tazocin" },
  { value: "102032", label: "Tears Naturale" },
  { value: "1457", label: "Tebetane" },
  { value: "106017", label: "Tecentriq" },
  { value: "106018", label: "Tecfidera" },
  {
    value: "106019",
    label: "technetium (99mTc) antiCarcinoEmbryonicAntigen antibody",
  },
  { value: "106020", label: "technetium (99mTc) antigranulocyte antibody" },
  { value: "106021", label: "technetium (99mTc) antimelanoma antibody" },
  { value: "106022", label: "technetium (99mTc) apcitide" },
  { value: "106023", label: "technetium (99mTc) arcitumomab" },
  { value: "106024", label: "technetium (99mTc) bicisate" },
  { value: "106025", label: "technetium (99mTc) butedronic acid" },
  { value: "106026", label: "technetium (99mTc) depreotide" },
  { value: "106027", label: "technetium (99mTc) disofenin" },
  { value: "106028", label: "technetium (99mTc) etifenin" },
  { value: "106029", label: "technetium (99mTc) exametazime" },
  { value: "106030", label: "technetium (99mTc) exametazime labelled cells" },
  { value: "106031", label: "technetium (99mTc) furifosmin" },
  { value: "106032", label: "technetium (99mTc) galtifenin" },
  { value: "106033", label: "technetium (99mTc) gluceptate" },
  { value: "106034", label: "technetium (99mTc) gluconate" },
  { value: "106035", label: "technetium (99mTc) human albumin" },
  { value: "106036", label: "technetium (99mTc) human immunoglobulin" },
  { value: "106037", label: "technetium (99mTc) hynic-octreotide" },
  { value: "106038", label: "technetium (99mTc) lidofenin" },
  { value: "106039", label: "technetium (99mTc) macrosalb" },
  { value: "106040", label: "technetium (99mTc) mebrofenin" },
  { value: "106041", label: "technetium (99mTc) medronic acid" },
  { value: "106042", label: "technetium (99mTc) mertiatide" },
  { value: "106043", label: "technetium (99mTc) microcolloid" },
  { value: "106044", label: "technetium (99mTc) microspheres" },
  { value: "106045", label: "technetium (99mTc) millimicrospheres" },
  { value: "106046", label: "technetium (99mTc) nanocolloid" },
  { value: "106047", label: "technetium (99mTc) oxidronic acid" },
  { value: "106048", label: "technetium (99mTc) pentavalent succimer" },
  { value: "106049", label: "technetium (99mTc) pentetic acid" },
  { value: "106050", label: "technetium (99mTc) pertechnetate" },
  { value: "106051", label: "technetium (99mTc) phytate" },
  { value: "106052", label: "technetium (99mTc) pyrophosphate" },
  { value: "106053", label: "technetium (99mTc) rheniumsulfide colloid" },
  { value: "106054", label: "technetium (99mTc) sestamibi" },
  {
    value: "106055",
    label: "technetium (99mTc) stannous agent labelled cells",
  },
  { value: "106056", label: "technetium (99mTc) succimer" },
  { value: "106057", label: "technetium (99mTc) sulesomab" },
  { value: "106058", label: "technetium (99mTc) sulfur colloid" },
  { value: "106059", label: "technetium (99mTc) teboroxime" },
  { value: "106060", label: "technetium (99mTc) technegas" },
  { value: "106061", label: "technetium (99mTc) tetrofosmin" },
  { value: "106062", label: "technetium (99mTc) tin colloid" },
  { value: "106063", label: "technetium (99mTc) votumumab" },
  { value: "106064", label: "teclozan" },
  { value: "106065", label: "tedisamil" },
  { value: "106066", label: "Teduglutide" },
  { value: "102033", label: "Tegafur" },
  { value: "106067", label: "tegafur, combinations" },
  { value: "106068", label: "tegaserod" },
  { value: "1458", label: "Tegretol" },
  { value: "102034", label: "Teicoplanin" },
  { value: "106069", label: "telaprevir" },
  { value: "106070", label: "telavancin" },
  { value: "102035", label: "Telbivudine" },
  { value: "1459", label: "Telfast" },
  { value: "102036", label: "Telithromycin" },
  { value: "1460", label: "Telmisartan" },
  { value: "102037", label: "Telzir" },
  { value: "106071", label: "temafloxacin" },
  { value: "1461", label: "Temazepam" },
  { value: "1462", label: "Temerit" },
  { value: "1463", label: "Temgesic" },
  { value: "106072", label: "temocapril" },
  { value: "106073", label: "temocillin" },
  { value: "1464", label: "Temodal" },
  { value: "102038", label: "Temoporfin" },
  { value: "106074", label: "Temozolamide" },
  { value: "1465", label: "Temozolomide" },
  { value: "102039", label: "Temsirolimus" },
  { value: "102040", label: "Tenecteplase" },
  { value: "106075", label: "tenidap" },
  { value: "1466", label: "Tenif" },
  { value: "106076", label: "teniposide" },
  { value: "106077", label: "tenitramine" },
  { value: "1467", label: "Tenofovir" },
  { value: "106078", label: "Tenofovir Alafenamide Fumarate" },
  { value: "106079", label: "tenofovir disoproxil" },
  { value: "106080", label: "Tenofovir Disproxil" },
  { value: "106081", label: "tenonitrozole" },
  { value: "1468", label: "Tenoret" },
  { value: "102041", label: "Tenoret 50" },
  { value: "102042", label: "Tenoretic" },
  { value: "1469", label: "Tenormin" },
  { value: "102043", label: "Tenoxicam" },
  { value: "106082", label: "tenprolide" },
  { value: "106083", label: "Tenprolide XL" },
  { value: "1470", label: "Tensaid" },
  { value: "106084", label: "Tensaid XL" },
  { value: "1471", label: "Tensionorme" },
  { value: "106085", label: "Tensipine" },
  { value: "102044", label: "Tensipine MR" },
  { value: "106086", label: "Tensium" },
  { value: "102045", label: "Tentrini" },
  { value: "102046", label: "Teoptic" },
  { value: "106087", label: "tepadina" },
  { value: "106088", label: "Tepmetko" },
  { value: "106089", label: "Tepotinib" },
  { value: "1472", label: "Terazosin" },
  { value: "106090", label: "Terazosin HCI" },
  { value: "1473", label: "Terbinafine" },
  { value: "1474", label: "Terbutaline" },
  { value: "106091", label: "terbutaline, combinations" },
  { value: "106092", label: "terconazole" },
  { value: "106093", label: "terfenadine" },
  { value: "106094", label: "terguride" },
  { value: "106095", label: "Teriflunomide" },
  { value: "102047", label: "Teriparatide" },
  { value: "106096", label: "terizidone" },
  { value: "1475", label: "Terlipressin" },
  { value: "1476", label: "Ternozolamide" },
  { value: "106097", label: "terodiline" },
  { value: "106098", label: "teromeg" },
  { value: "106099", label: "tertatolol" },
  { value: "1477", label: "Tertroxin" },
  { value: "1478", label: "Terutroban" },
  { value: "1479", label: "Tesavel" },
  { value: "102048", label: "Testim" },
  { value: "1480", label: "Testogel" },
  { value: "102049", label: "Testosterone" },
  { value: "106100", label: "tetanus antitoxin" },
  { value: "106101", label: "tetanus immunoglobulin" },
  { value: "106102", label: "tetanus toxoid" },
  {
    value: "106103",
    label: "tetanus toxoid, combinations with diphtheria toxoid",
  },
  {
    value: "106104",
    label: "tetanus toxoid, combinations with tetanus immunoglobulin",
  },
  { value: "106105", label: "Tetmodis" },
  { value: "102050", label: "Tetrabenazine" },
  { value: "102051", label: "Tetracaine" },
  { value: "102052", label: "Tetracosactide" },
  { value: "1481", label: "Tetracycline" },
  { value: "106106", label: "Tetracycline combined preparations" },
  { value: "106107", label: "tetragalacturonic acid hydroxymethylester" },
  { value: "106108", label: "tetrahydrofurfuryl" },
  { value: "102053", label: "Tetrahydrofurfuryl Salicylate" },
  { value: "102054", label: "Tetralysal" },
  { value: "106109", label: "tetramethrin" },
  { value: "106110", label: "tetrazepam" },
  { value: "106111", label: "tetryzoline" },
  { value: "106112", label: "tetryzoline, combinations" },
  { value: "102055", label: "Tevagrastim" },
  { value: "1482", label: "Teveten" },
  { value: "106113", label: "textiles" },
  { value: "106114", label: "Teysuno" },
  { value: "1483", label: "Thalidomide" },
  { value: "102056", label: "Thalidomide Celgene" },
  { value: "106115", label: "thallium (201Tl) chloride" },
  { value: "106116", label: "thebacon" },
  { value: "102057", label: "Thelin" },
  { value: "106117", label: "thenalidine" },
  { value: "106118", label: "thenalidine, combinations" },
  { value: "106119", label: "theobromine" },
  { value: "106120", label: "theobromine, combinations" },
  { value: "106121", label: "theodrenaline" },
  { value: "1484", label: "Theophylline" },
  { value: "106122", label: "theophylline and adrenergics" },
  { value: "106123", label: "theophylline, combinations excl. psycholeptics" },
  { value: "106124", label: "theophylline, combinations with psycholeptics" },
  { value: "106125", label: "thiamazole" },
  { value: "106126", label: "thiamazole, combinations" },
  { value: "106127", label: "thiamine" },
  { value: "106128", label: "thiamine (vit B1)" },
  { value: "1485", label: "Thiamine Hydrochloride" },
  { value: "106129", label: "thiamphenicol" },
  { value: "106130", label: "thiamphenicol, combinations" },
  { value: "106131", label: "thiazinam" },
  { value: "102058", label: "Thick And Easy" },
  { value: "106132", label: "thiethylperazine" },
  { value: "106133", label: "thioacetazone and isoniazid" },
  { value: "106134", label: "thiocolchicoside" },
  { value: "106135", label: "thioctic acid" },
  { value: "106136", label: "thiomersal" },
  { value: "106137", label: "thiopental" },
  { value: "106138", label: "thiopropazate" },
  { value: "106139", label: "thioproperazine" },
  { value: "106140", label: "thioridazine" },
  { value: "106141", label: "thiosulfate" },
  { value: "106142", label: "thiotepa" },
  { value: "106143", label: "Thiothixene" },
  { value: "106144", label: "thiram" },
  { value: "106145", label: "thixo-d" },
  { value: "102059", label: "Thixo-D Original" },
  { value: "106146", label: "thonzylamine" },
  { value: "106147", label: "Thorazine" },
  { value: "106148", label: "thrombin" },
  { value: "106149", label: "thrombocytes" },
  { value: "102060", label: "Thymoglobuline" },
  { value: "106150", label: "thymopentin" },
  { value: "106151", label: "thyroid gland preparations" },
  { value: "106152", label: "Thyrotropin" },
  { value: "1486", label: "Thyroxine" },
  { value: "106153", label: "tiabendazole" },
  { value: "106154", label: "tiadenol" },
  { value: "102061", label: "Tiagabine" },
  { value: "1487", label: "Tianeptine" },
  { value: "106155", label: "tiapride" },
  { value: "106156", label: "tiaprofenic" },
  { value: "102062", label: "Tiaprofenic acid" },
  { value: "1488", label: "Tiazac" },
  { value: "106157", label: "tiazofurine" },
  { value: "106158", label: "tibezonium iodide" },
  { value: "1489", label: "Tibolone" },
  { value: "106159", label: "ticagrelor" },
  { value: "102063", label: "Ticarcillin" },
  { value: "106160", label: "ticarcillin and enzyme inhibitor" },
  { value: "102064", label: "Tick-borne encephalitis vaccine" },
  { value: "106161", label: "ticlatone" },
  { value: "1490", label: "Ticlopidine" },
  { value: "102065", label: "TicoVac" },
  { value: "106162", label: "tidiacic arginine" },
  { value: "106163", label: "tiemonium iodide" },
  { value: "106164", label: "tiemonium iodide and analgesics" },
  { value: "106165", label: "tienilic acid" },
  { value: "106166", label: "Tifaxin" },
  { value: "106167", label: "Tifaxin XL" },
  { value: "102066", label: "Tigecycline" },
  { value: "106168", label: "tilactase" },
  { value: "1491", label: "Tilade" },
  { value: "106169", label: "tilbroquinol" },
  { value: "1492", label: "Tildiem" },
  { value: "102067", label: "Tildiem LA" },
  { value: "102068", label: "Tildiem Retard" },
  { value: "106170", label: "tildrakizumab" },
  { value: "106171", label: "tilidine" },
  { value: "102069", label: "Tiloryth" },
  { value: "102070", label: "Tiludronate" },
  { value: "106172", label: "tiludronic acid" },
  { value: "102071", label: "Timentin" },
  { value: "106173", label: "timepidium bromide" },
  { value: "102072", label: "Timodine" },
  { value: "1493", label: "Timolol" },
  { value: "106174", label: "timolol and thiazides" },
  { value: "102073", label: "Timolol Maleate" },
  { value: "106175", label: "Timolol with bendrofluazide 10mg/2.5mg" },
  { value: "106176", label: "Timolol with co-amilozide 10mg/(2.5mg/25mg)" },
  { value: "106177", label: "timolol, combinations" },
  { value: "106178", label: "timolol, thiazides and other diuretics" },
  { value: "1494", label: "Timoptol" },
  { value: "102074", label: "Timoptol-LA" },
  { value: "102075", label: "Tinidazole" },
  { value: "1495", label: "Tinzaparin" },
  { value: "106179", label: "tiocarlide" },
  { value: "106180", label: "tioclomarol" },
  { value: "102076", label: "Tioconazole" },
  { value: "106181", label: "Tiofex" },
  { value: "102077", label: "Tioguanine" },
  { value: "106182", label: "tiopronin" },
  { value: "106183", label: "Tioptropium" },
  { value: "106184", label: "tiotixene" },
  { value: "1496", label: "Tiotropium" },
  { value: "106185", label: "tiotropium bromide" },
  { value: "106186", label: "tioxolone" },
  { value: "106187", label: "tipepidine" },
  { value: "102078", label: "Tipranavir" },
  { value: "106188", label: "tiracizine" },
  { value: "106189", label: "tiratricol" },
  { value: "106190", label: "tirilazad" },
  { value: "102079", label: "Tirofiban" },
  { value: "106191", label: "tiropramide" },
  { value: "106192", label: "tisagenlecleucel" },
  { value: "102080", label: "Tisept" },
  { value: "106193", label: "tisopurine" },
  { value: "106194", label: "Tivicay" },
  { value: "106195", label: "tivozanib" },
  { value: "106196", label: "tixocortol" },
  { value: "106197", label: "tixocortol, combinations" },
  { value: "1497", label: "Tizanidine" },
  { value: "102081", label: "TOBI" },
  { value: "106198", label: "tobia" },
  { value: "102082", label: "Tobia Teff Flour" },
  { value: "102083", label: "Tobradex" },
  { value: "102084", label: "Tobramycin" },
  { value: "106199", label: "tocainide" },
  { value: "102085", label: "Tocilizumab" },
  { value: "106200", label: "tocofersolan" },
  { value: "106201", label: "tocopherol (vit E)" },
  { value: "102086", label: "Toctino" },
  { value: "106202", label: "tofacitinib" },
  { value: "106203", label: "tofisopam" },
  { value: "106204", label: "tolazamide" },
  { value: "106205", label: "tolazoline" },
  { value: "1498", label: "Tolbutamide" },
  { value: "102087", label: "Tolcapone" },
  { value: "106206", label: "tolciclate" },
  { value: "106207", label: "tolfenamic" },
  { value: "102088", label: "Tolfenamic acid" },
  { value: "106208", label: "tolmetin" },
  { value: "106209", label: "tolnaftate" },
  { value: "106210", label: "tolonidine" },
  { value: "106211", label: "toloxatone" },
  { value: "106212", label: "tolperisone" },
  { value: "106213", label: "tolpropamine" },
  { value: "106214", label: "tolrestat" },
  { value: "1499", label: "Tolterodine" },
  { value: "102089", label: "Tolvaptan" },
  { value: "102090", label: "Tomudex" },
  { value: "102091", label: "Topal" },
  { value: "1500", label: "Topamax" },
  { value: "1501", label: "Topiramate" },
  { value: "1502", label: "Topotecan" },
  { value: "106215", label: "toprol" },
  { value: "1503", label: "Toprol XL" },
  { value: "102092", label: "Toradol" },
  { value: "1504", label: "Torasemide" },
  { value: "1505", label: "Torcetrapib" },
  { value: "102093", label: "Torem" },
  { value: "102094", label: "Toremifene" },
  { value: "102095", label: "Torisel" },
  { value: "106216", label: "Torsemide" },
  { value: "1506", label: "Torvastin" },
  { value: "106217", label: "tositumomab/iodine (131I) tositumomab" },
  { value: "102096", label: "Tostran" },
  { value: "106218", label: "tosylchloramide sodium" },
  { value: "106219", label: "Toujeo" },
  { value: "1507", label: "Toviaz" },
  { value: "102097", label: "Trabectedin" },
  { value: "102098", label: "Tracleer" },
  { value: "102099", label: "Tracrium" },
  { value: "102100", label: "Tractocile" },
  { value: "106220", label: "tradorec" },
  { value: "102101", label: "Tradorec XL" },
  { value: "106221", label: "Trajenta" },
  { value: "106222", label: "Tralokinumab" },
  { value: "1508", label: "Tramacet" },
  { value: "1509", label: "Tramadol" },
  { value: "106223", label: "tramadol, combinations" },
  { value: "106224", label: "tramazoline" },
  { value: "106225", label: "trametinib" },
  { value: "106226", label: "Trandate" },
  { value: "1510", label: "Trandolapril" },
  { value: "106227", label: "Trandolapril with verapamil 2/180mg" },
  { value: "106228", label: "tranexamic" },
  { value: "1511", label: "Tranexamic acid" },
  { value: "106229", label: "trangina" },
  { value: "106230", label: "trangina xl" },
  { value: "102102", label: "Transiderm-Nitro" },
  { value: "1512", label: "Transtec" },
  { value: "102103", label: "Transvasin" },
  { value: "1513", label: "Tranylcypromine" },
  { value: "106231", label: "trapidil" },
  { value: "1514", label: "Trasicor" },
  { value: "102104", label: "Trasidrex" },
  { value: "1515", label: "Trastuzumab" },
  { value: "106232", label: "trastuzumab deruxtecan" },
  { value: "106233", label: "trastuzumab emtansine" },
  { value: "106234", label: "travasept" },
  { value: "102105", label: "Travasept 100" },
  { value: "1516", label: "Travatan" },
  { value: "1517", label: "Travoprost" },
  { value: "102106", label: "Traxam" },
  { value: "1518", label: "Trazodone" },
  { value: "106235", label: "Trazodone Hydrochloride" },
  { value: "106236", label: "Treanda" },
  { value: "102107", label: "TREATMENT" },
  { value: "106237", label: "Trecondi" },
  { value: "102108", label: "Tredaptive" },
  { value: "106238", label: "tree pollen" },
  { value: "106239", label: "Tremfya" },
  { value: "102109", label: "Trental" },
  { value: "106240", label: "treosulfan" },
  { value: "106241", label: "trepibutone" },
  { value: "106242", label: "treprostinil" },
  { value: "106243", label: "Tresiba" },
  { value: "102110", label: "Tretinoin" },
  { value: "106244", label: "tretinoin, combinations" },
  { value: "106245", label: "tretoquinol" },
  { value: "1519", label: "Triamcinolone" },
  { value: "106246", label: "triamcinolone and antibiotics" },
  { value: "106247", label: "triamcinolone and antiinfectives" },
  { value: "106248", label: "triamcinolone and antiseptics" },
  { value: "1520", label: "Triamterene" },
  { value: "106249", label: "Triamterene/Chlorthalidone" },
  { value: "106250", label: "Triapin" },
  { value: "1521", label: "Triatec" },
  { value: "106251", label: "triaziquone" },
  { value: "106252", label: "triazolam" },
  { value: "106253", label: "tribenoside" },
  { value: "106254", label: "tribromometacresol" },
  { value: "106255", label: "trichlormethiazide" },
  { value: "106256", label: "trichlormethiazide and potassium-sparing agents" },
  { value: "106257", label: "trichloroethylene" },
  { value: "106258", label: "triclabendazole" },
  { value: "106259", label: "triclofos" },
  { value: "106260", label: "Triclofos sodium" },
  { value: "102112", label: "Triclosan" },
  { value: "1522", label: "Tridestra" },
  { value: "106261", label: "tridihexethyl" },
  { value: "1523", label: "Trifluoperazine" },
  { value: "106262", label: "Trifluopromazine" },
  { value: "106263", label: "trifluperidol" },
  { value: "106264", label: "triflupromazine" },
  { value: "106265", label: "trifluridine" },
  { value: "1524", label: "Triflusal" },
  { value: "106266", label: "Trifyba" },
  { value: "1525", label: "Trihexyphenidyl" },
  { value: "102113", label: "Trileptal" },
  { value: "102114", label: "Trilostane" },
  { value: "106267", label: "trimazosin" },
  { value: "106268", label: "Trimbow" },
  { value: "106269", label: "trimebutine" },
  { value: "106270", label: "trimegestone and estrogen" },
  { value: "106271", label: "Trimeprazine (Alimemazine)" },
  { value: "106272", label: "trimetaphan" },
  { value: "1526", label: "Trimetazidine" },
  { value: "106273", label: "trimethadione" },
  { value: "1527", label: "Trimethoprim" },
  { value: "106274", label: "trimethyldiphenylpropylamine" },
  { value: "106275", label: "trimetrexate" },
  { value: "1528", label: "Trimipramine" },
  { value: "102115", label: "Trimopan" },
  { value: "102116", label: "Trimovate" },
  { value: "102117", label: "Trintek" },
  { value: "106276", label: "trioxysalen" },
  { value: "106277", label: "tripelennamine" },
  { value: "106278", label: "tri-potassium" },
  { value: "102111", label: "Tri-potassium di-citrato bismuthate" },
  { value: "106279", label: "Tripotassium Dicitratobismuthate" },
  { value: "106280", label: "triprolidine" },
  { value: "1529", label: "Triptafen" },
  { value: "1530", label: "Triptorelin" },
  { value: "106281", label: "Trisenox" },
  { value: "1531", label: "Trisequens" },
  { value: "1532", label: "Tritace" },
  { value: "102118", label: "Tritamyl" },
  { value: "106282", label: "triticum (wheat fibre)" },
  { value: "106283", label: "tritoqualine" },
  { value: "106284", label: "Triumeq" },
  { value: "1533", label: "Trizivir" },
  { value: "106285", label: "Trobalt" },
  { value: "106286", label: "Trodelvy" },
  { value: "106287", label: "trofosfamide" },
  { value: "106288", label: "troglitazone" },
  { value: "106289", label: "troleandomycin" },
  { value: "106290", label: "trolnitrate" },
  { value: "106291", label: "trolnitrate, combinations" },
  { value: "1534", label: "Tromalyt" },
  { value: "106292", label: "tromantadine" },
  { value: "1535", label: "Trombyl" },
  { value: "106293", label: "trometamol" },
  { value: "106294", label: "tropatepine" },
  { value: "106295", label: "tropenzilone and analgesics" },
  { value: "102119", label: "Tropicamide" },
  { value: "106296", label: "tropicamide, combinations" },
  { value: "106297", label: "tropisetron" },
  { value: "1536", label: "Trospium" },
  { value: "106298", label: "trospium and analgesics" },
  { value: "102120", label: "Trospium chloride" },
  { value: "102121", label: "Trosyl" },
  { value: "106299", label: "trovafloxacin" },
  { value: "106300", label: "troxerutin" },
  { value: "106301", label: "troxerutin, combinations" },
  { value: "106302", label: "troxipide" },
  { value: "106303", label: "Trulicity" },
  { value: "102122", label: "Trusopt" },
  { value: "1537", label: "Truvada" },
  { value: "106304", label: "truxima" },
  { value: "106305", label: "trypsin" },
  { value: "106306", label: "trypsin, combinations" },
  { value: "1538", label: "Tryptizol" },
  { value: "102123", label: "Tryptophan" },
  { value: "106307", label: "tuaminoheptane" },
  { value: "106308", label: "tuberculin" },
  { value: "106309", label: "tuberculosis, live attenuated" },
  { value: "106310", label: "tubocurarine" },
  { value: "106311", label: "Tucatinib" },
  { value: "102124", label: "Tuinal" },
  { value: "106312", label: "Tukysa" },
  { value: "106313", label: "Tulip" },
  { value: "106314", label: "tulobuterol" },
  { value: "106315", label: "T-Vec" },
  { value: "106316", label: "twinrix" },
  { value: "102125", label: "Twinrix Adult" },
  { value: "106317", label: "Tybost" },
  { value: "102126", label: "Tygacil" },
  { value: "1539", label: "Tylex" },
  { value: "106318", label: "tyloxapol" },
  { value: "106319", label: "tymazoline" },
  { value: "102127", label: "Typherix" },
  { value: "106320", label: "typhim" },
  { value: "102128", label: "Typhim Vi" },
  { value: "102129", label: "Typhoid" },
  { value: "106321", label: "typhoid, combinations with paratyphi types" },
  { value: "106322", label: "typhoid, inactivated, whole cell" },
  { value: "106323", label: "typhoid, oral, live attenuated" },
  { value: "106324", label: "typhoid, purified polysaccharide antigen" },
  { value: "106325", label: "typhoid-hepatitis A" },
  { value: "106326", label: "typhus exanthematicus, inactivated, whole cell" },
  { value: "102130", label: "TYR Anamix Junior" },
  { value: "102131", label: "TYR Express" },
  { value: "106327", label: "tyropanoic acid" },
  { value: "102132", label: "Tyrosine" },
  { value: "102133", label: "Tyrosine AA Supplement" },
  { value: "106328", label: "tyrothricin" },
  { value: "102134", label: "Tysabri" },
  { value: "1540", label: "Tyverb" },
  { value: "106329", label: "ubidecarenone" },
  { value: "102135", label: "Ubretid" },
  { value: "1541", label: "Ucerax" },
  { value: "106330", label: "ucerax syrup" },
  { value: "102136", label: "Uftoral" },
  { value: "106331", label: "ulipristal" },
  { value: "106332", label: "ulobetasol" },
  { value: "106333", label: "Ultibro Breezhaler" },
  { value: "102137", label: "Ultimate" },
  { value: "102138", label: "Ultiva" },
  { value: "106334", label: "Ultomiris" },
  { value: "102139", label: "Ultra" },
  { value: "102140", label: "Ultra GF" },
  { value: "102141", label: "Ultra PKU" },
  { value: "102142", label: "Ultrabase" },
  { value: "102143", label: "Ultralanum" },
  { value: "102144", label: "Ultraproct" },
  { value: "106335", label: "Umeclidinium" },
  { value: "106336", label: "umeclidinium bromide" },
  { value: "106337", label: "undecenoic" },
  { value: "102145", label: "Undecenoic Acid" },
  { value: "106338", label: "undecylenic acid" },
  { value: "106339", label: "undecylenic acid, combinations" },
  { value: "106340", label: "unguentum" },
  { value: "102146", label: "Unguentum M" },
  { value: "106341", label: "uniphyllin" },
  { value: "1542", label: "Uniphyllin Continus" },
  { value: "106342", label: "uniroid" },
  { value: "102147", label: "Uniroid HC" },
  { value: "102148", label: "Unisept" },
  { value: "1543", label: "Univer" },
  { value: "106343", label: "unoprostone" },
  { value: "106344", label: "unrecognised" },
  { value: "106345", label: "upadacitinib" },
  { value: "102149", label: "Uracil" },
  { value: "106346", label: "urapidil" },
  { value: "106347", label: "urate oxidase" },
  { value: "102150", label: "Urdox" },
  { value: "102151", label: "Urea" },
  { value: "102152", label: "Urea Hydrogen Peroxide" },
  { value: "102153", label: "Uriben" },
  { value: "106348", label: "uricto" },
  { value: "106349", label: "uriflex" },
  { value: "102154", label: "Uriflex G" },
  { value: "102155", label: "Urispas" },
  { value: "102156", label: "Urofollitropin" },
  { value: "102157", label: "Urokinase" },
  { value: "106350", label: "ursodeoxycholic" },
  { value: "1544", label: "Ursodeoxycholic Acid" },
  { value: "1545", label: "Ursofalk" },
  { value: "102158", label: "Ursogal" },
  { value: "102159", label: "Ustekinumab" },
  { value: "102160", label: "Utinor" },
  { value: "102161", label: "Utovlan" },
  { value: "102162", label: "Utrogestan" },
  { value: "106351", label: "uvistat" },
  { value: "102163", label: "Uvistat SPF30" },
  { value: "106352", label: "Vabysmo" },
  { value: "106353", label: "vaccinia immunoglobulin" },
  { value: "1546", label: "Vagifem" },
  { value: "106354", label: "vaginal ring with progestogen and estrogen" },
  { value: "1547", label: "Valaciclovir" },
  { value: "102164", label: "Valclair" },
  { value: "102165", label: "Valcyte" },
  { value: "106355", label: "valdecoxib" },
  { value: "102166", label: "Valdoxan" },
  { value: "106356", label: "valerian" },
  { value: "106357", label: "valethamate" },
  { value: "102167", label: "Valganciclovir" },
  { value: "106358", label: "Valganciclovir Hydrochloride" },
  { value: "102168", label: "Valine" },
  { value: "102169", label: "Valine AA Supplement" },
  { value: "1548", label: "Valium" },
  { value: "106359", label: "valni" },
  { value: "102170", label: "Valni XL" },
  { value: "106360", label: "valnoctamide" },
  { value: "102171", label: "Valoid" },
  { value: "106361", label: "valoid injection" },
  { value: "1549", label: "Valproate" },
  { value: "106362", label: "valproic" },
  { value: "1550", label: "Valproic Acid" },
  { value: "106363", label: "valpromide" },
  { value: "106364", label: "valrubicin" },
  { value: "1551", label: "Valsartan" },
  { value: "1552", label: "Valtrex" },
  { value: "102172", label: "Vancocin" },
  { value: "102173", label: "Vancomycin" },
  { value: "106365", label: "vandetanib" },
  { value: "102174", label: "Vaniqa" },
  { value: "102175", label: "Vantas" },
  { value: "106366", label: "vapreotide" },
  { value: "106367", label: "vaqta" },
  { value: "102176", label: "Vaqta Paediatric" },
  { value: "106368", label: "varbim" },
  { value: "1553", label: "Varbim XL" },
  { value: "1554", label: "Vardenafil" },
  { value: "1555", label: "Varenicline" },
  { value: "106369", label: "Vargatef" },
  { value: "106370", label: "varicella" },
  { value: "102177", label: "Varicella zoster vaccine" },
  { value: "106371", label: "varicella, live attenuated" },
  { value: "106372", label: "varicella/zoster immunoglobulin" },
  { value: "102178", label: "Varilrix" },
  { value: "106373", label: "various" },
  { value: "106374", label: "various combinations" },
  { value: "102179", label: "Varivax" },
  { value: "102180", label: "Vascace" },
  { value: "1556", label: "Vascalpha" },
  { value: "102181", label: "Vasodilator - Other" },
  { value: "102182", label: "Vasogen" },
  { value: "106375", label: "vasopressin" },
  { value: "1557", label: "Vastarel" },
  { value: "106376", label: "Vastatin" },
  { value: "102183", label: "Vectavir" },
  { value: "102184", label: "Vectibix" },
  { value: "102185", label: "Vecuronium" },
  { value: "106377", label: "vedolizumab" },
  { value: "106378", label: "vegenat-med" },
  { value: "102186", label: "Vegenat-Med High Protein" },
  { value: "102187", label: "Veil" },
  { value: "106379", label: "velaglucerase alfa" },
  { value: "102188", label: "Velbe" },
  { value: "1558", label: "Velcade" },
  { value: "106380", label: "Veletri" },
  { value: "1559", label: "Velosef" },
  { value: "102189", label: "Velosulin" },
  { value: "106381", label: "velpatasvir" },
  { value: "106382", label: "Velphoro" },
  { value: "106383", label: "Veltassa" },
  { value: "106384", label: "vemurafenib" },
  { value: "106385", label: "Venaxx" },
  { value: "106386", label: "Venaxx XL" },
  { value: "106387", label: "Venclyxto" },
  { value: "106388", label: "venetoclax" },
  { value: "106389", label: "venlablue" },
  { value: "106390", label: "venlablue xl" },
  { value: "1560", label: "Venlafaxine" },
  { value: "106391", label: "Venlalic" },
  { value: "1561", label: "Venlalic XL" },
  { value: "1562", label: "Venofer" },
  { value: "106392", label: "Vensir" },
  { value: "106393", label: "Vensir XL" },
  { value: "102190", label: "Ventavis" },
  { value: "106394", label: "Ventmax" },
  { value: "102191", label: "Ventmax SR" },
  { value: "1563", label: "Ventolin" },
  { value: "102192", label: "Ventolin Evohaler" },
  { value: "102193", label: "Ventolin Infusion" },
  { value: "106395", label: "ventra" },
  { value: "102194", label: "Ventricular anti-arrhythmic - Other" },
  { value: "102195", label: "Vepesid" },
  { value: "102196", label: "Veracur" },
  { value: "106396", label: "veralipride" },
  { value: "1564", label: "Verapamil" },
  { value: "106397", label: "verapamil, combinations" },
  { value: "106398", label: "verapress" },
  { value: "106399", label: "Verapress MR" },
  { value: "106400", label: "Vera-Til" },
  { value: "106401", label: "veratrum" },
  { value: "102197", label: "Vermox" },
  { value: "106402", label: "vernakalant" },
  { value: "102198", label: "Verrugon" },
  { value: "1565", label: "Versatis" },
  { value: "102199", label: "Versol" },
  { value: "106403", label: "Vertab" },
  { value: "1566", label: "Vertab SR" },
  { value: "106404", label: "Vertab SR 240" },
  { value: "102200", label: "Verteporfin" },
  { value: "106405", label: "vertine" },
  { value: "106406", label: "Verzenios" },
  { value: "102201", label: "Vesanoid" },
  { value: "1567", label: "Vesicare" },
  { value: "102202", label: "Vexol" },
  { value: "102203", label: "Vfend" },
  { value: "1568", label: "Viagra" },
  { value: "102204", label: "ViATIM" },
  { value: "106407", label: "Viazem" },
  { value: "1569", label: "Viazem XL" },
  { value: "102205", label: "Vibramycin-D" },
  { value: "102206", label: "Victanyl" },
  { value: "1570", label: "Victoza" },
  { value: "106408", label: "Victrelis" },
  { value: "106409", label: "vidarabine" },
  { value: "1571", label: "Vidaza" },
  { value: "102207", label: "Videne" },
  { value: "102208", label: "Videx" },
  { value: "106410", label: "Viekirax" },
  { value: "102209", label: "Vigabatrin" },
  { value: "102210", label: "Vigam" },
  { value: "106411", label: "vilanterol" },
  { value: "1572", label: "Vildagliptin" },
  { value: "106412", label: "vildagliptin," },
  { value: "106413", label: "vildagliptin, metformin combination" },
  { value: "106414", label: "viloxazine" },
  { value: "106415", label: "viminol" },
  { value: "106416", label: "vimovo" },
  { value: "102211", label: "Vimpat" },
  { value: "106417", label: "vinbarbital" },
  { value: "1573", label: "Vinblastine" },
  { value: "106418", label: "vinburnine" },
  { value: "106419", label: "vincamine" },
  { value: "1574", label: "Vincristine" },
  { value: "1575", label: "Vindesine" },
  { value: "102212", label: "Vinflunine" },
  { value: "1576", label: "Vinorelbine" },
  { value: "106420", label: "vinpocetine" },
  { value: "106421", label: "vinyl ether" },
  { value: "106422", label: "vinylbital" },
  { value: "1577", label: "Vioform-Hydrocortisone" },
  { value: "1578", label: "Vioxx" },
  { value: "106423", label: "Vipdomet" },
  { value: "106424", label: "Vipida" },
  { value: "102213", label: "Vipidia" },
  { value: "102214", label: "Viracept" },
  { value: "106425", label: "Viraferon" },
  { value: "102215", label: "ViraferonPeg" },
  { value: "102216", label: "Viramune" },
  { value: "106426", label: "Virazole" },
  { value: "102217", label: "Viread" },
  { value: "102218", label: "Virgan" },
  { value: "106427", label: "virginiamycin" },
  { value: "106428", label: "viridal" },
  { value: "102219", label: "Viridal Duo" },
  { value: "102220", label: "Viroflu" },
  { value: "102221", label: "Virormone" },
  { value: "1579", label: "Visclair" },
  { value: "1580", label: "Viscotears" },
  { value: "102222", label: "Viskaldix" },
  { value: "102223", label: "Visken" },
  { value: "102224", label: "Vismed" },
  { value: "106429", label: "vismodegib" },
  { value: "106430", label: "visnadine" },
  { value: "102225", label: "Vistide" },
  { value: "102226", label: "Visudyne" },
  { value: "102227", label: "Vitalograph" },
  { value: "106431", label: "vitamin A concentrates" },
  { value: "102228", label: "Vitamin D" },
  { value: "102229", label: "Vitamin D3" },
  { value: "106432", label: "Viteka" },
  { value: "106433", label: "Vitile" },
  { value: "106434", label: "Vitile XL" },
  { value: "106435", label: "Vitrakvi" },
  { value: "106436", label: "Vivadex" },
  { value: "102230", label: "Vivaglobin" },
  { value: "1581", label: "Vivaxa" },
  { value: "106437", label: "vividrin" },
  { value: "102231", label: "Vividrin Drops" },
  { value: "102232", label: "Vividrin Spray" },
  { value: "102233", label: "Vivotif" },
  { value: "106438", label: "Vizimpro" },
  { value: "106439", label: "Vocabria" },
  { value: "106440", label: "voclosporin" },
  { value: "106441", label: "Voglib" },
  { value: "106442", label: "voglibose" },
  { value: "106443", label: "Vokanamet" },
  { value: "106444", label: "voleze" },
  { value: "102234", label: "Volibris" },
  { value: "106445", label: "volsaid" },
  { value: "1582", label: "Volsaid Retard" },
  { value: "106446", label: "voltarene" },
  { value: "1583", label: "Voltarene SR" },
  { value: "1584", label: "Voltarol" },
  { value: "102235", label: "Voltarol Emulgel" },
  { value: "106447", label: "voltarol gel" },
  { value: "102236", label: "Voltarol Ophtha" },
  { value: "102237", label: "Volumatic" },
  {
    value: "106448",
    label: "von Willebrand factor and coagulation factor VIII in combination",
  },
  { value: "106449", label: "vonoprazan" },
  { value: "102238", label: "Voriconazole" },
  { value: "106450", label: "vorinostat" },
  { value: "106451", label: "vorozole" },
  { value: "102239", label: "Vortex" },
  { value: "106452", label: "vortioxetine" },
  { value: "106453", label: "Vosevi" },
  { value: "102240", label: "Votrient" },
  { value: "106454", label: "votubia" },
  { value: "106455", label: "voxilaprevir" },
  { value: "106456", label: "vsl" },
  { value: "106457", label: "vsl 3" },
  { value: "106458", label: "Vumerity" },
  { value: "106459", label: "vyndaqel" },
  { value: "106460", label: "Vyxeos" },
  { value: "1585", label: "Warfarin" },
  { value: "102242", label: "Warticon" },
  { value: "102243", label: "Waxsol" },
  { value: "102244", label: "Welldorm" },
  { value: "102245", label: "Wellvone" },
  { value: "106461", label: "Winfex" },
  { value: "106462", label: "Winfex XL" },
  { value: "1586", label: "Wobenzyme" },
  { value: "102246", label: "Wool Fat" },
  { value: "106463", label: "Xadago" },
  { value: "102248", label: "Xagrid" },
  { value: "1587", label: "Xalacom" },
  { value: "1588", label: "Xalatan" },
  { value: "106464", label: "xaliproden" },
  { value: "106465", label: "Xalkori" },
  { value: "106466", label: "Xaluprine" },
  { value: "102249", label: "Xamiol" },
  { value: "106467", label: "xamoterol" },
  { value: "1589", label: "Xanax" },
  { value: "106468", label: "xantinol nicotinate" },
  { value: "102250", label: "Xarelto" },
  { value: "106469", label: "xatral" },
  { value: "1590", label: "Xatral XL" },
  { value: "102251", label: "Xclair" },
  { value: "106470", label: "Xelevia" },
  { value: "106471", label: "Xeljanz" },
  { value: "1591", label: "Xeloda" },
  { value: "106472", label: "Xenazine" },
  { value: "102252", label: "Xenazine 25" },
  { value: "1592", label: "Xenical" },
  { value: "106473", label: "xenon" },
  { value: "106474", label: "xenon (127Xe) gas" },
  { value: "106475", label: "xenon (133Xe) gas" },
  { value: "106476", label: "xenysalate" },
  { value: "102253", label: "Xeomin" },
  { value: "1593", label: "Xepin" },
  { value: "106477", label: "xeplion" },
  { value: "102254", label: "Xerotin" },
  { value: "106478", label: "xibornol" },
  { value: "106479", label: "Xigduo" },
  { value: "102255", label: "Xigris" },
  { value: "106480", label: "ximelagatran" },
  { value: "1594", label: "Xipamide" },
  { value: "106481", label: "Xismox" },
  { value: "1595", label: "Xismox XL" },
  { value: "106482", label: "Xofigo" },
  { value: "102256", label: "Xolair" },
  { value: "106483", label: "xomolix" },
  { value: "106484", label: "Xospata" },
  { value: "106485", label: "Xtandi" },
  { value: "106486", label: "Xultophy" },
  { value: "102257", label: "Xylitol" },
  { value: "102258", label: "Xylocaine" },
  { value: "102259", label: "Xylometazoline" },
  { value: "106487", label: "xylometazoline, combinations" },
  { value: "102260", label: "Xyloproct" },
  { value: "102261", label: "Xyrem" },
  { value: "1596", label: "Xyzal" },
  { value: "106488", label: "Yaltormin" },
  { value: "102262", label: "Yellow fever vaccine" },
  { value: "106489", label: "yellow fever, live attenuated" },
  { value: "102263", label: "Yellow Soft Paraffin" },
  { value: "102264", label: "Yentreve" },
  { value: "106490", label: "Yervoy" },
  { value: "106491", label: "Yescarta" },
  { value: "106492", label: "yohimbine" },
  { value: "102265", label: "Yondelis" },
  { value: "106493", label: "yttrium (90Y) citrate colloid" },
  { value: "106494", label: "yttrium (90Y) ferrihydroxide colloid" },
  { value: "106495", label: "yttrium (90Y) silicate colloid" },
  { value: "102266", label: "Yutopar" },
  { value: "1597", label: "Zacin" },
  { value: "102267", label: "Zaditen" },
  { value: "102268", label: "Zaditen Drops" },
  { value: "1598", label: "Zafirlukast" },
  { value: "106496", label: "Zalasta" },
  { value: "106497", label: "zalcitabine" },
  { value: "1599", label: "Zaldiar" },
  { value: "102269", label: "Zaleplon" },
  { value: "106498", label: "Zaltrap" },
  { value: "1600", label: "Zamadol" },
  { value: "102270", label: "Zamadol SR" },
  { value: "1601", label: "Zamene" },
  { value: "1602", label: "Zanaflex" },
  { value: "102271", label: "Zanamivir" },
  { value: "1603", label: "Zanidip" },
  { value: "1604", label: "Zantac" },
  { value: "106499", label: "zanubrutinib" },
  { value: "1605", label: "Zapain" },
  { value: "106500", label: "Zaponex" },
  { value: "1606", label: "Zarator" },
  { value: "102272", label: "Zarontin" },
  { value: "106501", label: "Zaroxolyn" },
  { value: "102273", label: "Zarzio" },
  { value: "102274", label: "Zavedos" },
  { value: "102275", label: "Zavesca" },
  { value: "102276", label: "Zeasorb" },
  { value: "102277", label: "Zebinix" },
  { value: "102278", label: "Zeffix" },
  { value: "106502", label: "Zejula" },
  { value: "102279", label: "Zelapar" },
  { value: "106503", label: "Zelboraf" },
  { value: "1607", label: "Zemon" },
  { value: "102280", label: "Zemplar" },
  { value: "1608", label: "Zemtard" },
  { value: "102281", label: "Zemtard XL" },
  { value: "106504", label: "Zepatier" },
  { value: "106505", label: "Zeposia" },
  { value: "102282", label: "Zerit" },
  { value: "102283", label: "Zerobase" },
  { value: "102284", label: "ZeroCream" },
  { value: "102285", label: "Zeroguent" },
  { value: "102286", label: "Zerolatum" },
  { value: "102287", label: "Zeroneum" },
  { value: "102288", label: "Zerozole" },
  { value: "106506", label: "Zessly" },
  { value: "1609", label: "Zestoretic" },
  { value: "106507", label: "zestoretic 10" },
  { value: "102289", label: "Zestoretic 20" },
  { value: "1610", label: "Zestril" },
  { value: "1611", label: "Zetia" },
  { value: "102290", label: "Ziagen" },
  { value: "102291", label: "Zibor" },
  { value: "106508", label: "Ziclaseg" },
  { value: "102292", label: "Ziconotide" },
  { value: "106509", label: "Zicron" },
  { value: "102293", label: "Zidoval" },
  { value: "1612", label: "Zidovudine" },
  { value: "106510", label: "zimbacol" },
  { value: "1613", label: "Zimbacol XL" },
  { value: "106511", label: "zimeldine" },
  { value: "102294", label: "Zimovane" },
  { value: "1614", label: "Zimstat" },
  { value: "102295", label: "Zinacef" },
  { value: "106512", label: "Zinbryta" },
  { value: "102296", label: "Zinc" },
  { value: "102297", label: "Zinc Acetate" },
  { value: "106513", label: "zinc bandage with supplements" },
  { value: "106514", label: "zinc bandage without supplements" },
  { value: "106515", label: "zinc chloride" },
  { value: "106516", label: "zinc compounds" },
  { value: "106517", label: "zinc gluconate" },
  { value: "102298", label: "Zinc Oxide" },
  { value: "106518", label: "zinc preparations" },
  { value: "106519", label: "zinc protein complex" },
  { value: "106520", label: "zinc sulfate" },
  { value: "102299", label: "Zinc sulphate" },
  { value: "102300", label: "Zindaclin" },
  { value: "102301", label: "Zineryt" },
  { value: "106521", label: "zipeprol" },
  { value: "106522", label: "ziprasidone" },
  { value: "106523", label: "zirtek" },
  { value: "102302", label: "Zirtek Allergy" },
  { value: "106524", label: "Zispin" },
  { value: "102303", label: "Zispin Soltab" },
  { value: "1615", label: "Zithromax" },
  { value: "1616", label: "Zocor" },
  { value: "106525", label: "zofenopril" },
  { value: "102304", label: "Zofran" },
  { value: "1617", label: "Zoladex" },
  { value: "102305", label: "Zoledronate" },
  { value: "106526", label: "zoledronic" },
  { value: "1618", label: "Zoledronic Acid" },
  { value: "102306", label: "Zoleptil" },
  { value: "106527", label: "zolimidine" },
  { value: "1619", label: "Zolmitriptan" },
  { value: "1620", label: "Zoloft" },
  { value: "1621", label: "Zolpidem" },
  { value: "102307", label: "Zolvera" },
  { value: "102308", label: "Zomacton" },
  { value: "106528", label: "zomepirac" },
  { value: "1622", label: "Zometa" },
  { value: "102309", label: "Zomig" },
  { value: "1623", label: "Zomorph" },
  { value: "1624", label: "Zonegran" },
  { value: "1625", label: "Zonisamide" },
  { value: "1626", label: "Zopiclone" },
  { value: "102310", label: "Zorac" },
  { value: "1627", label: "Zortress" },
  { value: "106529", label: "zorubicin" },
  { value: "106530", label: "zoster, live attenuated" },
  { value: "102311", label: "Zotepine" },
  { value: "1628", label: "Zoton" },
  { value: "102312", label: "Zoton FasTab" },
  { value: "102313", label: "Zovirax" },
  { value: "102314", label: "Zovirax Eye Ointment" },
  { value: "1629", label: "Zoxan" },
  { value: "106531", label: "zucapsaicin" },
  { value: "106532", label: "Zuclopenth Decan" },
  { value: "1630", label: "Zuclopenthixol" },
  { value: "1631", label: "Zumenon" },
  { value: "1632", label: "Zyban" },
  { value: "106533", label: "Zydelig" },
  { value: "1633", label: "Zydol" },
  { value: "102315", label: "Zydol SR" },
  { value: "106534", label: "Zykadia" },
  { value: "1634", label: "Zyloric" },
  { value: "106535", label: "Zynquista" },
  { value: "102316", label: "Zyomet" },
  { value: "102317", label: "Zypadhera" },
  { value: "1635", label: "Zyprexa" },
  { value: "106536", label: "Zytanix" },
  { value: "106537", label: "Zytiga" },
  { value: "106538", label: "zyvox" },
  { value: "102318", label: "Zyvox Tablets" },
];

export const groupedOptions: IGroupedOption[] = [
  {
    label: "Medications",
    groupValue: "medicaitons",
    options: allMedications,
  },
];
